var _linearGradient;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSpringBreak(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 662.457,
    height: 428.954,
    viewBox: "0 0 175.275 113.494",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("defs", null, _linearGradient || (_linearGradient = /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#a",
    id: "b",
    x1: 212.747,
    x2: -73.381,
    y1: 296.28,
    y2: -96.104,
    gradientTransform: "matrix(.81183 0 0 .2031 7.527 336.883)",
    gradientUnits: "userSpaceOnUse"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "a"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#d6fdff",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#d6fdff",
      stopOpacity: 0.36000001
    }
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M7.527 283.71v113.495h175.276V283.71z",
    style: {
      fill: "#fff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 3.87204337,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1,
      paintOrder: "normal"
    },
    transform: "translate(-7.527 -283.71)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.527 283.71v113.495h175.276V283.71z",
    style: {
      fill: "url(#b)",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 3.87204337,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1,
      paintOrder: "normal"
    },
    transform: "translate(-7.527 -283.71)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M171.828 322.825c2.05 6.881 7.208 20.524 4.81 26.848a3.5 3.5 0 0 1-.618 1.047c-.25.283-.552.502-.856.623-.497.198-1.283.198-2.289.29-2.995.278-5.755 1.792-7.719 4.003-1.956 2.203-3.089 5.02-3.39 7.898-.3 2.872.211 5.763 1.281 8.387 1.068 2.62 2.678 4.965 4.566 6.998a28.2 28.2 0 0 0 7.13 5.545l1.228-2.252a25.6 25.6 0 0 1-6.479-5.037c-1.713-1.845-3.14-3.942-4.07-6.223-.928-2.277-1.356-4.758-1.105-7.15.25-2.386 1.2-4.709 2.757-6.463 1.552-1.747 3.762-2.94 6.037-3.15.776-.072 1.84 0 3.004-.465a4.8 4.8 0 0 0 1.829-1.309 6.1 6.1 0 0 0 1.082-1.807c.495-1.264.592-2.54.636-3.695.33-8.626-2.493-17.305-7.834-24.088",
    style: {
      color: "#000",
      fontStyle: "normal",
      fontVariant: "normal",
      fontWeight: 400,
      fontStretch: "normal",
      fontSize: "medium",
      lineHeight: "normal",
      fontFamily: "sans-serif",
      fontVariantLigatures: "normal",
      fontVariantPosition: "normal",
      fontVariantCaps: "normal",
      fontVariantNumeric: "normal",
      fontVariantAlternates: "normal",
      fontFeatureSettings: "normal",
      textIndent: 0,
      textAlign: "start",
      textDecoration: "none",
      textDecorationLine: "none",
      textDecorationStyle: "solid",
      textDecorationColor: "#000",
      letterSpacing: "normal",
      wordSpacing: "normal",
      textTransform: "none",
      writingMode: "lr-tb",
      direction: "ltr",
      textOrientation: "mixed",
      dominantBaseline: "auto",
      baselineShift: "baseline",
      textAnchor: "start",
      whiteSpace: "normal",
      shapePadding: 0,
      clipRule: "nonzero",
      display: "inline",
      overflow: "visible",
      visibility: "visible",
      opacity: 1,
      isolation: "auto",
      mixBlendMode: "normal",
      colorInterpolation: "sRGB",
      colorInterpolationFilters: "linearRGB",
      solidColor: "#000",
      solidOpacity: 1,
      vectorEffect: "none",
      fill: "#542600",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 2.56500006,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1,
      colorRendering: "auto",
      imageRendering: "auto",
      shapeRendering: "auto",
      textRendering: "auto"
    },
    transform: "translate(-7.527 -283.71)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.543 395.278a2.5 2.5 0 0 0 2.188-2.774c-.083-.698-.494-1.694-1.057-2.482a2.07 2.07 0 0 1-1.616 1.149 2.07 2.07 0 0 1-1.84-.74c-.364.898-.532 1.961-.45 2.659a2.5 2.5 0 0 0 2.775 2.188M32.368 375.389a2.5 2.5 0 0 0-2.917-1.994c-.69.13-1.656.607-2.404 1.223a2.07 2.07 0 0 1 1.257 1.534 2.07 2.07 0 0 1-.612 1.887c.92.302 1.991.396 2.682.267a2.5 2.5 0 0 0 1.994-2.917M21.791 383.964a2.5 2.5 0 0 0-2.917-1.994c-.69.13-1.656.607-2.404 1.224a2.07 2.07 0 0 1 1.257 1.533 2.07 2.07 0 0 1-.612 1.887c.92.302 1.991.396 2.682.267a2.5 2.5 0 0 0 1.994-2.917M20.486 364.279a2.5 2.5 0 0 0 3.364-1.081c.321-.625.536-1.68.508-2.65a2.07 2.07 0 0 1-1.982.052 2.07 2.07 0 0 1-1.115-1.64c-.803.542-1.535 1.33-1.856 1.955a2.5 2.5 0 0 0 1.081 3.364M13.385 343.906a2.5 2.5 0 0 0 2.496 2.5c.703.001 1.74-.29 2.59-.756a2.07 2.07 0 0 1-.95-1.74 2.07 2.07 0 0 1 .95-1.74c-.848-.468-1.883-.76-2.585-.76a2.5 2.5 0 0 0-2.501 2.496M38.909 352.7a2.5 2.5 0 0 0-1.308-3.283c-.646-.277-1.713-.42-2.678-.326a2.07 2.07 0 0 1 .187 1.974 2.07 2.07 0 0 1-1.56 1.224c.595.764 1.43 1.44 2.076 1.718a2.5 2.5 0 0 0 3.283-1.307M70.153 390.78a2.5 2.5 0 0 0 3.467.682c.584-.392 1.282-1.211 1.727-2.072a2.07 2.07 0 0 1-1.76-.914 2.07 2.07 0 0 1-.181-1.975c-.965.085-1.987.421-2.57.812a2.5 2.5 0 0 0-.683 3.467M96.24 383.834a2.5 2.5 0 0 0-2.916-1.994c-.691.13-1.656.608-2.405 1.224a2.07 2.07 0 0 1 1.257 1.533 2.07 2.07 0 0 1-.612 1.887c.92.302 1.992.396 2.682.267a2.5 2.5 0 0 0 1.994-2.917M85.663 392.41a2.5 2.5 0 0 0-2.916-1.995c-.691.13-1.656.608-2.405 1.224a2.07 2.07 0 0 1 1.257 1.534 2.07 2.07 0 0 1-.612 1.886c.92.302 1.992.397 2.682.267a2.5 2.5 0 0 0 1.994-2.917M70.978 379.315a2.5 2.5 0 0 0 .143-3.53c-.477-.517-1.394-1.082-2.313-1.39a2.07 2.07 0 0 1-.633 1.88 2.07 2.07 0 0 1-1.924.482c.232.94.72 1.899 1.197 2.415a2.5 2.5 0 0 0 3.53.143M49.406 378.97a2.5 2.5 0 0 0 3.207-1.483c.242-.66.327-1.733.181-2.691a2.07 2.07 0 0 1-1.961.293 2.07 2.07 0 0 1-1.306-1.492c-.731.636-1.362 1.507-1.604 2.166a2.5 2.5 0 0 0 1.483 3.208M66.447 358.033a2.5 2.5 0 0 0-3.532.098c-.483.51-.984 1.464-1.228 2.402a2.07 2.07 0 0 1 1.918.504 2.07 2.07 0 0 1 .612 1.886c.922-.295 1.845-.848 2.328-1.358a2.5 2.5 0 0 0-.098-3.532M84.359 372.724a2.5 2.5 0 0 0 3.363-1.08c.321-.626.536-1.681.508-2.65a2.07 2.07 0 0 1-1.982.051 2.07 2.07 0 0 1-1.115-1.64c-.803.542-1.534 1.33-1.855 1.955a2.5 2.5 0 0 0 1.08 3.364M77.257 352.351a2.5 2.5 0 0 0 2.496 2.5c.703.001 1.74-.289 2.59-.755a2.07 2.07 0 0 1-.95-1.74 2.07 2.07 0 0 1 .951-1.74c-.848-.468-1.884-.76-2.586-.76a2.5 2.5 0 0 0-2.501 2.495M102.78 361.145a2.5 2.5 0 0 0-1.307-3.282c-.646-.278-1.713-.42-2.678-.327a2.07 2.07 0 0 1 .187 1.974 2.07 2.07 0 0 1-1.56 1.224c.595.764 1.431 1.44 2.076 1.718a2.5 2.5 0 0 0 3.283-1.307M111.408 386.827a2.5 2.5 0 0 0-3.532.098c-.483.51-.984 1.464-1.228 2.402a2.07 2.07 0 0 1 1.918.504 2.07 2.07 0 0 1 .611 1.887c.923-.296 1.846-.848 2.329-1.359a2.5 2.5 0 0 0-.098-3.532M122.218 381.146a2.5 2.5 0 0 0 2.496 2.5c.703 0 1.74-.29 2.59-.756a2.07 2.07 0 0 1-.95-1.74 2.07 2.07 0 0 1 .95-1.74c-.848-.468-1.883-.76-2.585-.76a2.5 2.5 0 0 0-2.501 2.496M147.742 389.94a2.5 2.5 0 0 0-1.308-3.283c-.646-.278-1.713-.42-2.678-.327a2.07 2.07 0 0 1 .187 1.974 2.07 2.07 0 0 1-1.56 1.224c.594.764 1.43 1.44 2.076 1.719a2.5 2.5 0 0 0 3.283-1.308",
    style: {
      fill: "#ffdcec",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 1.628438,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1,
      paintOrder: "normal"
    },
    transform: "translate(-7.527 -283.71)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M123.484 295.952c-.715 4.508-1.657 9.537.362 13.631 1.754 3.56 4.375 6.5 7.07 9.158 2.693 2.656 5.493 5.079 7.873 7.776 5.173 5.86 8.57 13.36 9.108 21.103a32.5 32.5 0 0 1-.182 6.346l2.744.348c.29-2.282.355-4.59.195-6.885 2.014-8.278-2.4-15.65-7.948-21.937-2.545-2.884-7.24-6.149-9.846-8.72-2.605-2.568-3.91-3.31-7.337-7.514-2.936-4.691-.732-9.566-2.04-13.306",
    style: {
      color: "#000",
      fontStyle: "normal",
      fontVariant: "normal",
      fontWeight: 400,
      fontStretch: "normal",
      fontSize: "medium",
      lineHeight: "normal",
      fontFamily: "sans-serif",
      fontVariantLigatures: "normal",
      fontVariantPosition: "normal",
      fontVariantCaps: "normal",
      fontVariantNumeric: "normal",
      fontVariantAlternates: "normal",
      fontFeatureSettings: "normal",
      textIndent: 0,
      textAlign: "start",
      textDecoration: "none",
      textDecorationLine: "none",
      textDecorationStyle: "solid",
      textDecorationColor: "#000",
      letterSpacing: "normal",
      wordSpacing: "normal",
      textTransform: "none",
      writingMode: "lr-tb",
      direction: "ltr",
      textOrientation: "mixed",
      dominantBaseline: "auto",
      baselineShift: "baseline",
      textAnchor: "start",
      whiteSpace: "normal",
      shapePadding: 0,
      clipRule: "nonzero",
      display: "inline",
      overflow: "visible",
      visibility: "visible",
      opacity: 1,
      isolation: "auto",
      mixBlendMode: "normal",
      colorInterpolation: "sRGB",
      colorInterpolationFilters: "linearRGB",
      solidColor: "#000",
      solidOpacity: 1,
      vectorEffect: "none",
      fill: "#542600",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 2.76500034,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1,
      colorRendering: "auto",
      imageRendering: "auto",
      shapeRendering: "auto",
      textRendering: "auto"
    },
    transform: "translate(-7.527 -283.71)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.436 318.892a49.1 49.1 0 0 0 12.226 25.33c5.535 6.047 12.005 10.201 17.727 14.185 18.144 12.634 34.945 27.425 43.07 46.334 5.302 12.337 6.77 26.409 4.13 39.575l12.907 2.587c3.177-15.84 1.437-32.516-4.941-47.359-9.711-22.599-31.926-32.52-50.857-45.703-5.931-4.13-11.864-7.939-18.75-12.46-4.031-3.19-8.064-10.855-15.512-22.49",
    style: {
      color: "#000",
      fontStyle: "normal",
      fontVariant: "normal",
      fontWeight: 400,
      fontStretch: "normal",
      fontSize: "medium",
      lineHeight: "normal",
      fontFamily: "sans-serif",
      fontVariantLigatures: "normal",
      fontVariantPosition: "normal",
      fontVariantCaps: "normal",
      fontVariantNumeric: "normal",
      fontVariantAlternates: "normal",
      fontFeatureSettings: "normal",
      textIndent: 0,
      textAlign: "start",
      textDecoration: "none",
      textDecorationLine: "none",
      textDecorationStyle: "solid",
      textDecorationColor: "#000",
      letterSpacing: "normal",
      wordSpacing: "normal",
      textTransform: "none",
      writingMode: "lr-tb",
      direction: "ltr",
      textOrientation: "mixed",
      dominantBaseline: "auto",
      baselineShift: "baseline",
      textAnchor: "start",
      whiteSpace: "normal",
      shapePadding: 0,
      clipRule: "nonzero",
      display: "inline",
      overflow: "visible",
      visibility: "visible",
      opacity: 1,
      isolation: "auto",
      mixBlendMode: "normal",
      colorInterpolation: "sRGB",
      colorInterpolationFilters: "linearRGB",
      solidColor: "#000",
      solidOpacity: 1,
      vectorEffect: "none",
      fill: "#542600",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 13.16499996,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1,
      colorRendering: "auto",
      imageRendering: "auto",
      shapeRendering: "auto",
      textRendering: "auto"
    },
    transform: "translate(-7.527 -283.71)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M160.797 322.704c-.928 3.675.29 4.576-.937 8.166-.796 1.838-1.854 3.03-2.96 4.522-1.421 1.92-3.918 3.502-6.066 6.047-3.286 3.893-4.449 9.123-3.812 14.013.632 4.857 2.926 9.274 5.937 12.914 6.26 7.567 15.09 11.706 21.918 17.373 7.149 5.934 12.654 13.865 15.713 22.637s3.679 18.408 1.77 27.5l3.978.836a55.77 55.77 0 0 0-1.91-29.674 55.77 55.77 0 0 0-16.955-24.426c-7.366-6.113-15.883-10.19-21.381-16.837-2.625-3.173-4.532-6.937-5.041-10.848-.505-3.878.474-8.004 2.89-10.867 1.596-1.89 4.195-3.504 6.227-6.248a13.5 13.5 0 0 0 2.633-7.457 13.5 13.5 0 0 0-2.004-7.65",
    style: {
      color: "#000",
      fontStyle: "normal",
      fontVariant: "normal",
      fontWeight: 400,
      fontStretch: "normal",
      fontSize: "medium",
      lineHeight: "normal",
      fontFamily: "sans-serif",
      fontVariantLigatures: "normal",
      fontVariantPosition: "normal",
      fontVariantCaps: "normal",
      fontVariantNumeric: "normal",
      fontVariantAlternates: "normal",
      fontFeatureSettings: "normal",
      textIndent: 0,
      textAlign: "start",
      textDecoration: "none",
      textDecorationLine: "none",
      textDecorationStyle: "solid",
      textDecorationColor: "#000",
      letterSpacing: "normal",
      wordSpacing: "normal",
      textTransform: "none",
      writingMode: "lr-tb",
      direction: "ltr",
      textOrientation: "mixed",
      dominantBaseline: "auto",
      baselineShift: "baseline",
      textAnchor: "start",
      whiteSpace: "normal",
      shapePadding: 0,
      clipRule: "nonzero",
      display: "inline",
      overflow: "visible",
      visibility: "visible",
      opacity: 1,
      isolation: "auto",
      mixBlendMode: "normal",
      colorInterpolation: "sRGB",
      colorInterpolationFilters: "linearRGB",
      solidColor: "#000",
      solidOpacity: 1,
      vectorEffect: "none",
      fill: "#542600",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 4.06500006,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1,
      colorRendering: "auto",
      imageRendering: "auto",
      shapeRendering: "auto",
      textRendering: "auto"
    },
    transform: "translate(-7.527 -283.71)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(.4006 0 0 .4006 -7.413 -18.3)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M258.725 156.021c0 3.444-2.793 10.112-6.237 10.112s-6.237-6.668-6.237-10.112a6.237 6.237 0 1 1 12.474 0",
    style: {
      fill: "#ffdcec",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 4.06500006,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1,
      paintOrder: "normal"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M263.041 168.904c-3.327.892-10.49-.08-11.382-3.407s4.827-7.75 8.154-8.641a6.237 6.237 0 1 1 3.228 12.048",
    style: {
      fill: "#ffdcec",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 4.06500006,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1,
      paintOrder: "normal"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M251.714 176.408c-1.722-2.983-2.638-10.153.345-11.876s8.735 2.656 10.457 5.64a6.237 6.237 0 1 1-10.802 6.236",
    style: {
      fill: "#ffdcec",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 4.06500006,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1,
      paintOrder: "normal"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M241.534 167.41c2.436-2.436 9.125-5.177 11.56-2.741s-.304 9.124-2.74 11.56a6.237 6.237 0 1 1-8.82-8.82",
    style: {
      fill: "#ffdcec",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 4.06500006,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1,
      paintOrder: "normal"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M247.592 155.247c2.983 1.722 7.361 7.474 5.639 10.457s-8.893 2.067-11.876.345a6.237 6.237 0 0 1 6.237-10.802",
    style: {
      fill: "#ffdcec",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 4.06500006,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1,
      paintOrder: "normal"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M247.592 155.247c2.983 1.722 7.361 7.474 5.639 10.457s-8.893 2.067-11.876.345a6.237 6.237 0 0 1 6.237-10.802",
    style: {
      fill: "#ffdcec",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 4.06500006,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1,
      paintOrder: "normal"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 252.488,
    cy: 165.275,
    r: 5.168,
    style: {
      fill: "#ff83ba",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 3.36817837,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1,
      paintOrder: "normal"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(.4006 0 0 .4006 2.226 -12.442)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M258.725 156.021c0 3.444-2.793 10.112-6.237 10.112s-6.237-6.668-6.237-10.112a6.237 6.237 0 1 1 12.474 0",
    style: {
      fill: "#ffdcec",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 4.06500006,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1,
      paintOrder: "normal"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M263.041 168.904c-3.327.892-10.49-.08-11.382-3.407s4.827-7.75 8.154-8.641a6.237 6.237 0 1 1 3.228 12.048",
    style: {
      fill: "#ffdcec",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 4.06500006,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1,
      paintOrder: "normal"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M251.714 176.408c-1.722-2.983-2.638-10.153.345-11.876s8.735 2.656 10.457 5.64a6.237 6.237 0 1 1-10.802 6.236",
    style: {
      fill: "#ffdcec",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 4.06500006,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1,
      paintOrder: "normal"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M241.534 167.41c2.436-2.436 9.125-5.177 11.56-2.741s-.304 9.124-2.74 11.56a6.237 6.237 0 1 1-8.82-8.82",
    style: {
      fill: "#ffdcec",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 4.06500006,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1,
      paintOrder: "normal"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M247.592 155.247c2.983 1.722 7.361 7.474 5.639 10.457s-8.893 2.067-11.876.345a6.237 6.237 0 0 1 6.237-10.802",
    style: {
      fill: "#ffdcec",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 4.06500006,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1,
      paintOrder: "normal"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M247.592 155.247c2.983 1.722 7.361 7.474 5.639 10.457s-8.893 2.067-11.876.345a6.237 6.237 0 0 1 6.237-10.802",
    style: {
      fill: "#ffdcec",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 4.06500006,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1,
      paintOrder: "normal"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 252.488,
    cy: 165.275,
    r: 5.168,
    style: {
      fill: "#ff83ba",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 3.36817837,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1,
      paintOrder: "normal"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(.4006 0 0 .4006 4.579 -31.856)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M258.725 156.021c0 3.444-2.793 10.112-6.237 10.112s-6.237-6.668-6.237-10.112a6.237 6.237 0 1 1 12.474 0",
    style: {
      fill: "#ffdcec",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 4.06500006,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1,
      paintOrder: "normal"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M263.041 168.904c-3.327.892-10.49-.08-11.382-3.407s4.827-7.75 8.154-8.641a6.237 6.237 0 1 1 3.228 12.048",
    style: {
      fill: "#ffdcec",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 4.06500006,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1,
      paintOrder: "normal"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M251.714 176.408c-1.722-2.983-2.638-10.153.345-11.876s8.735 2.656 10.457 5.64a6.237 6.237 0 1 1-10.802 6.236",
    style: {
      fill: "#ffdcec",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 4.06500006,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1,
      paintOrder: "normal"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M241.534 167.41c2.436-2.436 9.125-5.177 11.56-2.741s-.304 9.124-2.74 11.56a6.237 6.237 0 1 1-8.82-8.82",
    style: {
      fill: "#ffdcec",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 4.06500006,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1,
      paintOrder: "normal"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M247.592 155.247c2.983 1.722 7.361 7.474 5.639 10.457s-8.893 2.067-11.876.345a6.237 6.237 0 0 1 6.237-10.802",
    style: {
      fill: "#ffdcec",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 4.06500006,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1,
      paintOrder: "normal"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M247.592 155.247c2.983 1.722 7.361 7.474 5.639 10.457s-8.893 2.067-11.876.345a6.237 6.237 0 0 1 6.237-10.802",
    style: {
      fill: "#ffdcec",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 4.06500006,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1,
      paintOrder: "normal"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 252.488,
    cy: 165.275,
    r: 5.168,
    style: {
      fill: "#ff83ba",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 3.36817837,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1,
      paintOrder: "normal"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(.4006 0 0 .4006 6.761 9.103)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M258.725 156.021c0 3.444-2.793 10.112-6.237 10.112s-6.237-6.668-6.237-10.112a6.237 6.237 0 1 1 12.474 0",
    style: {
      fill: "#ffdcec",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 4.06500006,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1,
      paintOrder: "normal"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M263.041 168.904c-3.327.892-10.49-.08-11.382-3.407s4.827-7.75 8.154-8.641a6.237 6.237 0 1 1 3.228 12.048",
    style: {
      fill: "#ffdcec",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 4.06500006,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1,
      paintOrder: "normal"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M251.714 176.408c-1.722-2.983-2.638-10.153.345-11.876s8.735 2.656 10.457 5.64a6.237 6.237 0 1 1-10.802 6.236",
    style: {
      fill: "#ffdcec",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 4.06500006,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1,
      paintOrder: "normal"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M241.534 167.41c2.436-2.436 9.125-5.177 11.56-2.741s-.304 9.124-2.74 11.56a6.237 6.237 0 1 1-8.82-8.82",
    style: {
      fill: "#ffdcec",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 4.06500006,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1,
      paintOrder: "normal"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M247.592 155.247c2.983 1.722 7.361 7.474 5.639 10.457s-8.893 2.067-11.876.345a6.237 6.237 0 0 1 6.237-10.802",
    style: {
      fill: "#ffdcec",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 4.06500006,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1,
      paintOrder: "normal"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M247.592 155.247c2.983 1.722 7.361 7.474 5.639 10.457s-8.893 2.067-11.876.345a6.237 6.237 0 0 1 6.237-10.802",
    style: {
      fill: "#ffdcec",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 4.06500006,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1,
      paintOrder: "normal"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 252.488,
    cy: 165.275,
    r: 5.168,
    style: {
      fill: "#ff83ba",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 3.36817837,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1,
      paintOrder: "normal"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(.4006 0 0 .4006 18.668 5.134)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M258.725 156.021c0 3.444-2.793 10.112-6.237 10.112s-6.237-6.668-6.237-10.112a6.237 6.237 0 1 1 12.474 0",
    style: {
      fill: "#ffdcec",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 4.06500006,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1,
      paintOrder: "normal"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M263.041 168.904c-3.327.892-10.49-.08-11.382-3.407s4.827-7.75 8.154-8.641a6.237 6.237 0 1 1 3.228 12.048",
    style: {
      fill: "#ffdcec",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 4.06500006,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1,
      paintOrder: "normal"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M251.714 176.408c-1.722-2.983-2.638-10.153.345-11.876s8.735 2.656 10.457 5.64a6.237 6.237 0 1 1-10.802 6.236",
    style: {
      fill: "#ffdcec",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 4.06500006,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1,
      paintOrder: "normal"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M241.534 167.41c2.436-2.436 9.125-5.177 11.56-2.741s-.304 9.124-2.74 11.56a6.237 6.237 0 1 1-8.82-8.82",
    style: {
      fill: "#ffdcec",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 4.06500006,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1,
      paintOrder: "normal"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M247.592 155.247c2.983 1.722 7.361 7.474 5.639 10.457s-8.893 2.067-11.876.345a6.237 6.237 0 0 1 6.237-10.802",
    style: {
      fill: "#ffdcec",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 4.06500006,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1,
      paintOrder: "normal"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M247.592 155.247c2.983 1.722 7.361 7.474 5.639 10.457s-8.893 2.067-11.876.345a6.237 6.237 0 0 1 6.237-10.802",
    style: {
      fill: "#ffdcec",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 4.06500006,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1,
      paintOrder: "normal"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 252.488,
    cy: 165.275,
    r: 5.168,
    style: {
      fill: "#ff83ba",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 3.36817837,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1,
      paintOrder: "normal"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(.4006 0 0 .4006 36.14 16.524)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M258.725 156.021c0 3.444-2.793 10.112-6.237 10.112s-6.237-6.668-6.237-10.112a6.237 6.237 0 1 1 12.474 0",
    style: {
      fill: "#ffdcec",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 4.06500006,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1,
      paintOrder: "normal"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M263.041 168.904c-3.327.892-10.49-.08-11.382-3.407s4.827-7.75 8.154-8.641a6.237 6.237 0 1 1 3.228 12.048",
    style: {
      fill: "#ffdcec",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 4.06500006,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1,
      paintOrder: "normal"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M251.714 176.408c-1.722-2.983-2.638-10.153.345-11.876s8.735 2.656 10.457 5.64a6.237 6.237 0 1 1-10.802 6.236",
    style: {
      fill: "#ffdcec",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 4.06500006,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1,
      paintOrder: "normal"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M241.534 167.41c2.436-2.436 9.125-5.177 11.56-2.741s-.304 9.124-2.74 11.56a6.237 6.237 0 1 1-8.82-8.82",
    style: {
      fill: "#ffdcec",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 4.06500006,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1,
      paintOrder: "normal"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M247.592 155.247c2.983 1.722 7.361 7.474 5.639 10.457s-8.893 2.067-11.876.345a6.237 6.237 0 0 1 6.237-10.802",
    style: {
      fill: "#ffdcec",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 4.06500006,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1,
      paintOrder: "normal"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M247.592 155.247c2.983 1.722 7.361 7.474 5.639 10.457s-8.893 2.067-11.876.345a6.237 6.237 0 0 1 6.237-10.802",
    style: {
      fill: "#ffdcec",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 4.06500006,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1,
      paintOrder: "normal"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 252.488,
    cy: 165.275,
    r: 5.168,
    style: {
      fill: "#ff83ba",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 3.36817837,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1,
      paintOrder: "normal"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(.4006 0 0 .4006 49.18 -24.297)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M258.725 156.021c0 3.444-2.793 10.112-6.237 10.112s-6.237-6.668-6.237-10.112a6.237 6.237 0 1 1 12.474 0",
    style: {
      fill: "#ffdcec",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 4.06500006,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1,
      paintOrder: "normal"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M263.041 168.904c-3.327.892-10.49-.08-11.382-3.407s4.827-7.75 8.154-8.641a6.237 6.237 0 1 1 3.228 12.048",
    style: {
      fill: "#ffdcec",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 4.06500006,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1,
      paintOrder: "normal"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M251.714 176.408c-1.722-2.983-2.638-10.153.345-11.876s8.735 2.656 10.457 5.64a6.237 6.237 0 1 1-10.802 6.236",
    style: {
      fill: "#ffdcec",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 4.06500006,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1,
      paintOrder: "normal"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M241.534 167.41c2.436-2.436 9.125-5.177 11.56-2.741s-.304 9.124-2.74 11.56a6.237 6.237 0 1 1-8.82-8.82",
    style: {
      fill: "#ffdcec",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 4.06500006,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1,
      paintOrder: "normal"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M247.592 155.247c2.983 1.722 7.361 7.474 5.639 10.457s-8.893 2.067-11.876.345a6.237 6.237 0 0 1 6.237-10.802",
    style: {
      fill: "#ffdcec",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 4.06500006,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1,
      paintOrder: "normal"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M247.592 155.247c2.983 1.722 7.361 7.474 5.639 10.457s-8.893 2.067-11.876.345a6.237 6.237 0 0 1 6.237-10.802",
    style: {
      fill: "#ffdcec",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 4.06500006,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1,
      paintOrder: "normal"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 252.488,
    cy: 165.275,
    r: 5.168,
    style: {
      fill: "#ff83ba",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 3.36817837,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1,
      paintOrder: "normal"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(.4006 0 0 .4006 53.527 -11.635)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M258.725 156.021c0 3.444-2.793 10.112-6.237 10.112s-6.237-6.668-6.237-10.112a6.237 6.237 0 1 1 12.474 0",
    style: {
      fill: "#ffdcec",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 4.06500006,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1,
      paintOrder: "normal"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M263.041 168.904c-3.327.892-10.49-.08-11.382-3.407s4.827-7.75 8.154-8.641a6.237 6.237 0 1 1 3.228 12.048",
    style: {
      fill: "#ffdcec",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 4.06500006,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1,
      paintOrder: "normal"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M251.714 176.408c-1.722-2.983-2.638-10.153.345-11.876s8.735 2.656 10.457 5.64a6.237 6.237 0 1 1-10.802 6.236",
    style: {
      fill: "#ffdcec",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 4.06500006,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1,
      paintOrder: "normal"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M241.534 167.41c2.436-2.436 9.125-5.177 11.56-2.741s-.304 9.124-2.74 11.56a6.237 6.237 0 1 1-8.82-8.82",
    style: {
      fill: "#ffdcec",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 4.06500006,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1,
      paintOrder: "normal"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M247.592 155.247c2.983 1.722 7.361 7.474 5.639 10.457s-8.893 2.067-11.876.345a6.237 6.237 0 0 1 6.237-10.802",
    style: {
      fill: "#ffdcec",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 4.06500006,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1,
      paintOrder: "normal"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M247.592 155.247c2.983 1.722 7.361 7.474 5.639 10.457s-8.893 2.067-11.876.345a6.237 6.237 0 0 1 6.237-10.802",
    style: {
      fill: "#ffdcec",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 4.06500006,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1,
      paintOrder: "normal"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 252.488,
    cy: 165.275,
    r: 5.168,
    style: {
      fill: "#ff83ba",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 3.36817837,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1,
      paintOrder: "normal"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(.4006 0 0 .4006 35.299 5.134)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M258.725 156.021c0 3.444-2.793 10.112-6.237 10.112s-6.237-6.668-6.237-10.112a6.237 6.237 0 1 1 12.474 0",
    style: {
      fill: "#ffdcec",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 4.06500006,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1,
      paintOrder: "normal"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M263.041 168.904c-3.327.892-10.49-.08-11.382-3.407s4.827-7.75 8.154-8.641a6.237 6.237 0 1 1 3.228 12.048",
    style: {
      fill: "#ffdcec",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 4.06500006,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1,
      paintOrder: "normal"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M251.714 176.408c-1.722-2.983-2.638-10.153.345-11.876s8.735 2.656 10.457 5.64a6.237 6.237 0 1 1-10.802 6.236",
    style: {
      fill: "#ffdcec",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 4.06500006,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1,
      paintOrder: "normal"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M241.534 167.41c2.436-2.436 9.125-5.177 11.56-2.741s-.304 9.124-2.74 11.56a6.237 6.237 0 1 1-8.82-8.82",
    style: {
      fill: "#ffdcec",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 4.06500006,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1,
      paintOrder: "normal"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M247.592 155.247c2.983 1.722 7.361 7.474 5.639 10.457s-8.893 2.067-11.876.345a6.237 6.237 0 0 1 6.237-10.802",
    style: {
      fill: "#ffdcec",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 4.06500006,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1,
      paintOrder: "normal"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M247.592 155.247c2.983 1.722 7.361 7.474 5.639 10.457s-8.893 2.067-11.876.345a6.237 6.237 0 0 1 6.237-10.802",
    style: {
      fill: "#ffdcec",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 4.06500006,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1,
      paintOrder: "normal"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 252.488,
    cy: 165.275,
    r: 5.168,
    style: {
      fill: "#ff83ba",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 3.36817837,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1,
      paintOrder: "normal"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(.4006 0 0 .4006 53.905 15.013)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M258.725 156.021c0 3.444-2.793 10.112-6.237 10.112s-6.237-6.668-6.237-10.112a6.237 6.237 0 1 1 12.474 0",
    style: {
      fill: "#ffdcec",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 4.06500006,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1,
      paintOrder: "normal"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M263.041 168.904c-3.327.892-10.49-.08-11.382-3.407s4.827-7.75 8.154-8.641a6.237 6.237 0 1 1 3.228 12.048",
    style: {
      fill: "#ffdcec",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 4.06500006,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1,
      paintOrder: "normal"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M251.714 176.408c-1.722-2.983-2.638-10.153.345-11.876s8.735 2.656 10.457 5.64a6.237 6.237 0 1 1-10.802 6.236",
    style: {
      fill: "#ffdcec",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 4.06500006,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1,
      paintOrder: "normal"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M241.534 167.41c2.436-2.436 9.125-5.177 11.56-2.741s-.304 9.124-2.74 11.56a6.237 6.237 0 1 1-8.82-8.82",
    style: {
      fill: "#ffdcec",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 4.06500006,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1,
      paintOrder: "normal"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M247.592 155.247c2.983 1.722 7.361 7.474 5.639 10.457s-8.893 2.067-11.876.345a6.237 6.237 0 0 1 6.237-10.802",
    style: {
      fill: "#ffdcec",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 4.06500006,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1,
      paintOrder: "normal"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M247.592 155.247c2.983 1.722 7.361 7.474 5.639 10.457s-8.893 2.067-11.876.345a6.237 6.237 0 0 1 6.237-10.802",
    style: {
      fill: "#ffdcec",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 4.06500006,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1,
      paintOrder: "normal"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 252.488,
    cy: 165.275,
    r: 5.168,
    style: {
      fill: "#ff83ba",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 3.36817837,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1,
      paintOrder: "normal"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(.4006 0 0 .4006 50.692 28.809)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M258.725 156.021c0 3.444-2.793 10.112-6.237 10.112s-6.237-6.668-6.237-10.112a6.237 6.237 0 1 1 12.474 0",
    style: {
      fill: "#ffdcec",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 4.06500006,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1,
      paintOrder: "normal"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M263.041 168.904c-3.327.892-10.49-.08-11.382-3.407s4.827-7.75 8.154-8.641a6.237 6.237 0 1 1 3.228 12.048",
    style: {
      fill: "#ffdcec",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 4.06500006,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1,
      paintOrder: "normal"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M251.714 176.408c-1.722-2.983-2.638-10.153.345-11.876s8.735 2.656 10.457 5.64a6.237 6.237 0 1 1-10.802 6.236",
    style: {
      fill: "#ffdcec",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 4.06500006,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1,
      paintOrder: "normal"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M241.534 167.41c2.436-2.436 9.125-5.177 11.56-2.741s-.304 9.124-2.74 11.56a6.237 6.237 0 1 1-8.82-8.82",
    style: {
      fill: "#ffdcec",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 4.06500006,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1,
      paintOrder: "normal"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M247.592 155.247c2.983 1.722 7.361 7.474 5.639 10.457s-8.893 2.067-11.876.345a6.237 6.237 0 0 1 6.237-10.802",
    style: {
      fill: "#ffdcec",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 4.06500006,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1,
      paintOrder: "normal"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M247.592 155.247c2.983 1.722 7.361 7.474 5.639 10.457s-8.893 2.067-11.876.345a6.237 6.237 0 0 1 6.237-10.802",
    style: {
      fill: "#ffdcec",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 4.06500006,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1,
      paintOrder: "normal"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 252.488,
    cy: 165.275,
    r: 5.168,
    style: {
      fill: "#ff83ba",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 3.36817837,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1,
      paintOrder: "normal"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(.4006 0 0 .4006 24.904 -18.49)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M258.725 156.021c0 3.444-2.793 10.112-6.237 10.112s-6.237-6.668-6.237-10.112a6.237 6.237 0 1 1 12.474 0",
    style: {
      fill: "#ffdcec",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 4.06500006,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1,
      paintOrder: "normal"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M263.041 168.904c-3.327.892-10.49-.08-11.382-3.407s4.827-7.75 8.154-8.641a6.237 6.237 0 1 1 3.228 12.048",
    style: {
      fill: "#ffdcec",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 4.06500006,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1,
      paintOrder: "normal"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M251.714 176.408c-1.722-2.983-2.638-10.153.345-11.876s8.735 2.656 10.457 5.64a6.237 6.237 0 1 1-10.802 6.236",
    style: {
      fill: "#ffdcec",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 4.06500006,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1,
      paintOrder: "normal"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M241.534 167.41c2.436-2.436 9.125-5.177 11.56-2.741s-.304 9.124-2.74 11.56a6.237 6.237 0 1 1-8.82-8.82",
    style: {
      fill: "#ffdcec",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 4.06500006,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1,
      paintOrder: "normal"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M247.592 155.247c2.983 1.722 7.361 7.474 5.639 10.457s-8.893 2.067-11.876.345a6.237 6.237 0 0 1 6.237-10.802",
    style: {
      fill: "#ffdcec",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 4.06500006,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1,
      paintOrder: "normal"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M247.592 155.247c2.983 1.722 7.361 7.474 5.639 10.457s-8.893 2.067-11.876.345a6.237 6.237 0 0 1 6.237-10.802",
    style: {
      fill: "#ffdcec",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 4.06500006,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1,
      paintOrder: "normal"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 252.488,
    cy: 165.275,
    r: 5.168,
    style: {
      fill: "#ff83ba",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 3.36817837,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1,
      paintOrder: "normal"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(.4006 0 0 .4006 39.258 -42.534)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M258.725 156.021c0 3.444-2.793 10.112-6.237 10.112s-6.237-6.668-6.237-10.112a6.237 6.237 0 1 1 12.474 0",
    style: {
      fill: "#ffdcec",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 4.06500006,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1,
      paintOrder: "normal"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M263.041 168.904c-3.327.892-10.49-.08-11.382-3.407s4.827-7.75 8.154-8.641a6.237 6.237 0 1 1 3.228 12.048",
    style: {
      fill: "#ffdcec",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 4.06500006,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1,
      paintOrder: "normal"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M251.714 176.408c-1.722-2.983-2.638-10.153.345-11.876s8.735 2.656 10.457 5.64a6.237 6.237 0 1 1-10.802 6.236",
    style: {
      fill: "#ffdcec",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 4.06500006,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1,
      paintOrder: "normal"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M241.534 167.41c2.436-2.436 9.125-5.177 11.56-2.741s-.304 9.124-2.74 11.56a6.237 6.237 0 1 1-8.82-8.82",
    style: {
      fill: "#ffdcec",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 4.06500006,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1,
      paintOrder: "normal"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M247.592 155.247c2.983 1.722 7.361 7.474 5.639 10.457s-8.893 2.067-11.876.345a6.237 6.237 0 0 1 6.237-10.802",
    style: {
      fill: "#ffdcec",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 4.06500006,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1,
      paintOrder: "normal"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M247.592 155.247c2.983 1.722 7.361 7.474 5.639 10.457s-8.893 2.067-11.876.345a6.237 6.237 0 0 1 6.237-10.802",
    style: {
      fill: "#ffdcec",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 4.06500006,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1,
      paintOrder: "normal"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 252.488,
    cy: 165.275,
    r: 5.168,
    style: {
      fill: "#ff83ba",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 3.36817837,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1,
      paintOrder: "normal"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(.4006 0 0 .4006 67.228 -32.329)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M258.725 156.021c0 3.444-2.793 10.112-6.237 10.112s-6.237-6.668-6.237-10.112a6.237 6.237 0 1 1 12.474 0",
    style: {
      fill: "#ffdcec",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 4.06500006,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1,
      paintOrder: "normal"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M263.041 168.904c-3.327.892-10.49-.08-11.382-3.407s4.827-7.75 8.154-8.641a6.237 6.237 0 1 1 3.228 12.048",
    style: {
      fill: "#ffdcec",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 4.06500006,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1,
      paintOrder: "normal"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M251.714 176.408c-1.722-2.983-2.638-10.153.345-11.876s8.735 2.656 10.457 5.64a6.237 6.237 0 1 1-10.802 6.236",
    style: {
      fill: "#ffdcec",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 4.06500006,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1,
      paintOrder: "normal"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M241.534 167.41c2.436-2.436 9.125-5.177 11.56-2.741s-.304 9.124-2.74 11.56a6.237 6.237 0 1 1-8.82-8.82",
    style: {
      fill: "#ffdcec",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 4.06500006,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1,
      paintOrder: "normal"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M247.592 155.247c2.983 1.722 7.361 7.474 5.639 10.457s-8.893 2.067-11.876.345a6.237 6.237 0 0 1 6.237-10.802",
    style: {
      fill: "#ffdcec",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 4.06500006,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1,
      paintOrder: "normal"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M247.592 155.247c2.983 1.722 7.361 7.474 5.639 10.457s-8.893 2.067-11.876.345a6.237 6.237 0 0 1 6.237-10.802",
    style: {
      fill: "#ffdcec",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 4.06500006,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1,
      paintOrder: "normal"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 252.488,
    cy: 165.275,
    r: 5.168,
    style: {
      fill: "#ff83ba",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 3.36817837,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1,
      paintOrder: "normal"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(.4006 0 0 .4006 20.836 -7.67)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M258.725 156.021c0 3.444-2.793 10.112-6.237 10.112s-6.237-6.668-6.237-10.112a6.237 6.237 0 1 1 12.474 0",
    style: {
      fill: "#ffdcec",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 4.06500006,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1,
      paintOrder: "normal"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M263.041 168.904c-3.327.892-10.49-.08-11.382-3.407s4.827-7.75 8.154-8.641a6.237 6.237 0 1 1 3.228 12.048",
    style: {
      fill: "#ffdcec",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 4.06500006,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1,
      paintOrder: "normal"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M251.714 176.408c-1.722-2.983-2.638-10.153.345-11.876s8.735 2.656 10.457 5.64a6.237 6.237 0 1 1-10.802 6.236",
    style: {
      fill: "#ffdcec",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 4.06500006,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1,
      paintOrder: "normal"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M241.534 167.41c2.436-2.436 9.125-5.177 11.56-2.741s-.304 9.124-2.74 11.56a6.237 6.237 0 1 1-8.82-8.82",
    style: {
      fill: "#ffdcec",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 4.06500006,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1,
      paintOrder: "normal"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M247.592 155.247c2.983 1.722 7.361 7.474 5.639 10.457s-8.893 2.067-11.876.345a6.237 6.237 0 0 1 6.237-10.802",
    style: {
      fill: "#ffdcec",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 4.06500006,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1,
      paintOrder: "normal"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M247.592 155.247c2.983 1.722 7.361 7.474 5.639 10.457s-8.893 2.067-11.876.345a6.237 6.237 0 0 1 6.237-10.802",
    style: {
      fill: "#ffdcec",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 4.06500006,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1,
      paintOrder: "normal"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 252.488,
    cy: 165.275,
    r: 5.168,
    style: {
      fill: "#ff83ba",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 3.36817837,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1,
      paintOrder: "normal"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(.4006 0 0 .4006 11.749 -10.877)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M258.725 156.021c0 3.444-2.793 10.112-6.237 10.112s-6.237-6.668-6.237-10.112a6.237 6.237 0 1 1 12.474 0",
    style: {
      fill: "#ffdcec",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 4.06500006,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1,
      paintOrder: "normal"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M263.041 168.904c-3.327.892-10.49-.08-11.382-3.407s4.827-7.75 8.154-8.641a6.237 6.237 0 1 1 3.228 12.048",
    style: {
      fill: "#ffdcec",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 4.06500006,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1,
      paintOrder: "normal"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M251.714 176.408c-1.722-2.983-2.638-10.153.345-11.876s8.735 2.656 10.457 5.64a6.237 6.237 0 1 1-10.802 6.236",
    style: {
      fill: "#ffdcec",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 4.06500006,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1,
      paintOrder: "normal"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M241.534 167.41c2.436-2.436 9.125-5.177 11.56-2.741s-.304 9.124-2.74 11.56a6.237 6.237 0 1 1-8.82-8.82",
    style: {
      fill: "#ffdcec",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 4.06500006,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1,
      paintOrder: "normal"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M247.592 155.247c2.983 1.722 7.361 7.474 5.639 10.457s-8.893 2.067-11.876.345a6.237 6.237 0 0 1 6.237-10.802",
    style: {
      fill: "#ffdcec",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 4.06500006,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1,
      paintOrder: "normal"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M247.592 155.247c2.983 1.722 7.361 7.474 5.639 10.457s-8.893 2.067-11.876.345a6.237 6.237 0 0 1 6.237-10.802",
    style: {
      fill: "#ffdcec",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 4.06500006,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1,
      paintOrder: "normal"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 252.488,
    cy: 165.275,
    r: 5.168,
    style: {
      fill: "#ff83ba",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 3.36817837,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1,
      paintOrder: "normal"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(.4006 0 0 .4006 8.809 -.72)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M258.725 156.021c0 3.444-2.793 10.112-6.237 10.112s-6.237-6.668-6.237-10.112a6.237 6.237 0 1 1 12.474 0",
    style: {
      fill: "#ffdcec",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 4.06500006,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1,
      paintOrder: "normal"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M263.041 168.904c-3.327.892-10.49-.08-11.382-3.407s4.827-7.75 8.154-8.641a6.237 6.237 0 1 1 3.228 12.048",
    style: {
      fill: "#ffdcec",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 4.06500006,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1,
      paintOrder: "normal"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M251.714 176.408c-1.722-2.983-2.638-10.153.345-11.876s8.735 2.656 10.457 5.64a6.237 6.237 0 1 1-10.802 6.236",
    style: {
      fill: "#ffdcec",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 4.06500006,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1,
      paintOrder: "normal"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M241.534 167.41c2.436-2.436 9.125-5.177 11.56-2.741s-.304 9.124-2.74 11.56a6.237 6.237 0 1 1-8.82-8.82",
    style: {
      fill: "#ffdcec",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 4.06500006,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1,
      paintOrder: "normal"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M247.592 155.247c2.983 1.722 7.361 7.474 5.639 10.457s-8.893 2.067-11.876.345a6.237 6.237 0 0 1 6.237-10.802",
    style: {
      fill: "#ffdcec",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 4.06500006,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1,
      paintOrder: "normal"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M247.592 155.247c2.983 1.722 7.361 7.474 5.639 10.457s-8.893 2.067-11.876.345a6.237 6.237 0 0 1 6.237-10.802",
    style: {
      fill: "#ffdcec",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 4.06500006,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1,
      paintOrder: "normal"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 252.488,
    cy: 165.275,
    r: 5.168,
    style: {
      fill: "#ff83ba",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 3.36817837,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1,
      paintOrder: "normal"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(.4006 0 0 .4006 26.85 3.289)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M258.725 156.021c0 3.444-2.793 10.112-6.237 10.112s-6.237-6.668-6.237-10.112a6.237 6.237 0 1 1 12.474 0",
    style: {
      fill: "#ffdcec",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 4.06500006,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1,
      paintOrder: "normal"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M263.041 168.904c-3.327.892-10.49-.08-11.382-3.407s4.827-7.75 8.154-8.641a6.237 6.237 0 1 1 3.228 12.048",
    style: {
      fill: "#ffdcec",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 4.06500006,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1,
      paintOrder: "normal"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M251.714 176.408c-1.722-2.983-2.638-10.153.345-11.876s8.735 2.656 10.457 5.64a6.237 6.237 0 1 1-10.802 6.236",
    style: {
      fill: "#ffdcec",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 4.06500006,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1,
      paintOrder: "normal"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M241.534 167.41c2.436-2.436 9.125-5.177 11.56-2.741s-.304 9.124-2.74 11.56a6.237 6.237 0 1 1-8.82-8.82",
    style: {
      fill: "#ffdcec",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 4.06500006,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1,
      paintOrder: "normal"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M247.592 155.247c2.983 1.722 7.361 7.474 5.639 10.457s-8.893 2.067-11.876.345a6.237 6.237 0 0 1 6.237-10.802",
    style: {
      fill: "#ffdcec",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 4.06500006,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1,
      paintOrder: "normal"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M247.592 155.247c2.983 1.722 7.361 7.474 5.639 10.457s-8.893 2.067-11.876.345a6.237 6.237 0 0 1 6.237-10.802",
    style: {
      fill: "#ffdcec",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 4.06500006,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1,
      paintOrder: "normal"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 252.488,
    cy: 165.275,
    r: 5.168,
    style: {
      fill: "#ff83ba",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 3.36817837,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1,
      paintOrder: "normal"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(.4006 0 0 .4006 35.268 -7.402)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M258.725 156.021c0 3.444-2.793 10.112-6.237 10.112s-6.237-6.668-6.237-10.112a6.237 6.237 0 1 1 12.474 0",
    style: {
      fill: "#ffdcec",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 4.06500006,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1,
      paintOrder: "normal"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M263.041 168.904c-3.327.892-10.49-.08-11.382-3.407s4.827-7.75 8.154-8.641a6.237 6.237 0 1 1 3.228 12.048",
    style: {
      fill: "#ffdcec",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 4.06500006,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1,
      paintOrder: "normal"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M251.714 176.408c-1.722-2.983-2.638-10.153.345-11.876s8.735 2.656 10.457 5.64a6.237 6.237 0 1 1-10.802 6.236",
    style: {
      fill: "#ffdcec",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 4.06500006,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1,
      paintOrder: "normal"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M241.534 167.41c2.436-2.436 9.125-5.177 11.56-2.741s-.304 9.124-2.74 11.56a6.237 6.237 0 1 1-8.82-8.82",
    style: {
      fill: "#ffdcec",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 4.06500006,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1,
      paintOrder: "normal"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M247.592 155.247c2.983 1.722 7.361 7.474 5.639 10.457s-8.893 2.067-11.876.345a6.237 6.237 0 0 1 6.237-10.802",
    style: {
      fill: "#ffdcec",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 4.06500006,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1,
      paintOrder: "normal"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M247.592 155.247c2.983 1.722 7.361 7.474 5.639 10.457s-8.893 2.067-11.876.345a6.237 6.237 0 0 1 6.237-10.802",
    style: {
      fill: "#ffdcec",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 4.06500006,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1,
      paintOrder: "normal"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 252.488,
    cy: 165.275,
    r: 5.168,
    style: {
      fill: "#ff83ba",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 3.36817837,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1,
      paintOrder: "normal"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(.4006 0 0 .4006 15.223 -21.968)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M258.725 156.021c0 3.444-2.793 10.112-6.237 10.112s-6.237-6.668-6.237-10.112a6.237 6.237 0 1 1 12.474 0",
    style: {
      fill: "#ffdcec",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 4.06500006,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1,
      paintOrder: "normal"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M263.041 168.904c-3.327.892-10.49-.08-11.382-3.407s4.827-7.75 8.154-8.641a6.237 6.237 0 1 1 3.228 12.048",
    style: {
      fill: "#ffdcec",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 4.06500006,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1,
      paintOrder: "normal"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M251.714 176.408c-1.722-2.983-2.638-10.153.345-11.876s8.735 2.656 10.457 5.64a6.237 6.237 0 1 1-10.802 6.236",
    style: {
      fill: "#ffdcec",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 4.06500006,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1,
      paintOrder: "normal"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M241.534 167.41c2.436-2.436 9.125-5.177 11.56-2.741s-.304 9.124-2.74 11.56a6.237 6.237 0 1 1-8.82-8.82",
    style: {
      fill: "#ffdcec",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 4.06500006,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1,
      paintOrder: "normal"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M247.592 155.247c2.983 1.722 7.361 7.474 5.639 10.457s-8.893 2.067-11.876.345a6.237 6.237 0 0 1 6.237-10.802",
    style: {
      fill: "#ffdcec",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 4.06500006,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1,
      paintOrder: "normal"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M247.592 155.247c2.983 1.722 7.361 7.474 5.639 10.457s-8.893 2.067-11.876.345a6.237 6.237 0 0 1 6.237-10.802",
    style: {
      fill: "#ffdcec",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 4.06500006,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1,
      paintOrder: "normal"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 252.488,
    cy: 165.275,
    r: 5.168,
    style: {
      fill: "#ff83ba",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 3.36817837,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1,
      paintOrder: "normal"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(.4006 0 0 .4006 22.507 -43.684)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M258.725 156.021c0 3.444-2.793 10.112-6.237 10.112s-6.237-6.668-6.237-10.112a6.237 6.237 0 1 1 12.474 0",
    style: {
      fill: "#ffdcec",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 4.06500006,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1,
      paintOrder: "normal"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M263.041 168.904c-3.327.892-10.49-.08-11.382-3.407s4.827-7.75 8.154-8.641a6.237 6.237 0 1 1 3.228 12.048",
    style: {
      fill: "#ffdcec",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 4.06500006,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1,
      paintOrder: "normal"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M251.714 176.408c-1.722-2.983-2.638-10.153.345-11.876s8.735 2.656 10.457 5.64a6.237 6.237 0 1 1-10.802 6.236",
    style: {
      fill: "#ffdcec",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 4.06500006,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1,
      paintOrder: "normal"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M241.534 167.41c2.436-2.436 9.125-5.177 11.56-2.741s-.304 9.124-2.74 11.56a6.237 6.237 0 1 1-8.82-8.82",
    style: {
      fill: "#ffdcec",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 4.06500006,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1,
      paintOrder: "normal"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M247.592 155.247c2.983 1.722 7.361 7.474 5.639 10.457s-8.893 2.067-11.876.345a6.237 6.237 0 0 1 6.237-10.802",
    style: {
      fill: "#ffdcec",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 4.06500006,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1,
      paintOrder: "normal"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M247.592 155.247c2.983 1.722 7.361 7.474 5.639 10.457s-8.893 2.067-11.876.345a6.237 6.237 0 0 1 6.237-10.802",
    style: {
      fill: "#ffdcec",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 4.06500006,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1,
      paintOrder: "normal"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 252.488,
    cy: 165.275,
    r: 5.168,
    style: {
      fill: "#ff83ba",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 3.36817837,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1,
      paintOrder: "normal"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(.4006 0 0 .4006 32.396 -36.334)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M258.725 156.021c0 3.444-2.793 10.112-6.237 10.112s-6.237-6.668-6.237-10.112a6.237 6.237 0 1 1 12.474 0",
    style: {
      fill: "#ffdcec",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 4.06500006,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1,
      paintOrder: "normal"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M263.041 168.904c-3.327.892-10.49-.08-11.382-3.407s4.827-7.75 8.154-8.641a6.237 6.237 0 1 1 3.228 12.048",
    style: {
      fill: "#ffdcec",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 4.06500006,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1,
      paintOrder: "normal"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M251.714 176.408c-1.722-2.983-2.638-10.153.345-11.876s8.735 2.656 10.457 5.64a6.237 6.237 0 1 1-10.802 6.236",
    style: {
      fill: "#ffdcec",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 4.06500006,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1,
      paintOrder: "normal"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M241.534 167.41c2.436-2.436 9.125-5.177 11.56-2.741s-.304 9.124-2.74 11.56a6.237 6.237 0 1 1-8.82-8.82",
    style: {
      fill: "#ffdcec",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 4.06500006,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1,
      paintOrder: "normal"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M247.592 155.247c2.983 1.722 7.361 7.474 5.639 10.457s-8.893 2.067-11.876.345a6.237 6.237 0 0 1 6.237-10.802",
    style: {
      fill: "#ffdcec",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 4.06500006,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1,
      paintOrder: "normal"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M247.592 155.247c2.983 1.722 7.361 7.474 5.639 10.457s-8.893 2.067-11.876.345a6.237 6.237 0 0 1 6.237-10.802",
    style: {
      fill: "#ffdcec",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 4.06500006,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1,
      paintOrder: "normal"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 252.488,
    cy: 165.275,
    r: 5.168,
    style: {
      fill: "#ff83ba",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 3.36817837,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1,
      paintOrder: "normal"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(.4006 0 0 .4006 30.32 -45.09)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M258.725 156.021c0 3.444-2.793 10.112-6.237 10.112s-6.237-6.668-6.237-10.112a6.237 6.237 0 1 1 12.474 0",
    style: {
      fill: "#ffdcec",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 4.06500006,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1,
      paintOrder: "normal"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M263.041 168.904c-3.327.892-10.49-.08-11.382-3.407s4.827-7.75 8.154-8.641a6.237 6.237 0 1 1 3.228 12.048",
    style: {
      fill: "#ffdcec",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 4.06500006,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1,
      paintOrder: "normal"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M251.714 176.408c-1.722-2.983-2.638-10.153.345-11.876s8.735 2.656 10.457 5.64a6.237 6.237 0 1 1-10.802 6.236",
    style: {
      fill: "#ffdcec",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 4.06500006,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1,
      paintOrder: "normal"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M241.534 167.41c2.436-2.436 9.125-5.177 11.56-2.741s-.304 9.124-2.74 11.56a6.237 6.237 0 1 1-8.82-8.82",
    style: {
      fill: "#ffdcec",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 4.06500006,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1,
      paintOrder: "normal"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M247.592 155.247c2.983 1.722 7.361 7.474 5.639 10.457s-8.893 2.067-11.876.345a6.237 6.237 0 0 1 6.237-10.802",
    style: {
      fill: "#ffdcec",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 4.06500006,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1,
      paintOrder: "normal"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M247.592 155.247c2.983 1.722 7.361 7.474 5.639 10.457s-8.893 2.067-11.876.345a6.237 6.237 0 0 1 6.237-10.802",
    style: {
      fill: "#ffdcec",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 4.06500006,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1,
      paintOrder: "normal"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 252.488,
    cy: 165.275,
    r: 5.168,
    style: {
      fill: "#ff83ba",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 3.36817837,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1,
      paintOrder: "normal"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(.4006 0 0 .4006 43.22 -37.135)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M258.725 156.021c0 3.444-2.793 10.112-6.237 10.112s-6.237-6.668-6.237-10.112a6.237 6.237 0 1 1 12.474 0",
    style: {
      fill: "#ffdcec",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 4.06500006,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1,
      paintOrder: "normal"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M263.041 168.904c-3.327.892-10.49-.08-11.382-3.407s4.827-7.75 8.154-8.641a6.237 6.237 0 1 1 3.228 12.048",
    style: {
      fill: "#ffdcec",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 4.06500006,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1,
      paintOrder: "normal"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M251.714 176.408c-1.722-2.983-2.638-10.153.345-11.876s8.735 2.656 10.457 5.64a6.237 6.237 0 1 1-10.802 6.236",
    style: {
      fill: "#ffdcec",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 4.06500006,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1,
      paintOrder: "normal"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M241.534 167.41c2.436-2.436 9.125-5.177 11.56-2.741s-.304 9.124-2.74 11.56a6.237 6.237 0 1 1-8.82-8.82",
    style: {
      fill: "#ffdcec",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 4.06500006,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1,
      paintOrder: "normal"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M247.592 155.247c2.983 1.722 7.361 7.474 5.639 10.457s-8.893 2.067-11.876.345a6.237 6.237 0 0 1 6.237-10.802",
    style: {
      fill: "#ffdcec",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 4.06500006,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1,
      paintOrder: "normal"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M247.592 155.247c2.983 1.722 7.361 7.474 5.639 10.457s-8.893 2.067-11.876.345a6.237 6.237 0 0 1 6.237-10.802",
    style: {
      fill: "#ffdcec",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 4.06500006,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1,
      paintOrder: "normal"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 252.488,
    cy: 165.275,
    r: 5.168,
    style: {
      fill: "#ff83ba",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 3.36817837,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1,
      paintOrder: "normal"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(.4006 0 0 .4006 25.018 -35.635)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M258.725 156.021c0 3.444-2.793 10.112-6.237 10.112s-6.237-6.668-6.237-10.112a6.237 6.237 0 1 1 12.474 0",
    style: {
      fill: "#ffdcec",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 4.06500006,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1,
      paintOrder: "normal"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M263.041 168.904c-3.327.892-10.49-.08-11.382-3.407s4.827-7.75 8.154-8.641a6.237 6.237 0 1 1 3.228 12.048",
    style: {
      fill: "#ffdcec",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 4.06500006,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1,
      paintOrder: "normal"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M251.714 176.408c-1.722-2.983-2.638-10.153.345-11.876s8.735 2.656 10.457 5.64a6.237 6.237 0 1 1-10.802 6.236",
    style: {
      fill: "#ffdcec",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 4.06500006,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1,
      paintOrder: "normal"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M241.534 167.41c2.436-2.436 9.125-5.177 11.56-2.741s-.304 9.124-2.74 11.56a6.237 6.237 0 1 1-8.82-8.82",
    style: {
      fill: "#ffdcec",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 4.06500006,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1,
      paintOrder: "normal"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M247.592 155.247c2.983 1.722 7.361 7.474 5.639 10.457s-8.893 2.067-11.876.345a6.237 6.237 0 0 1 6.237-10.802",
    style: {
      fill: "#ffdcec",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 4.06500006,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1,
      paintOrder: "normal"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M247.592 155.247c2.983 1.722 7.361 7.474 5.639 10.457s-8.893 2.067-11.876.345a6.237 6.237 0 0 1 6.237-10.802",
    style: {
      fill: "#ffdcec",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 4.06500006,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1,
      paintOrder: "normal"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 252.488,
    cy: 165.275,
    r: 5.168,
    style: {
      fill: "#ff83ba",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 3.36817837,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1,
      paintOrder: "normal"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(.4006 0 0 .4006 58.455 -33.795)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M258.725 156.021c0 3.444-2.793 10.112-6.237 10.112s-6.237-6.668-6.237-10.112a6.237 6.237 0 1 1 12.474 0",
    style: {
      fill: "#ffdcec",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 4.06500006,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1,
      paintOrder: "normal"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M263.041 168.904c-3.327.892-10.49-.08-11.382-3.407s4.827-7.75 8.154-8.641a6.237 6.237 0 1 1 3.228 12.048",
    style: {
      fill: "#ffdcec",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 4.06500006,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1,
      paintOrder: "normal"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M251.714 176.408c-1.722-2.983-2.638-10.153.345-11.876s8.735 2.656 10.457 5.64a6.237 6.237 0 1 1-10.802 6.236",
    style: {
      fill: "#ffdcec",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 4.06500006,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1,
      paintOrder: "normal"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M241.534 167.41c2.436-2.436 9.125-5.177 11.56-2.741s-.304 9.124-2.74 11.56a6.237 6.237 0 1 1-8.82-8.82",
    style: {
      fill: "#ffdcec",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 4.06500006,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1,
      paintOrder: "normal"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M247.592 155.247c2.983 1.722 7.361 7.474 5.639 10.457s-8.893 2.067-11.876.345a6.237 6.237 0 0 1 6.237-10.802",
    style: {
      fill: "#ffdcec",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 4.06500006,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1,
      paintOrder: "normal"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M247.592 155.247c2.983 1.722 7.361 7.474 5.639 10.457s-8.893 2.067-11.876.345a6.237 6.237 0 0 1 6.237-10.802",
    style: {
      fill: "#ffdcec",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 4.06500006,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1,
      paintOrder: "normal"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 252.488,
    cy: 165.275,
    r: 5.168,
    style: {
      fill: "#ff83ba",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 3.36817837,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1,
      paintOrder: "normal"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(.4006 0 0 .4006 37.902 -20.006)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M258.725 156.021c0 3.444-2.793 10.112-6.237 10.112s-6.237-6.668-6.237-10.112a6.237 6.237 0 1 1 12.474 0",
    style: {
      fill: "#ffdcec",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 4.06500006,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1,
      paintOrder: "normal"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M263.041 168.904c-3.327.892-10.49-.08-11.382-3.407s4.827-7.75 8.154-8.641a6.237 6.237 0 1 1 3.228 12.048",
    style: {
      fill: "#ffdcec",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 4.06500006,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1,
      paintOrder: "normal"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M251.714 176.408c-1.722-2.983-2.638-10.153.345-11.876s8.735 2.656 10.457 5.64a6.237 6.237 0 1 1-10.802 6.236",
    style: {
      fill: "#ffdcec",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 4.06500006,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1,
      paintOrder: "normal"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M241.534 167.41c2.436-2.436 9.125-5.177 11.56-2.741s-.304 9.124-2.74 11.56a6.237 6.237 0 1 1-8.82-8.82",
    style: {
      fill: "#ffdcec",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 4.06500006,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1,
      paintOrder: "normal"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M247.592 155.247c2.983 1.722 7.361 7.474 5.639 10.457s-8.893 2.067-11.876.345a6.237 6.237 0 0 1 6.237-10.802",
    style: {
      fill: "#ffdcec",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 4.06500006,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1,
      paintOrder: "normal"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M247.592 155.247c2.983 1.722 7.361 7.474 5.639 10.457s-8.893 2.067-11.876.345a6.237 6.237 0 0 1 6.237-10.802",
    style: {
      fill: "#ffdcec",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 4.06500006,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1,
      paintOrder: "normal"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 252.488,
    cy: 165.275,
    r: 5.168,
    style: {
      fill: "#ff83ba",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 3.36817837,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1,
      paintOrder: "normal"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(.4006 0 0 .4006 48.566 -3.059)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M258.725 156.021c0 3.444-2.793 10.112-6.237 10.112s-6.237-6.668-6.237-10.112a6.237 6.237 0 1 1 12.474 0",
    style: {
      fill: "#ffdcec",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 4.06500006,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1,
      paintOrder: "normal"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M263.041 168.904c-3.327.892-10.49-.08-11.382-3.407s4.827-7.75 8.154-8.641a6.237 6.237 0 1 1 3.228 12.048",
    style: {
      fill: "#ffdcec",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 4.06500006,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1,
      paintOrder: "normal"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M251.714 176.408c-1.722-2.983-2.638-10.153.345-11.876s8.735 2.656 10.457 5.64a6.237 6.237 0 1 1-10.802 6.236",
    style: {
      fill: "#ffdcec",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 4.06500006,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1,
      paintOrder: "normal"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M241.534 167.41c2.436-2.436 9.125-5.177 11.56-2.741s-.304 9.124-2.74 11.56a6.237 6.237 0 1 1-8.82-8.82",
    style: {
      fill: "#ffdcec",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 4.06500006,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1,
      paintOrder: "normal"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M247.592 155.247c2.983 1.722 7.361 7.474 5.639 10.457s-8.893 2.067-11.876.345a6.237 6.237 0 0 1 6.237-10.802",
    style: {
      fill: "#ffdcec",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 4.06500006,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1,
      paintOrder: "normal"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M247.592 155.247c2.983 1.722 7.361 7.474 5.639 10.457s-8.893 2.067-11.876.345a6.237 6.237 0 0 1 6.237-10.802",
    style: {
      fill: "#ffdcec",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 4.06500006,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1,
      paintOrder: "normal"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 252.488,
    cy: 165.275,
    r: 5.168,
    style: {
      fill: "#ff83ba",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 3.36817837,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1,
      paintOrder: "normal"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(.4006 0 0 .4006 27.117 15.984)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M258.725 156.021c0 3.444-2.793 10.112-6.237 10.112s-6.237-6.668-6.237-10.112a6.237 6.237 0 1 1 12.474 0",
    style: {
      fill: "#ffdcec",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 4.06500006,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1,
      paintOrder: "normal"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M263.041 168.904c-3.327.892-10.49-.08-11.382-3.407s4.827-7.75 8.154-8.641a6.237 6.237 0 1 1 3.228 12.048",
    style: {
      fill: "#ffdcec",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 4.06500006,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1,
      paintOrder: "normal"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M251.714 176.408c-1.722-2.983-2.638-10.153.345-11.876s8.735 2.656 10.457 5.64a6.237 6.237 0 1 1-10.802 6.236",
    style: {
      fill: "#ffdcec",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 4.06500006,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1,
      paintOrder: "normal"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M241.534 167.41c2.436-2.436 9.125-5.177 11.56-2.741s-.304 9.124-2.74 11.56a6.237 6.237 0 1 1-8.82-8.82",
    style: {
      fill: "#ffdcec",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 4.06500006,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1,
      paintOrder: "normal"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M247.592 155.247c2.983 1.722 7.361 7.474 5.639 10.457s-8.893 2.067-11.876.345a6.237 6.237 0 0 1 6.237-10.802",
    style: {
      fill: "#ffdcec",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 4.06500006,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1,
      paintOrder: "normal"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M247.592 155.247c2.983 1.722 7.361 7.474 5.639 10.457s-8.893 2.067-11.876.345a6.237 6.237 0 0 1 6.237-10.802",
    style: {
      fill: "#ffdcec",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 4.06500006,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1,
      paintOrder: "normal"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 252.488,
    cy: 165.275,
    r: 5.168,
    style: {
      fill: "#ff83ba",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 3.36817837,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1,
      paintOrder: "normal"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(.4006 0 0 .4006 45.359 13.245)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M258.725 156.021c0 3.444-2.793 10.112-6.237 10.112s-6.237-6.668-6.237-10.112a6.237 6.237 0 1 1 12.474 0",
    style: {
      fill: "#ffdcec",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 4.06500006,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1,
      paintOrder: "normal"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M263.041 168.904c-3.327.892-10.49-.08-11.382-3.407s4.827-7.75 8.154-8.641a6.237 6.237 0 1 1 3.228 12.048",
    style: {
      fill: "#ffdcec",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 4.06500006,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1,
      paintOrder: "normal"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M251.714 176.408c-1.722-2.983-2.638-10.153.345-11.876s8.735 2.656 10.457 5.64a6.237 6.237 0 1 1-10.802 6.236",
    style: {
      fill: "#ffdcec",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 4.06500006,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1,
      paintOrder: "normal"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M241.534 167.41c2.436-2.436 9.125-5.177 11.56-2.741s-.304 9.124-2.74 11.56a6.237 6.237 0 1 1-8.82-8.82",
    style: {
      fill: "#ffdcec",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 4.06500006,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1,
      paintOrder: "normal"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M247.592 155.247c2.983 1.722 7.361 7.474 5.639 10.457s-8.893 2.067-11.876.345a6.237 6.237 0 0 1 6.237-10.802",
    style: {
      fill: "#ffdcec",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 4.06500006,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1,
      paintOrder: "normal"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M247.592 155.247c2.983 1.722 7.361 7.474 5.639 10.457s-8.893 2.067-11.876.345a6.237 6.237 0 0 1 6.237-10.802",
    style: {
      fill: "#ffdcec",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 4.06500006,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1,
      paintOrder: "normal"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 252.488,
    cy: 165.275,
    r: 5.168,
    style: {
      fill: "#ff83ba",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 3.36817837,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1,
      paintOrder: "normal"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(.4006 0 0 .4006 57.52 2.287)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M258.725 156.021c0 3.444-2.793 10.112-6.237 10.112s-6.237-6.668-6.237-10.112a6.237 6.237 0 1 1 12.474 0",
    style: {
      fill: "#ffdcec",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 4.06500006,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1,
      paintOrder: "normal"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M263.041 168.904c-3.327.892-10.49-.08-11.382-3.407s4.827-7.75 8.154-8.641a6.237 6.237 0 1 1 3.228 12.048",
    style: {
      fill: "#ffdcec",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 4.06500006,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1,
      paintOrder: "normal"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M251.714 176.408c-1.722-2.983-2.638-10.153.345-11.876s8.735 2.656 10.457 5.64a6.237 6.237 0 1 1-10.802 6.236",
    style: {
      fill: "#ffdcec",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 4.06500006,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1,
      paintOrder: "normal"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M241.534 167.41c2.436-2.436 9.125-5.177 11.56-2.741s-.304 9.124-2.74 11.56a6.237 6.237 0 1 1-8.82-8.82",
    style: {
      fill: "#ffdcec",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 4.06500006,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1,
      paintOrder: "normal"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M247.592 155.247c2.983 1.722 7.361 7.474 5.639 10.457s-8.893 2.067-11.876.345a6.237 6.237 0 0 1 6.237-10.802",
    style: {
      fill: "#ffdcec",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 4.06500006,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1,
      paintOrder: "normal"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M247.592 155.247c2.983 1.722 7.361 7.474 5.639 10.457s-8.893 2.067-11.876.345a6.237 6.237 0 0 1 6.237-10.802",
    style: {
      fill: "#ffdcec",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 4.06500006,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1,
      paintOrder: "normal"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 252.488,
    cy: 165.275,
    r: 5.168,
    style: {
      fill: "#ff83ba",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 3.36817837,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1,
      paintOrder: "normal"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(.4006 0 0 .4006 65.137 -12.413)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M258.725 156.021c0 3.444-2.793 10.112-6.237 10.112s-6.237-6.668-6.237-10.112a6.237 6.237 0 1 1 12.474 0",
    style: {
      fill: "#ffdcec",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 4.06500006,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1,
      paintOrder: "normal"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M263.041 168.904c-3.327.892-10.49-.08-11.382-3.407s4.827-7.75 8.154-8.641a6.237 6.237 0 1 1 3.228 12.048",
    style: {
      fill: "#ffdcec",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 4.06500006,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1,
      paintOrder: "normal"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M251.714 176.408c-1.722-2.983-2.638-10.153.345-11.876s8.735 2.656 10.457 5.64a6.237 6.237 0 1 1-10.802 6.236",
    style: {
      fill: "#ffdcec",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 4.06500006,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1,
      paintOrder: "normal"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M241.534 167.41c2.436-2.436 9.125-5.177 11.56-2.741s-.304 9.124-2.74 11.56a6.237 6.237 0 1 1-8.82-8.82",
    style: {
      fill: "#ffdcec",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 4.06500006,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1,
      paintOrder: "normal"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M247.592 155.247c2.983 1.722 7.361 7.474 5.639 10.457s-8.893 2.067-11.876.345a6.237 6.237 0 0 1 6.237-10.802",
    style: {
      fill: "#ffdcec",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 4.06500006,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1,
      paintOrder: "normal"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M247.592 155.247c2.983 1.722 7.361 7.474 5.639 10.457s-8.893 2.067-11.876.345a6.237 6.237 0 0 1 6.237-10.802",
    style: {
      fill: "#ffdcec",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 4.06500006,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1,
      paintOrder: "normal"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 252.488,
    cy: 165.275,
    r: 5.168,
    style: {
      fill: "#ff83ba",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 3.36817837,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1,
      paintOrder: "normal"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(.4006 0 0 .4006 61.261 -25.51)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M258.725 156.021c0 3.444-2.793 10.112-6.237 10.112s-6.237-6.668-6.237-10.112a6.237 6.237 0 1 1 12.474 0",
    style: {
      fill: "#ffdcec",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 4.06500006,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1,
      paintOrder: "normal"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M263.041 168.904c-3.327.892-10.49-.08-11.382-3.407s4.827-7.75 8.154-8.641a6.237 6.237 0 1 1 3.228 12.048",
    style: {
      fill: "#ffdcec",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 4.06500006,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1,
      paintOrder: "normal"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M251.714 176.408c-1.722-2.983-2.638-10.153.345-11.876s8.735 2.656 10.457 5.64a6.237 6.237 0 1 1-10.802 6.236",
    style: {
      fill: "#ffdcec",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 4.06500006,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1,
      paintOrder: "normal"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M241.534 167.41c2.436-2.436 9.125-5.177 11.56-2.741s-.304 9.124-2.74 11.56a6.237 6.237 0 1 1-8.82-8.82",
    style: {
      fill: "#ffdcec",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 4.06500006,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1,
      paintOrder: "normal"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M247.592 155.247c2.983 1.722 7.361 7.474 5.639 10.457s-8.893 2.067-11.876.345a6.237 6.237 0 0 1 6.237-10.802",
    style: {
      fill: "#ffdcec",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 4.06500006,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1,
      paintOrder: "normal"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M247.592 155.247c2.983 1.722 7.361 7.474 5.639 10.457s-8.893 2.067-11.876.345a6.237 6.237 0 0 1 6.237-10.802",
    style: {
      fill: "#ffdcec",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 4.06500006,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1,
      paintOrder: "normal"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 252.488,
    cy: 165.275,
    r: 5.168,
    style: {
      fill: "#ff83ba",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 3.36817837,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1,
      paintOrder: "normal"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(.4006 0 0 .4006 70.933 -22.946)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M258.725 156.021c0 3.444-2.793 10.112-6.237 10.112s-6.237-6.668-6.237-10.112a6.237 6.237 0 1 1 12.474 0",
    style: {
      fill: "#ffdcec",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 4.06500006,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1,
      paintOrder: "normal"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M263.041 168.904c-3.327.892-10.49-.08-11.382-3.407s4.827-7.75 8.154-8.641a6.237 6.237 0 1 1 3.228 12.048",
    style: {
      fill: "#ffdcec",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 4.06500006,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1,
      paintOrder: "normal"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M251.714 176.408c-1.722-2.983-2.638-10.153.345-11.876s8.735 2.656 10.457 5.64a6.237 6.237 0 1 1-10.802 6.236",
    style: {
      fill: "#ffdcec",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 4.06500006,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1,
      paintOrder: "normal"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M241.534 167.41c2.436-2.436 9.125-5.177 11.56-2.741s-.304 9.124-2.74 11.56a6.237 6.237 0 1 1-8.82-8.82",
    style: {
      fill: "#ffdcec",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 4.06500006,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1,
      paintOrder: "normal"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M247.592 155.247c2.983 1.722 7.361 7.474 5.639 10.457s-8.893 2.067-11.876.345a6.237 6.237 0 0 1 6.237-10.802",
    style: {
      fill: "#ffdcec",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 4.06500006,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1,
      paintOrder: "normal"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M247.592 155.247c2.983 1.722 7.361 7.474 5.639 10.457s-8.893 2.067-11.876.345a6.237 6.237 0 0 1 6.237-10.802",
    style: {
      fill: "#ffdcec",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 4.06500006,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1,
      paintOrder: "normal"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 252.488,
    cy: 165.275,
    r: 5.168,
    style: {
      fill: "#ff83ba",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 3.36817837,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1,
      paintOrder: "normal"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(.4006 0 0 .4006 72.62 -4.261)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M258.725 156.021c0 3.444-2.793 10.112-6.237 10.112s-6.237-6.668-6.237-10.112a6.237 6.237 0 1 1 12.474 0",
    style: {
      fill: "#ffdcec",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 4.06500006,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1,
      paintOrder: "normal"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M263.041 168.904c-3.327.892-10.49-.08-11.382-3.407s4.827-7.75 8.154-8.641a6.237 6.237 0 1 1 3.228 12.048",
    style: {
      fill: "#ffdcec",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 4.06500006,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1,
      paintOrder: "normal"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M251.714 176.408c-1.722-2.983-2.638-10.153.345-11.876s8.735 2.656 10.457 5.64a6.237 6.237 0 1 1-10.802 6.236",
    style: {
      fill: "#ffdcec",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 4.06500006,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1,
      paintOrder: "normal"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M241.534 167.41c2.436-2.436 9.125-5.177 11.56-2.741s-.304 9.124-2.74 11.56a6.237 6.237 0 1 1-8.82-8.82",
    style: {
      fill: "#ffdcec",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 4.06500006,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1,
      paintOrder: "normal"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M247.592 155.247c2.983 1.722 7.361 7.474 5.639 10.457s-8.893 2.067-11.876.345a6.237 6.237 0 0 1 6.237-10.802",
    style: {
      fill: "#ffdcec",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 4.06500006,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1,
      paintOrder: "normal"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M247.592 155.247c2.983 1.722 7.361 7.474 5.639 10.457s-8.893 2.067-11.876.345a6.237 6.237 0 0 1 6.237-10.802",
    style: {
      fill: "#ffdcec",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 4.06500006,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1,
      paintOrder: "normal"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 252.488,
    cy: 165.275,
    r: 5.168,
    style: {
      fill: "#ff83ba",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 3.36817837,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1,
      paintOrder: "normal"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(.4006 0 0 .4006 62.999 9.77)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M258.725 156.021c0 3.444-2.793 10.112-6.237 10.112s-6.237-6.668-6.237-10.112a6.237 6.237 0 1 1 12.474 0",
    style: {
      fill: "#ffdcec",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 4.06500006,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1,
      paintOrder: "normal"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M263.041 168.904c-3.327.892-10.49-.08-11.382-3.407s4.827-7.75 8.154-8.641a6.237 6.237 0 1 1 3.228 12.048",
    style: {
      fill: "#ffdcec",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 4.06500006,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1,
      paintOrder: "normal"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M251.714 176.408c-1.722-2.983-2.638-10.153.345-11.876s8.735 2.656 10.457 5.64a6.237 6.237 0 1 1-10.802 6.236",
    style: {
      fill: "#ffdcec",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 4.06500006,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1,
      paintOrder: "normal"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M241.534 167.41c2.436-2.436 9.125-5.177 11.56-2.741s-.304 9.124-2.74 11.56a6.237 6.237 0 1 1-8.82-8.82",
    style: {
      fill: "#ffdcec",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 4.06500006,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1,
      paintOrder: "normal"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M247.592 155.247c2.983 1.722 7.361 7.474 5.639 10.457s-8.893 2.067-11.876.345a6.237 6.237 0 0 1 6.237-10.802",
    style: {
      fill: "#ffdcec",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 4.06500006,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1,
      paintOrder: "normal"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M247.592 155.247c2.983 1.722 7.361 7.474 5.639 10.457s-8.893 2.067-11.876.345a6.237 6.237 0 0 1 6.237-10.802",
    style: {
      fill: "#ffdcec",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 4.06500006,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1,
      paintOrder: "normal"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 252.488,
    cy: 165.275,
    r: 5.168,
    style: {
      fill: "#ff83ba",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 3.36817837,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1,
      paintOrder: "normal"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(.4006 0 0 .4006 70.215 28.078)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M258.725 156.021c0 3.444-2.793 10.112-6.237 10.112s-6.237-6.668-6.237-10.112a6.237 6.237 0 1 1 12.474 0",
    style: {
      fill: "#ffdcec",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 4.06500006,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1,
      paintOrder: "normal"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M263.041 168.904c-3.327.892-10.49-.08-11.382-3.407s4.827-7.75 8.154-8.641a6.237 6.237 0 1 1 3.228 12.048",
    style: {
      fill: "#ffdcec",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 4.06500006,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1,
      paintOrder: "normal"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M251.714 176.408c-1.722-2.983-2.638-10.153.345-11.876s8.735 2.656 10.457 5.64a6.237 6.237 0 1 1-10.802 6.236",
    style: {
      fill: "#ffdcec",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 4.06500006,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1,
      paintOrder: "normal"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M241.534 167.41c2.436-2.436 9.125-5.177 11.56-2.741s-.304 9.124-2.74 11.56a6.237 6.237 0 1 1-8.82-8.82",
    style: {
      fill: "#ffdcec",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 4.06500006,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1,
      paintOrder: "normal"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M247.592 155.247c2.983 1.722 7.361 7.474 5.639 10.457s-8.893 2.067-11.876.345a6.237 6.237 0 0 1 6.237-10.802",
    style: {
      fill: "#ffdcec",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 4.06500006,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1,
      paintOrder: "normal"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M247.592 155.247c2.983 1.722 7.361 7.474 5.639 10.457s-8.893 2.067-11.876.345a6.237 6.237 0 0 1 6.237-10.802",
    style: {
      fill: "#ffdcec",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 4.06500006,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1,
      paintOrder: "normal"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 252.488,
    cy: 165.275,
    r: 5.168,
    style: {
      fill: "#ff83ba",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 3.36817837,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1,
      paintOrder: "normal"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(.4006 0 0 .4006 60.192 27.41)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M258.725 156.021c0 3.444-2.793 10.112-6.237 10.112s-6.237-6.668-6.237-10.112a6.237 6.237 0 1 1 12.474 0",
    style: {
      fill: "#ffdcec",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 4.06500006,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1,
      paintOrder: "normal"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M263.041 168.904c-3.327.892-10.49-.08-11.382-3.407s4.827-7.75 8.154-8.641a6.237 6.237 0 1 1 3.228 12.048",
    style: {
      fill: "#ffdcec",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 4.06500006,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1,
      paintOrder: "normal"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M251.714 176.408c-1.722-2.983-2.638-10.153.345-11.876s8.735 2.656 10.457 5.64a6.237 6.237 0 1 1-10.802 6.236",
    style: {
      fill: "#ffdcec",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 4.06500006,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1,
      paintOrder: "normal"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M241.534 167.41c2.436-2.436 9.125-5.177 11.56-2.741s-.304 9.124-2.74 11.56a6.237 6.237 0 1 1-8.82-8.82",
    style: {
      fill: "#ffdcec",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 4.06500006,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1,
      paintOrder: "normal"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M247.592 155.247c2.983 1.722 7.361 7.474 5.639 10.457s-8.893 2.067-11.876.345a6.237 6.237 0 0 1 6.237-10.802",
    style: {
      fill: "#ffdcec",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 4.06500006,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1,
      paintOrder: "normal"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M247.592 155.247c2.983 1.722 7.361 7.474 5.639 10.457s-8.893 2.067-11.876.345a6.237 6.237 0 0 1 6.237-10.802",
    style: {
      fill: "#ffdcec",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 4.06500006,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1,
      paintOrder: "normal"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 252.488,
    cy: 165.275,
    r: 5.168,
    style: {
      fill: "#ff83ba",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 3.36817837,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1,
      paintOrder: "normal"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(.4006 0 0 .4006 60.192 27.41)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M258.725 156.021c0 3.444-2.793 10.112-6.237 10.112s-6.237-6.668-6.237-10.112a6.237 6.237 0 1 1 12.474 0",
    style: {
      fill: "#ffdcec",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 4.06500006,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1,
      paintOrder: "normal"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M263.041 168.904c-3.327.892-10.49-.08-11.382-3.407s4.827-7.75 8.154-8.641a6.237 6.237 0 1 1 3.228 12.048",
    style: {
      fill: "#ffdcec",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 4.06500006,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1,
      paintOrder: "normal"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M251.714 176.408c-1.722-2.983-2.638-10.153.345-11.876s8.735 2.656 10.457 5.64a6.237 6.237 0 1 1-10.802 6.236",
    style: {
      fill: "#ffdcec",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 4.06500006,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1,
      paintOrder: "normal"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M241.534 167.41c2.436-2.436 9.125-5.177 11.56-2.741s-.304 9.124-2.74 11.56a6.237 6.237 0 1 1-8.82-8.82",
    style: {
      fill: "#ffdcec",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 4.06500006,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1,
      paintOrder: "normal"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M247.592 155.247c2.983 1.722 7.361 7.474 5.639 10.457s-8.893 2.067-11.876.345a6.237 6.237 0 0 1 6.237-10.802",
    style: {
      fill: "#ffdcec",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 4.06500006,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1,
      paintOrder: "normal"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M247.592 155.247c2.983 1.722 7.361 7.474 5.639 10.457s-8.893 2.067-11.876.345a6.237 6.237 0 0 1 6.237-10.802",
    style: {
      fill: "#ffdcec",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 4.06500006,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1,
      paintOrder: "normal"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 252.488,
    cy: 165.275,
    r: 5.168,
    style: {
      fill: "#ff83ba",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 3.36817837,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1,
      paintOrder: "normal"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M171.828 322.825c2.05 6.881 7.208 20.524 4.81 26.848a3.5 3.5 0 0 1-.618 1.047c-.25.283-.552.502-.856.623-.497.198-1.283.198-2.289.29-2.995.278-5.755 1.792-7.719 4.003-1.956 2.203-3.089 5.02-3.39 7.898-.3 2.872.211 5.763 1.281 8.387 1.068 2.62 2.678 4.965 4.566 6.998a28.2 28.2 0 0 0 7.13 5.545l1.228-2.252a25.6 25.6 0 0 1-6.479-5.037c-1.713-1.845-3.14-3.942-4.07-6.223-.928-2.277-1.356-4.758-1.105-7.15.25-2.386 1.2-4.709 2.757-6.463 1.552-1.747 3.762-2.94 6.037-3.15.776-.072 1.84 0 3.004-.465a4.8 4.8 0 0 0 1.829-1.309 6.1 6.1 0 0 0 1.082-1.807c.495-1.264.592-2.54.636-3.695.33-8.626-2.493-17.305-7.834-24.088",
    style: {
      color: "#000",
      fontStyle: "normal",
      fontVariant: "normal",
      fontWeight: 400,
      fontStretch: "normal",
      fontSize: "medium",
      lineHeight: "normal",
      fontFamily: "sans-serif",
      fontVariantLigatures: "normal",
      fontVariantPosition: "normal",
      fontVariantCaps: "normal",
      fontVariantNumeric: "normal",
      fontVariantAlternates: "normal",
      fontFeatureSettings: "normal",
      textIndent: 0,
      textAlign: "start",
      textDecoration: "none",
      textDecorationLine: "none",
      textDecorationStyle: "solid",
      textDecorationColor: "#000",
      letterSpacing: "normal",
      wordSpacing: "normal",
      textTransform: "none",
      writingMode: "lr-tb",
      direction: "ltr",
      textOrientation: "mixed",
      dominantBaseline: "auto",
      baselineShift: "baseline",
      textAnchor: "start",
      whiteSpace: "normal",
      shapePadding: 0,
      clipRule: "nonzero",
      display: "inline",
      overflow: "visible",
      visibility: "visible",
      opacity: 1,
      isolation: "auto",
      mixBlendMode: "normal",
      colorInterpolation: "sRGB",
      colorInterpolationFilters: "linearRGB",
      solidColor: "#000",
      solidOpacity: 1,
      vectorEffect: "none",
      fill: "#542600",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 2.56500006,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1,
      colorRendering: "auto",
      imageRendering: "auto",
      shapeRendering: "auto",
      textRendering: "auto"
    },
    transform: "translate(-7.527 -283.71)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M123.484 295.952c-.715 4.508-1.657 9.537.362 13.631 1.754 3.56 4.375 6.5 7.07 9.158 2.693 2.656 5.493 5.079 7.873 7.776 5.173 5.86 8.57 13.36 9.108 21.103a32.5 32.5 0 0 1-.182 6.346l2.744.348c.29-2.282.355-4.59.195-6.885 2.014-8.278-2.4-15.65-7.948-21.937-2.545-2.884-7.24-6.149-9.846-8.72-2.605-2.568-3.91-3.31-7.337-7.514-2.936-4.691-.732-9.566-2.04-13.306",
    style: {
      color: "#000",
      fontStyle: "normal",
      fontVariant: "normal",
      fontWeight: 400,
      fontStretch: "normal",
      fontSize: "medium",
      lineHeight: "normal",
      fontFamily: "sans-serif",
      fontVariantLigatures: "normal",
      fontVariantPosition: "normal",
      fontVariantCaps: "normal",
      fontVariantNumeric: "normal",
      fontVariantAlternates: "normal",
      fontFeatureSettings: "normal",
      textIndent: 0,
      textAlign: "start",
      textDecoration: "none",
      textDecorationLine: "none",
      textDecorationStyle: "solid",
      textDecorationColor: "#000",
      letterSpacing: "normal",
      wordSpacing: "normal",
      textTransform: "none",
      writingMode: "lr-tb",
      direction: "ltr",
      textOrientation: "mixed",
      dominantBaseline: "auto",
      baselineShift: "baseline",
      textAnchor: "start",
      whiteSpace: "normal",
      shapePadding: 0,
      clipRule: "nonzero",
      display: "inline",
      overflow: "visible",
      visibility: "visible",
      opacity: 1,
      isolation: "auto",
      mixBlendMode: "normal",
      colorInterpolation: "sRGB",
      colorInterpolationFilters: "linearRGB",
      solidColor: "#000",
      solidOpacity: 1,
      vectorEffect: "none",
      fill: "#542600",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 2.76500034,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1,
      colorRendering: "auto",
      imageRendering: "auto",
      shapeRendering: "auto",
      textRendering: "auto"
    },
    transform: "translate(-7.527 -283.71)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.436 318.892a49.1 49.1 0 0 0 12.226 25.33c5.535 6.047 12.005 10.201 17.727 14.185 18.144 12.634 34.945 27.425 43.07 46.334 5.302 12.337 6.77 26.409 4.13 39.575l12.907 2.587c3.177-15.84 1.437-32.516-4.941-47.359-9.711-22.599-31.926-32.52-50.857-45.703-5.931-4.13-11.864-7.939-18.75-12.46-4.031-3.19-8.064-10.855-15.512-22.49",
    style: {
      color: "#000",
      fontStyle: "normal",
      fontVariant: "normal",
      fontWeight: 400,
      fontStretch: "normal",
      fontSize: "medium",
      lineHeight: "normal",
      fontFamily: "sans-serif",
      fontVariantLigatures: "normal",
      fontVariantPosition: "normal",
      fontVariantCaps: "normal",
      fontVariantNumeric: "normal",
      fontVariantAlternates: "normal",
      fontFeatureSettings: "normal",
      textIndent: 0,
      textAlign: "start",
      textDecoration: "none",
      textDecorationLine: "none",
      textDecorationStyle: "solid",
      textDecorationColor: "#000",
      letterSpacing: "normal",
      wordSpacing: "normal",
      textTransform: "none",
      writingMode: "lr-tb",
      direction: "ltr",
      textOrientation: "mixed",
      dominantBaseline: "auto",
      baselineShift: "baseline",
      textAnchor: "start",
      whiteSpace: "normal",
      shapePadding: 0,
      clipRule: "nonzero",
      display: "inline",
      overflow: "visible",
      visibility: "visible",
      opacity: 1,
      isolation: "auto",
      mixBlendMode: "normal",
      colorInterpolation: "sRGB",
      colorInterpolationFilters: "linearRGB",
      solidColor: "#000",
      solidOpacity: 1,
      vectorEffect: "none",
      fill: "#542600",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 13.16499996,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1,
      colorRendering: "auto",
      imageRendering: "auto",
      shapeRendering: "auto",
      textRendering: "auto"
    },
    transform: "translate(-7.527 -283.71)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M160.797 322.704c-.928 3.675.29 4.576-.937 8.166-.796 1.838-1.854 3.03-2.96 4.522-1.421 1.92-3.918 3.502-6.066 6.047-3.286 3.893-4.449 9.123-3.812 14.013.632 4.857 2.926 9.274 5.937 12.914 6.26 7.567 15.09 11.706 21.918 17.373 7.149 5.934 12.654 13.865 15.713 22.637s3.679 18.408 1.77 27.5l3.978.836a55.77 55.77 0 0 0-1.91-29.674 55.77 55.77 0 0 0-16.955-24.426c-7.366-6.113-15.883-10.19-21.381-16.837-2.625-3.173-4.532-6.937-5.041-10.848-.505-3.878.474-8.004 2.89-10.867 1.596-1.89 4.195-3.504 6.227-6.248a13.5 13.5 0 0 0 2.633-7.457 13.5 13.5 0 0 0-2.004-7.65",
    style: {
      color: "#000",
      fontStyle: "normal",
      fontVariant: "normal",
      fontWeight: 400,
      fontStretch: "normal",
      fontSize: "medium",
      lineHeight: "normal",
      fontFamily: "sans-serif",
      fontVariantLigatures: "normal",
      fontVariantPosition: "normal",
      fontVariantCaps: "normal",
      fontVariantNumeric: "normal",
      fontVariantAlternates: "normal",
      fontFeatureSettings: "normal",
      textIndent: 0,
      textAlign: "start",
      textDecoration: "none",
      textDecorationLine: "none",
      textDecorationStyle: "solid",
      textDecorationColor: "#000",
      letterSpacing: "normal",
      wordSpacing: "normal",
      textTransform: "none",
      writingMode: "lr-tb",
      direction: "ltr",
      textOrientation: "mixed",
      dominantBaseline: "auto",
      baselineShift: "baseline",
      textAnchor: "start",
      whiteSpace: "normal",
      shapePadding: 0,
      clipRule: "nonzero",
      display: "inline",
      overflow: "visible",
      visibility: "visible",
      opacity: 1,
      isolation: "auto",
      mixBlendMode: "normal",
      colorInterpolation: "sRGB",
      colorInterpolationFilters: "linearRGB",
      solidColor: "#000",
      solidOpacity: 1,
      vectorEffect: "none",
      fill: "#542600",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 4.06500006,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1,
      colorRendering: "auto",
      imageRendering: "auto",
      shapeRendering: "auto",
      textRendering: "auto"
    },
    transform: "translate(-7.527 -283.71)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(.4006 0 0 .4006 -2.121 -24.348)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M258.725 156.021c0 3.444-2.793 10.112-6.237 10.112s-6.237-6.668-6.237-10.112a6.237 6.237 0 1 1 12.474 0",
    style: {
      fill: "#ffdcec",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 4.06500006,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1,
      paintOrder: "normal"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M263.041 168.904c-3.327.892-10.49-.08-11.382-3.407s4.827-7.75 8.154-8.641a6.237 6.237 0 1 1 3.228 12.048",
    style: {
      fill: "#ffdcec",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 4.06500006,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1,
      paintOrder: "normal"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M251.714 176.408c-1.722-2.983-2.638-10.153.345-11.876s8.735 2.656 10.457 5.64a6.237 6.237 0 1 1-10.802 6.236",
    style: {
      fill: "#ffdcec",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 4.06500006,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1,
      paintOrder: "normal"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M241.534 167.41c2.436-2.436 9.125-5.177 11.56-2.741s-.304 9.124-2.74 11.56a6.237 6.237 0 1 1-8.82-8.82",
    style: {
      fill: "#ffdcec",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 4.06500006,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1,
      paintOrder: "normal"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M247.592 155.247c2.983 1.722 7.361 7.474 5.639 10.457s-8.893 2.067-11.876.345a6.237 6.237 0 0 1 6.237-10.802",
    style: {
      fill: "#ffdcec",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 4.06500006,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1,
      paintOrder: "normal"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M247.592 155.247c2.983 1.722 7.361 7.474 5.639 10.457s-8.893 2.067-11.876.345a6.237 6.237 0 0 1 6.237-10.802",
    style: {
      fill: "#ffdcec",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 4.06500006,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1,
      paintOrder: "normal"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 252.488,
    cy: 165.275,
    r: 5.168,
    style: {
      fill: "#ff83ba",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 3.36817837,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1,
      paintOrder: "normal"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(.4006 0 0 .4006 2.226 -12.442)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M258.725 156.021c0 3.444-2.793 10.112-6.237 10.112s-6.237-6.668-6.237-10.112a6.237 6.237 0 1 1 12.474 0",
    style: {
      fill: "#ffdcec",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 4.06500006,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1,
      paintOrder: "normal"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M263.041 168.904c-3.327.892-10.49-.08-11.382-3.407s4.827-7.75 8.154-8.641a6.237 6.237 0 1 1 3.228 12.048",
    style: {
      fill: "#ffdcec",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 4.06500006,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1,
      paintOrder: "normal"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M251.714 176.408c-1.722-2.983-2.638-10.153.345-11.876s8.735 2.656 10.457 5.64a6.237 6.237 0 1 1-10.802 6.236",
    style: {
      fill: "#ffdcec",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 4.06500006,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1,
      paintOrder: "normal"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M241.534 167.41c2.436-2.436 9.125-5.177 11.56-2.741s-.304 9.124-2.74 11.56a6.237 6.237 0 1 1-8.82-8.82",
    style: {
      fill: "#ffdcec",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 4.06500006,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1,
      paintOrder: "normal"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M247.592 155.247c2.983 1.722 7.361 7.474 5.639 10.457s-8.893 2.067-11.876.345a6.237 6.237 0 0 1 6.237-10.802",
    style: {
      fill: "#ffdcec",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 4.06500006,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1,
      paintOrder: "normal"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M247.592 155.247c2.983 1.722 7.361 7.474 5.639 10.457s-8.893 2.067-11.876.345a6.237 6.237 0 0 1 6.237-10.802",
    style: {
      fill: "#ffdcec",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 4.06500006,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1,
      paintOrder: "normal"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 252.488,
    cy: 165.275,
    r: 5.168,
    style: {
      fill: "#ff83ba",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 3.36817837,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1,
      paintOrder: "normal"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(.4006 0 0 .4006 4.579 -31.856)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M258.725 156.021c0 3.444-2.793 10.112-6.237 10.112s-6.237-6.668-6.237-10.112a6.237 6.237 0 1 1 12.474 0",
    style: {
      fill: "#ffdcec",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 4.06500006,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1,
      paintOrder: "normal"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M263.041 168.904c-3.327.892-10.49-.08-11.382-3.407s4.827-7.75 8.154-8.641a6.237 6.237 0 1 1 3.228 12.048",
    style: {
      fill: "#ffdcec",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 4.06500006,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1,
      paintOrder: "normal"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M251.714 176.408c-1.722-2.983-2.638-10.153.345-11.876s8.735 2.656 10.457 5.64a6.237 6.237 0 1 1-10.802 6.236",
    style: {
      fill: "#ffdcec",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 4.06500006,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1,
      paintOrder: "normal"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M241.534 167.41c2.436-2.436 9.125-5.177 11.56-2.741s-.304 9.124-2.74 11.56a6.237 6.237 0 1 1-8.82-8.82",
    style: {
      fill: "#ffdcec",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 4.06500006,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1,
      paintOrder: "normal"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M247.592 155.247c2.983 1.722 7.361 7.474 5.639 10.457s-8.893 2.067-11.876.345a6.237 6.237 0 0 1 6.237-10.802",
    style: {
      fill: "#ffdcec",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 4.06500006,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1,
      paintOrder: "normal"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M247.592 155.247c2.983 1.722 7.361 7.474 5.639 10.457s-8.893 2.067-11.876.345a6.237 6.237 0 0 1 6.237-10.802",
    style: {
      fill: "#ffdcec",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 4.06500006,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1,
      paintOrder: "normal"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 252.488,
    cy: 165.275,
    r: 5.168,
    style: {
      fill: "#ff83ba",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 3.36817837,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1,
      paintOrder: "normal"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(.4006 0 0 .4006 6.761 9.103)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M258.725 156.021c0 3.444-2.793 10.112-6.237 10.112s-6.237-6.668-6.237-10.112a6.237 6.237 0 1 1 12.474 0",
    style: {
      fill: "#ffdcec",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 4.06500006,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1,
      paintOrder: "normal"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M263.041 168.904c-3.327.892-10.49-.08-11.382-3.407s4.827-7.75 8.154-8.641a6.237 6.237 0 1 1 3.228 12.048",
    style: {
      fill: "#ffdcec",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 4.06500006,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1,
      paintOrder: "normal"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M251.714 176.408c-1.722-2.983-2.638-10.153.345-11.876s8.735 2.656 10.457 5.64a6.237 6.237 0 1 1-10.802 6.236",
    style: {
      fill: "#ffdcec",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 4.06500006,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1,
      paintOrder: "normal"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M241.534 167.41c2.436-2.436 9.125-5.177 11.56-2.741s-.304 9.124-2.74 11.56a6.237 6.237 0 1 1-8.82-8.82",
    style: {
      fill: "#ffdcec",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 4.06500006,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1,
      paintOrder: "normal"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M247.592 155.247c2.983 1.722 7.361 7.474 5.639 10.457s-8.893 2.067-11.876.345a6.237 6.237 0 0 1 6.237-10.802",
    style: {
      fill: "#ffdcec",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 4.06500006,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1,
      paintOrder: "normal"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M247.592 155.247c2.983 1.722 7.361 7.474 5.639 10.457s-8.893 2.067-11.876.345a6.237 6.237 0 0 1 6.237-10.802",
    style: {
      fill: "#ffdcec",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 4.06500006,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1,
      paintOrder: "normal"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 252.488,
    cy: 165.275,
    r: 5.168,
    style: {
      fill: "#ff83ba",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 3.36817837,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1,
      paintOrder: "normal"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(.4006 0 0 .4006 18.668 5.134)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M258.725 156.021c0 3.444-2.793 10.112-6.237 10.112s-6.237-6.668-6.237-10.112a6.237 6.237 0 1 1 12.474 0",
    style: {
      fill: "#ffdcec",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 4.06500006,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1,
      paintOrder: "normal"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M263.041 168.904c-3.327.892-10.49-.08-11.382-3.407s4.827-7.75 8.154-8.641a6.237 6.237 0 1 1 3.228 12.048",
    style: {
      fill: "#ffdcec",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 4.06500006,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1,
      paintOrder: "normal"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M251.714 176.408c-1.722-2.983-2.638-10.153.345-11.876s8.735 2.656 10.457 5.64a6.237 6.237 0 1 1-10.802 6.236",
    style: {
      fill: "#ffdcec",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 4.06500006,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1,
      paintOrder: "normal"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M241.534 167.41c2.436-2.436 9.125-5.177 11.56-2.741s-.304 9.124-2.74 11.56a6.237 6.237 0 1 1-8.82-8.82",
    style: {
      fill: "#ffdcec",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 4.06500006,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1,
      paintOrder: "normal"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M247.592 155.247c2.983 1.722 7.361 7.474 5.639 10.457s-8.893 2.067-11.876.345a6.237 6.237 0 0 1 6.237-10.802",
    style: {
      fill: "#ffdcec",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 4.06500006,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1,
      paintOrder: "normal"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M247.592 155.247c2.983 1.722 7.361 7.474 5.639 10.457s-8.893 2.067-11.876.345a6.237 6.237 0 0 1 6.237-10.802",
    style: {
      fill: "#ffdcec",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 4.06500006,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1,
      paintOrder: "normal"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 252.488,
    cy: 165.275,
    r: 5.168,
    style: {
      fill: "#ff83ba",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 3.36817837,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1,
      paintOrder: "normal"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(.4006 0 0 .4006 36.14 16.524)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M258.725 156.021c0 3.444-2.793 10.112-6.237 10.112s-6.237-6.668-6.237-10.112a6.237 6.237 0 1 1 12.474 0",
    style: {
      fill: "#ffdcec",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 4.06500006,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1,
      paintOrder: "normal"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M263.041 168.904c-3.327.892-10.49-.08-11.382-3.407s4.827-7.75 8.154-8.641a6.237 6.237 0 1 1 3.228 12.048",
    style: {
      fill: "#ffdcec",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 4.06500006,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1,
      paintOrder: "normal"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M251.714 176.408c-1.722-2.983-2.638-10.153.345-11.876s8.735 2.656 10.457 5.64a6.237 6.237 0 1 1-10.802 6.236",
    style: {
      fill: "#ffdcec",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 4.06500006,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1,
      paintOrder: "normal"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M241.534 167.41c2.436-2.436 9.125-5.177 11.56-2.741s-.304 9.124-2.74 11.56a6.237 6.237 0 1 1-8.82-8.82",
    style: {
      fill: "#ffdcec",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 4.06500006,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1,
      paintOrder: "normal"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M247.592 155.247c2.983 1.722 7.361 7.474 5.639 10.457s-8.893 2.067-11.876.345a6.237 6.237 0 0 1 6.237-10.802",
    style: {
      fill: "#ffdcec",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 4.06500006,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1,
      paintOrder: "normal"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M247.592 155.247c2.983 1.722 7.361 7.474 5.639 10.457s-8.893 2.067-11.876.345a6.237 6.237 0 0 1 6.237-10.802",
    style: {
      fill: "#ffdcec",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 4.06500006,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1,
      paintOrder: "normal"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 252.488,
    cy: 165.275,
    r: 5.168,
    style: {
      fill: "#ff83ba",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 3.36817837,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1,
      paintOrder: "normal"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(.4006 0 0 .4006 49.18 -24.297)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M258.725 156.021c0 3.444-2.793 10.112-6.237 10.112s-6.237-6.668-6.237-10.112a6.237 6.237 0 1 1 12.474 0",
    style: {
      fill: "#ffdcec",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 4.06500006,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1,
      paintOrder: "normal"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M263.041 168.904c-3.327.892-10.49-.08-11.382-3.407s4.827-7.75 8.154-8.641a6.237 6.237 0 1 1 3.228 12.048",
    style: {
      fill: "#ffdcec",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 4.06500006,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1,
      paintOrder: "normal"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M251.714 176.408c-1.722-2.983-2.638-10.153.345-11.876s8.735 2.656 10.457 5.64a6.237 6.237 0 1 1-10.802 6.236",
    style: {
      fill: "#ffdcec",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 4.06500006,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1,
      paintOrder: "normal"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M241.534 167.41c2.436-2.436 9.125-5.177 11.56-2.741s-.304 9.124-2.74 11.56a6.237 6.237 0 1 1-8.82-8.82",
    style: {
      fill: "#ffdcec",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 4.06500006,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1,
      paintOrder: "normal"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M247.592 155.247c2.983 1.722 7.361 7.474 5.639 10.457s-8.893 2.067-11.876.345a6.237 6.237 0 0 1 6.237-10.802",
    style: {
      fill: "#ffdcec",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 4.06500006,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1,
      paintOrder: "normal"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M247.592 155.247c2.983 1.722 7.361 7.474 5.639 10.457s-8.893 2.067-11.876.345a6.237 6.237 0 0 1 6.237-10.802",
    style: {
      fill: "#ffdcec",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 4.06500006,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1,
      paintOrder: "normal"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 252.488,
    cy: 165.275,
    r: 5.168,
    style: {
      fill: "#ff83ba",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 3.36817837,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1,
      paintOrder: "normal"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(.4006 0 0 .4006 53.527 -11.635)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M258.725 156.021c0 3.444-2.793 10.112-6.237 10.112s-6.237-6.668-6.237-10.112a6.237 6.237 0 1 1 12.474 0",
    style: {
      fill: "#ffdcec",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 4.06500006,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1,
      paintOrder: "normal"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M263.041 168.904c-3.327.892-10.49-.08-11.382-3.407s4.827-7.75 8.154-8.641a6.237 6.237 0 1 1 3.228 12.048",
    style: {
      fill: "#ffdcec",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 4.06500006,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1,
      paintOrder: "normal"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M251.714 176.408c-1.722-2.983-2.638-10.153.345-11.876s8.735 2.656 10.457 5.64a6.237 6.237 0 1 1-10.802 6.236",
    style: {
      fill: "#ffdcec",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 4.06500006,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1,
      paintOrder: "normal"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M241.534 167.41c2.436-2.436 9.125-5.177 11.56-2.741s-.304 9.124-2.74 11.56a6.237 6.237 0 1 1-8.82-8.82",
    style: {
      fill: "#ffdcec",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 4.06500006,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1,
      paintOrder: "normal"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M247.592 155.247c2.983 1.722 7.361 7.474 5.639 10.457s-8.893 2.067-11.876.345a6.237 6.237 0 0 1 6.237-10.802",
    style: {
      fill: "#ffdcec",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 4.06500006,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1,
      paintOrder: "normal"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M247.592 155.247c2.983 1.722 7.361 7.474 5.639 10.457s-8.893 2.067-11.876.345a6.237 6.237 0 0 1 6.237-10.802",
    style: {
      fill: "#ffdcec",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 4.06500006,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1,
      paintOrder: "normal"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 252.488,
    cy: 165.275,
    r: 5.168,
    style: {
      fill: "#ff83ba",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 3.36817837,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1,
      paintOrder: "normal"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(.4006 0 0 .4006 35.299 5.134)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M258.725 156.021c0 3.444-2.793 10.112-6.237 10.112s-6.237-6.668-6.237-10.112a6.237 6.237 0 1 1 12.474 0",
    style: {
      fill: "#ffdcec",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 4.06500006,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1,
      paintOrder: "normal"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M263.041 168.904c-3.327.892-10.49-.08-11.382-3.407s4.827-7.75 8.154-8.641a6.237 6.237 0 1 1 3.228 12.048",
    style: {
      fill: "#ffdcec",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 4.06500006,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1,
      paintOrder: "normal"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M251.714 176.408c-1.722-2.983-2.638-10.153.345-11.876s8.735 2.656 10.457 5.64a6.237 6.237 0 1 1-10.802 6.236",
    style: {
      fill: "#ffdcec",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 4.06500006,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1,
      paintOrder: "normal"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M241.534 167.41c2.436-2.436 9.125-5.177 11.56-2.741s-.304 9.124-2.74 11.56a6.237 6.237 0 1 1-8.82-8.82",
    style: {
      fill: "#ffdcec",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 4.06500006,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1,
      paintOrder: "normal"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M247.592 155.247c2.983 1.722 7.361 7.474 5.639 10.457s-8.893 2.067-11.876.345a6.237 6.237 0 0 1 6.237-10.802",
    style: {
      fill: "#ffdcec",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 4.06500006,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1,
      paintOrder: "normal"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M247.592 155.247c2.983 1.722 7.361 7.474 5.639 10.457s-8.893 2.067-11.876.345a6.237 6.237 0 0 1 6.237-10.802",
    style: {
      fill: "#ffdcec",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 4.06500006,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1,
      paintOrder: "normal"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 252.488,
    cy: 165.275,
    r: 5.168,
    style: {
      fill: "#ff83ba",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 3.36817837,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1,
      paintOrder: "normal"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(.4006 0 0 .4006 53.905 15.013)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M258.725 156.021c0 3.444-2.793 10.112-6.237 10.112s-6.237-6.668-6.237-10.112a6.237 6.237 0 1 1 12.474 0",
    style: {
      fill: "#ffdcec",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 4.06500006,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1,
      paintOrder: "normal"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M263.041 168.904c-3.327.892-10.49-.08-11.382-3.407s4.827-7.75 8.154-8.641a6.237 6.237 0 1 1 3.228 12.048",
    style: {
      fill: "#ffdcec",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 4.06500006,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1,
      paintOrder: "normal"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M251.714 176.408c-1.722-2.983-2.638-10.153.345-11.876s8.735 2.656 10.457 5.64a6.237 6.237 0 1 1-10.802 6.236",
    style: {
      fill: "#ffdcec",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 4.06500006,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1,
      paintOrder: "normal"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M241.534 167.41c2.436-2.436 9.125-5.177 11.56-2.741s-.304 9.124-2.74 11.56a6.237 6.237 0 1 1-8.82-8.82",
    style: {
      fill: "#ffdcec",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 4.06500006,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1,
      paintOrder: "normal"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M247.592 155.247c2.983 1.722 7.361 7.474 5.639 10.457s-8.893 2.067-11.876.345a6.237 6.237 0 0 1 6.237-10.802",
    style: {
      fill: "#ffdcec",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 4.06500006,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1,
      paintOrder: "normal"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M247.592 155.247c2.983 1.722 7.361 7.474 5.639 10.457s-8.893 2.067-11.876.345a6.237 6.237 0 0 1 6.237-10.802",
    style: {
      fill: "#ffdcec",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 4.06500006,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1,
      paintOrder: "normal"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 252.488,
    cy: 165.275,
    r: 5.168,
    style: {
      fill: "#ff83ba",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 3.36817837,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1,
      paintOrder: "normal"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(.4006 0 0 .4006 50.692 28.809)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M258.725 156.021c0 3.444-2.793 10.112-6.237 10.112s-6.237-6.668-6.237-10.112a6.237 6.237 0 1 1 12.474 0",
    style: {
      fill: "#ffdcec",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 4.06500006,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1,
      paintOrder: "normal"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M263.041 168.904c-3.327.892-10.49-.08-11.382-3.407s4.827-7.75 8.154-8.641a6.237 6.237 0 1 1 3.228 12.048",
    style: {
      fill: "#ffdcec",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 4.06500006,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1,
      paintOrder: "normal"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M251.714 176.408c-1.722-2.983-2.638-10.153.345-11.876s8.735 2.656 10.457 5.64a6.237 6.237 0 1 1-10.802 6.236",
    style: {
      fill: "#ffdcec",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 4.06500006,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1,
      paintOrder: "normal"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M241.534 167.41c2.436-2.436 9.125-5.177 11.56-2.741s-.304 9.124-2.74 11.56a6.237 6.237 0 1 1-8.82-8.82",
    style: {
      fill: "#ffdcec",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 4.06500006,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1,
      paintOrder: "normal"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M247.592 155.247c2.983 1.722 7.361 7.474 5.639 10.457s-8.893 2.067-11.876.345a6.237 6.237 0 0 1 6.237-10.802",
    style: {
      fill: "#ffdcec",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 4.06500006,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1,
      paintOrder: "normal"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M247.592 155.247c2.983 1.722 7.361 7.474 5.639 10.457s-8.893 2.067-11.876.345a6.237 6.237 0 0 1 6.237-10.802",
    style: {
      fill: "#ffdcec",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 4.06500006,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1,
      paintOrder: "normal"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 252.488,
    cy: 165.275,
    r: 5.168,
    style: {
      fill: "#ff83ba",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 3.36817837,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1,
      paintOrder: "normal"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(.4006 0 0 .4006 24.904 -18.49)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M258.725 156.021c0 3.444-2.793 10.112-6.237 10.112s-6.237-6.668-6.237-10.112a6.237 6.237 0 1 1 12.474 0",
    style: {
      fill: "#ffdcec",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 4.06500006,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1,
      paintOrder: "normal"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M263.041 168.904c-3.327.892-10.49-.08-11.382-3.407s4.827-7.75 8.154-8.641a6.237 6.237 0 1 1 3.228 12.048",
    style: {
      fill: "#ffdcec",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 4.06500006,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1,
      paintOrder: "normal"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M251.714 176.408c-1.722-2.983-2.638-10.153.345-11.876s8.735 2.656 10.457 5.64a6.237 6.237 0 1 1-10.802 6.236",
    style: {
      fill: "#ffdcec",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 4.06500006,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1,
      paintOrder: "normal"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M241.534 167.41c2.436-2.436 9.125-5.177 11.56-2.741s-.304 9.124-2.74 11.56a6.237 6.237 0 1 1-8.82-8.82",
    style: {
      fill: "#ffdcec",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 4.06500006,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1,
      paintOrder: "normal"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M247.592 155.247c2.983 1.722 7.361 7.474 5.639 10.457s-8.893 2.067-11.876.345a6.237 6.237 0 0 1 6.237-10.802",
    style: {
      fill: "#ffdcec",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 4.06500006,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1,
      paintOrder: "normal"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M247.592 155.247c2.983 1.722 7.361 7.474 5.639 10.457s-8.893 2.067-11.876.345a6.237 6.237 0 0 1 6.237-10.802",
    style: {
      fill: "#ffdcec",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 4.06500006,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1,
      paintOrder: "normal"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 252.488,
    cy: 165.275,
    r: 5.168,
    style: {
      fill: "#ff83ba",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 3.36817837,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1,
      paintOrder: "normal"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(.4006 0 0 .4006 39.258 -42.534)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M258.725 156.021c0 3.444-2.793 10.112-6.237 10.112s-6.237-6.668-6.237-10.112a6.237 6.237 0 1 1 12.474 0",
    style: {
      fill: "#ffdcec",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 4.06500006,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1,
      paintOrder: "normal"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M263.041 168.904c-3.327.892-10.49-.08-11.382-3.407s4.827-7.75 8.154-8.641a6.237 6.237 0 1 1 3.228 12.048",
    style: {
      fill: "#ffdcec",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 4.06500006,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1,
      paintOrder: "normal"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M251.714 176.408c-1.722-2.983-2.638-10.153.345-11.876s8.735 2.656 10.457 5.64a6.237 6.237 0 1 1-10.802 6.236",
    style: {
      fill: "#ffdcec",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 4.06500006,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1,
      paintOrder: "normal"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M241.534 167.41c2.436-2.436 9.125-5.177 11.56-2.741s-.304 9.124-2.74 11.56a6.237 6.237 0 1 1-8.82-8.82",
    style: {
      fill: "#ffdcec",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 4.06500006,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1,
      paintOrder: "normal"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M247.592 155.247c2.983 1.722 7.361 7.474 5.639 10.457s-8.893 2.067-11.876.345a6.237 6.237 0 0 1 6.237-10.802",
    style: {
      fill: "#ffdcec",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 4.06500006,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1,
      paintOrder: "normal"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M247.592 155.247c2.983 1.722 7.361 7.474 5.639 10.457s-8.893 2.067-11.876.345a6.237 6.237 0 0 1 6.237-10.802",
    style: {
      fill: "#ffdcec",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 4.06500006,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1,
      paintOrder: "normal"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 252.488,
    cy: 165.275,
    r: 5.168,
    style: {
      fill: "#ff83ba",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 3.36817837,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1,
      paintOrder: "normal"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(.4006 0 0 .4006 67.228 -32.329)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M258.725 156.021c0 3.444-2.793 10.112-6.237 10.112s-6.237-6.668-6.237-10.112a6.237 6.237 0 1 1 12.474 0",
    style: {
      fill: "#ffdcec",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 4.06500006,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1,
      paintOrder: "normal"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M263.041 168.904c-3.327.892-10.49-.08-11.382-3.407s4.827-7.75 8.154-8.641a6.237 6.237 0 1 1 3.228 12.048",
    style: {
      fill: "#ffdcec",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 4.06500006,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1,
      paintOrder: "normal"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M251.714 176.408c-1.722-2.983-2.638-10.153.345-11.876s8.735 2.656 10.457 5.64a6.237 6.237 0 1 1-10.802 6.236",
    style: {
      fill: "#ffdcec",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 4.06500006,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1,
      paintOrder: "normal"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M241.534 167.41c2.436-2.436 9.125-5.177 11.56-2.741s-.304 9.124-2.74 11.56a6.237 6.237 0 1 1-8.82-8.82",
    style: {
      fill: "#ffdcec",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 4.06500006,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1,
      paintOrder: "normal"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M247.592 155.247c2.983 1.722 7.361 7.474 5.639 10.457s-8.893 2.067-11.876.345a6.237 6.237 0 0 1 6.237-10.802",
    style: {
      fill: "#ffdcec",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 4.06500006,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1,
      paintOrder: "normal"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M247.592 155.247c2.983 1.722 7.361 7.474 5.639 10.457s-8.893 2.067-11.876.345a6.237 6.237 0 0 1 6.237-10.802",
    style: {
      fill: "#ffdcec",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 4.06500006,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1,
      paintOrder: "normal"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 252.488,
    cy: 165.275,
    r: 5.168,
    style: {
      fill: "#ff83ba",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 3.36817837,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1,
      paintOrder: "normal"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(.4006 0 0 .4006 13.126 -53.152)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M258.725 156.021c0 3.444-2.793 10.112-6.237 10.112s-6.237-6.668-6.237-10.112a6.237 6.237 0 1 1 12.474 0",
    style: {
      fill: "#ffdcec",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 4.06500006,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1,
      paintOrder: "normal"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M263.041 168.904c-3.327.892-10.49-.08-11.382-3.407s4.827-7.75 8.154-8.641a6.237 6.237 0 1 1 3.228 12.048",
    style: {
      fill: "#ffdcec",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 4.06500006,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1,
      paintOrder: "normal"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M251.714 176.408c-1.722-2.983-2.638-10.153.345-11.876s8.735 2.656 10.457 5.64a6.237 6.237 0 1 1-10.802 6.236",
    style: {
      fill: "#ffdcec",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 4.06500006,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1,
      paintOrder: "normal"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M241.534 167.41c2.436-2.436 9.125-5.177 11.56-2.741s-.304 9.124-2.74 11.56a6.237 6.237 0 1 1-8.82-8.82",
    style: {
      fill: "#ffdcec",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 4.06500006,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1,
      paintOrder: "normal"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M247.592 155.247c2.983 1.722 7.361 7.474 5.639 10.457s-8.893 2.067-11.876.345a6.237 6.237 0 0 1 6.237-10.802",
    style: {
      fill: "#ffdcec",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 4.06500006,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1,
      paintOrder: "normal"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M247.592 155.247c2.983 1.722 7.361 7.474 5.639 10.457s-8.893 2.067-11.876.345a6.237 6.237 0 0 1 6.237-10.802",
    style: {
      fill: "#ffdcec",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 4.06500006,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1,
      paintOrder: "normal"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 252.488,
    cy: 165.275,
    r: 5.168,
    style: {
      fill: "#ff83ba",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 3.36817837,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1,
      paintOrder: "normal"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(.4006 0 0 .4006 20.836 -7.67)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M258.725 156.021c0 3.444-2.793 10.112-6.237 10.112s-6.237-6.668-6.237-10.112a6.237 6.237 0 1 1 12.474 0",
    style: {
      fill: "#ffdcec",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 4.06500006,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1,
      paintOrder: "normal"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M263.041 168.904c-3.327.892-10.49-.08-11.382-3.407s4.827-7.75 8.154-8.641a6.237 6.237 0 1 1 3.228 12.048",
    style: {
      fill: "#ffdcec",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 4.06500006,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1,
      paintOrder: "normal"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M251.714 176.408c-1.722-2.983-2.638-10.153.345-11.876s8.735 2.656 10.457 5.64a6.237 6.237 0 1 1-10.802 6.236",
    style: {
      fill: "#ffdcec",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 4.06500006,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1,
      paintOrder: "normal"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M241.534 167.41c2.436-2.436 9.125-5.177 11.56-2.741s-.304 9.124-2.74 11.56a6.237 6.237 0 1 1-8.82-8.82",
    style: {
      fill: "#ffdcec",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 4.06500006,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1,
      paintOrder: "normal"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M247.592 155.247c2.983 1.722 7.361 7.474 5.639 10.457s-8.893 2.067-11.876.345a6.237 6.237 0 0 1 6.237-10.802",
    style: {
      fill: "#ffdcec",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 4.06500006,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1,
      paintOrder: "normal"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M247.592 155.247c2.983 1.722 7.361 7.474 5.639 10.457s-8.893 2.067-11.876.345a6.237 6.237 0 0 1 6.237-10.802",
    style: {
      fill: "#ffdcec",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 4.06500006,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1,
      paintOrder: "normal"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 252.488,
    cy: 165.275,
    r: 5.168,
    style: {
      fill: "#ff83ba",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 3.36817837,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1,
      paintOrder: "normal"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(.4006 0 0 .4006 11.749 -10.877)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M258.725 156.021c0 3.444-2.793 10.112-6.237 10.112s-6.237-6.668-6.237-10.112a6.237 6.237 0 1 1 12.474 0",
    style: {
      fill: "#ffdcec",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 4.06500006,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1,
      paintOrder: "normal"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M263.041 168.904c-3.327.892-10.49-.08-11.382-3.407s4.827-7.75 8.154-8.641a6.237 6.237 0 1 1 3.228 12.048",
    style: {
      fill: "#ffdcec",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 4.06500006,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1,
      paintOrder: "normal"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M251.714 176.408c-1.722-2.983-2.638-10.153.345-11.876s8.735 2.656 10.457 5.64a6.237 6.237 0 1 1-10.802 6.236",
    style: {
      fill: "#ffdcec",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 4.06500006,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1,
      paintOrder: "normal"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M241.534 167.41c2.436-2.436 9.125-5.177 11.56-2.741s-.304 9.124-2.74 11.56a6.237 6.237 0 1 1-8.82-8.82",
    style: {
      fill: "#ffdcec",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 4.06500006,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1,
      paintOrder: "normal"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M247.592 155.247c2.983 1.722 7.361 7.474 5.639 10.457s-8.893 2.067-11.876.345a6.237 6.237 0 0 1 6.237-10.802",
    style: {
      fill: "#ffdcec",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 4.06500006,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1,
      paintOrder: "normal"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M247.592 155.247c2.983 1.722 7.361 7.474 5.639 10.457s-8.893 2.067-11.876.345a6.237 6.237 0 0 1 6.237-10.802",
    style: {
      fill: "#ffdcec",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 4.06500006,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1,
      paintOrder: "normal"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 252.488,
    cy: 165.275,
    r: 5.168,
    style: {
      fill: "#ff83ba",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 3.36817837,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1,
      paintOrder: "normal"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(.4006 0 0 .4006 8.809 -.72)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M258.725 156.021c0 3.444-2.793 10.112-6.237 10.112s-6.237-6.668-6.237-10.112a6.237 6.237 0 1 1 12.474 0",
    style: {
      fill: "#ffdcec",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 4.06500006,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1,
      paintOrder: "normal"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M263.041 168.904c-3.327.892-10.49-.08-11.382-3.407s4.827-7.75 8.154-8.641a6.237 6.237 0 1 1 3.228 12.048",
    style: {
      fill: "#ffdcec",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 4.06500006,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1,
      paintOrder: "normal"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M251.714 176.408c-1.722-2.983-2.638-10.153.345-11.876s8.735 2.656 10.457 5.64a6.237 6.237 0 1 1-10.802 6.236",
    style: {
      fill: "#ffdcec",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 4.06500006,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1,
      paintOrder: "normal"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M241.534 167.41c2.436-2.436 9.125-5.177 11.56-2.741s-.304 9.124-2.74 11.56a6.237 6.237 0 1 1-8.82-8.82",
    style: {
      fill: "#ffdcec",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 4.06500006,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1,
      paintOrder: "normal"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M247.592 155.247c2.983 1.722 7.361 7.474 5.639 10.457s-8.893 2.067-11.876.345a6.237 6.237 0 0 1 6.237-10.802",
    style: {
      fill: "#ffdcec",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 4.06500006,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1,
      paintOrder: "normal"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M247.592 155.247c2.983 1.722 7.361 7.474 5.639 10.457s-8.893 2.067-11.876.345a6.237 6.237 0 0 1 6.237-10.802",
    style: {
      fill: "#ffdcec",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 4.06500006,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1,
      paintOrder: "normal"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 252.488,
    cy: 165.275,
    r: 5.168,
    style: {
      fill: "#ff83ba",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 3.36817837,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1,
      paintOrder: "normal"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(.4006 0 0 .4006 26.85 3.289)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M258.725 156.021c0 3.444-2.793 10.112-6.237 10.112s-6.237-6.668-6.237-10.112a6.237 6.237 0 1 1 12.474 0",
    style: {
      fill: "#ffdcec",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 4.06500006,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1,
      paintOrder: "normal"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M263.041 168.904c-3.327.892-10.49-.08-11.382-3.407s4.827-7.75 8.154-8.641a6.237 6.237 0 1 1 3.228 12.048",
    style: {
      fill: "#ffdcec",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 4.06500006,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1,
      paintOrder: "normal"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M251.714 176.408c-1.722-2.983-2.638-10.153.345-11.876s8.735 2.656 10.457 5.64a6.237 6.237 0 1 1-10.802 6.236",
    style: {
      fill: "#ffdcec",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 4.06500006,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1,
      paintOrder: "normal"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M241.534 167.41c2.436-2.436 9.125-5.177 11.56-2.741s-.304 9.124-2.74 11.56a6.237 6.237 0 1 1-8.82-8.82",
    style: {
      fill: "#ffdcec",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 4.06500006,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1,
      paintOrder: "normal"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M247.592 155.247c2.983 1.722 7.361 7.474 5.639 10.457s-8.893 2.067-11.876.345a6.237 6.237 0 0 1 6.237-10.802",
    style: {
      fill: "#ffdcec",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 4.06500006,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1,
      paintOrder: "normal"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M247.592 155.247c2.983 1.722 7.361 7.474 5.639 10.457s-8.893 2.067-11.876.345a6.237 6.237 0 0 1 6.237-10.802",
    style: {
      fill: "#ffdcec",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 4.06500006,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1,
      paintOrder: "normal"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 252.488,
    cy: 165.275,
    r: 5.168,
    style: {
      fill: "#ff83ba",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 3.36817837,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1,
      paintOrder: "normal"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(.4006 0 0 .4006 35.268 -7.402)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M258.725 156.021c0 3.444-2.793 10.112-6.237 10.112s-6.237-6.668-6.237-10.112a6.237 6.237 0 1 1 12.474 0",
    style: {
      fill: "#ffdcec",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 4.06500006,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1,
      paintOrder: "normal"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M263.041 168.904c-3.327.892-10.49-.08-11.382-3.407s4.827-7.75 8.154-8.641a6.237 6.237 0 1 1 3.228 12.048",
    style: {
      fill: "#ffdcec",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 4.06500006,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1,
      paintOrder: "normal"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M251.714 176.408c-1.722-2.983-2.638-10.153.345-11.876s8.735 2.656 10.457 5.64a6.237 6.237 0 1 1-10.802 6.236",
    style: {
      fill: "#ffdcec",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 4.06500006,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1,
      paintOrder: "normal"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M241.534 167.41c2.436-2.436 9.125-5.177 11.56-2.741s-.304 9.124-2.74 11.56a6.237 6.237 0 1 1-8.82-8.82",
    style: {
      fill: "#ffdcec",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 4.06500006,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1,
      paintOrder: "normal"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M247.592 155.247c2.983 1.722 7.361 7.474 5.639 10.457s-8.893 2.067-11.876.345a6.237 6.237 0 0 1 6.237-10.802",
    style: {
      fill: "#ffdcec",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 4.06500006,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1,
      paintOrder: "normal"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M247.592 155.247c2.983 1.722 7.361 7.474 5.639 10.457s-8.893 2.067-11.876.345a6.237 6.237 0 0 1 6.237-10.802",
    style: {
      fill: "#ffdcec",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 4.06500006,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1,
      paintOrder: "normal"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 252.488,
    cy: 165.275,
    r: 5.168,
    style: {
      fill: "#ff83ba",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 3.36817837,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1,
      paintOrder: "normal"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(.4006 0 0 .4006 15.223 -21.968)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M258.725 156.021c0 3.444-2.793 10.112-6.237 10.112s-6.237-6.668-6.237-10.112a6.237 6.237 0 1 1 12.474 0",
    style: {
      fill: "#ffdcec",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 4.06500006,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1,
      paintOrder: "normal"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M263.041 168.904c-3.327.892-10.49-.08-11.382-3.407s4.827-7.75 8.154-8.641a6.237 6.237 0 1 1 3.228 12.048",
    style: {
      fill: "#ffdcec",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 4.06500006,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1,
      paintOrder: "normal"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M251.714 176.408c-1.722-2.983-2.638-10.153.345-11.876s8.735 2.656 10.457 5.64a6.237 6.237 0 1 1-10.802 6.236",
    style: {
      fill: "#ffdcec",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 4.06500006,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1,
      paintOrder: "normal"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M241.534 167.41c2.436-2.436 9.125-5.177 11.56-2.741s-.304 9.124-2.74 11.56a6.237 6.237 0 1 1-8.82-8.82",
    style: {
      fill: "#ffdcec",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 4.06500006,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1,
      paintOrder: "normal"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M247.592 155.247c2.983 1.722 7.361 7.474 5.639 10.457s-8.893 2.067-11.876.345a6.237 6.237 0 0 1 6.237-10.802",
    style: {
      fill: "#ffdcec",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 4.06500006,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1,
      paintOrder: "normal"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M247.592 155.247c2.983 1.722 7.361 7.474 5.639 10.457s-8.893 2.067-11.876.345a6.237 6.237 0 0 1 6.237-10.802",
    style: {
      fill: "#ffdcec",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 4.06500006,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1,
      paintOrder: "normal"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 252.488,
    cy: 165.275,
    r: 5.168,
    style: {
      fill: "#ff83ba",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 3.36817837,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1,
      paintOrder: "normal"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(.4006 0 0 .4006 22.507 -43.684)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M258.725 156.021c0 3.444-2.793 10.112-6.237 10.112s-6.237-6.668-6.237-10.112a6.237 6.237 0 1 1 12.474 0",
    style: {
      fill: "#ffdcec",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 4.06500006,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1,
      paintOrder: "normal"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M263.041 168.904c-3.327.892-10.49-.08-11.382-3.407s4.827-7.75 8.154-8.641a6.237 6.237 0 1 1 3.228 12.048",
    style: {
      fill: "#ffdcec",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 4.06500006,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1,
      paintOrder: "normal"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M251.714 176.408c-1.722-2.983-2.638-10.153.345-11.876s8.735 2.656 10.457 5.64a6.237 6.237 0 1 1-10.802 6.236",
    style: {
      fill: "#ffdcec",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 4.06500006,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1,
      paintOrder: "normal"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M241.534 167.41c2.436-2.436 9.125-5.177 11.56-2.741s-.304 9.124-2.74 11.56a6.237 6.237 0 1 1-8.82-8.82",
    style: {
      fill: "#ffdcec",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 4.06500006,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1,
      paintOrder: "normal"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M247.592 155.247c2.983 1.722 7.361 7.474 5.639 10.457s-8.893 2.067-11.876.345a6.237 6.237 0 0 1 6.237-10.802",
    style: {
      fill: "#ffdcec",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 4.06500006,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1,
      paintOrder: "normal"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M247.592 155.247c2.983 1.722 7.361 7.474 5.639 10.457s-8.893 2.067-11.876.345a6.237 6.237 0 0 1 6.237-10.802",
    style: {
      fill: "#ffdcec",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 4.06500006,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1,
      paintOrder: "normal"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 252.488,
    cy: 165.275,
    r: 5.168,
    style: {
      fill: "#ff83ba",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 3.36817837,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1,
      paintOrder: "normal"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(.4006 0 0 .4006 11.255 -42.729)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M258.725 156.021c0 3.444-2.793 10.112-6.237 10.112s-6.237-6.668-6.237-10.112a6.237 6.237 0 1 1 12.474 0",
    style: {
      fill: "#ffdcec",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 4.06500006,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1,
      paintOrder: "normal"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M263.041 168.904c-3.327.892-10.49-.08-11.382-3.407s4.827-7.75 8.154-8.641a6.237 6.237 0 1 1 3.228 12.048",
    style: {
      fill: "#ffdcec",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 4.06500006,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1,
      paintOrder: "normal"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M251.714 176.408c-1.722-2.983-2.638-10.153.345-11.876s8.735 2.656 10.457 5.64a6.237 6.237 0 1 1-10.802 6.236",
    style: {
      fill: "#ffdcec",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 4.06500006,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1,
      paintOrder: "normal"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M241.534 167.41c2.436-2.436 9.125-5.177 11.56-2.741s-.304 9.124-2.74 11.56a6.237 6.237 0 1 1-8.82-8.82",
    style: {
      fill: "#ffdcec",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 4.06500006,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1,
      paintOrder: "normal"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M247.592 155.247c2.983 1.722 7.361 7.474 5.639 10.457s-8.893 2.067-11.876.345a6.237 6.237 0 0 1 6.237-10.802",
    style: {
      fill: "#ffdcec",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 4.06500006,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1,
      paintOrder: "normal"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M247.592 155.247c2.983 1.722 7.361 7.474 5.639 10.457s-8.893 2.067-11.876.345a6.237 6.237 0 0 1 6.237-10.802",
    style: {
      fill: "#ffdcec",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 4.06500006,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1,
      paintOrder: "normal"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 252.488,
    cy: 165.275,
    r: 5.168,
    style: {
      fill: "#ff83ba",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 3.36817837,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1,
      paintOrder: "normal"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(.4006 0 0 .4006 32.396 -36.334)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M258.725 156.021c0 3.444-2.793 10.112-6.237 10.112s-6.237-6.668-6.237-10.112a6.237 6.237 0 1 1 12.474 0",
    style: {
      fill: "#ffdcec",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 4.06500006,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1,
      paintOrder: "normal"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M263.041 168.904c-3.327.892-10.49-.08-11.382-3.407s4.827-7.75 8.154-8.641a6.237 6.237 0 1 1 3.228 12.048",
    style: {
      fill: "#ffdcec",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 4.06500006,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1,
      paintOrder: "normal"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M251.714 176.408c-1.722-2.983-2.638-10.153.345-11.876s8.735 2.656 10.457 5.64a6.237 6.237 0 1 1-10.802 6.236",
    style: {
      fill: "#ffdcec",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 4.06500006,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1,
      paintOrder: "normal"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M241.534 167.41c2.436-2.436 9.125-5.177 11.56-2.741s-.304 9.124-2.74 11.56a6.237 6.237 0 1 1-8.82-8.82",
    style: {
      fill: "#ffdcec",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 4.06500006,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1,
      paintOrder: "normal"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M247.592 155.247c2.983 1.722 7.361 7.474 5.639 10.457s-8.893 2.067-11.876.345a6.237 6.237 0 0 1 6.237-10.802",
    style: {
      fill: "#ffdcec",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 4.06500006,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1,
      paintOrder: "normal"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M247.592 155.247c2.983 1.722 7.361 7.474 5.639 10.457s-8.893 2.067-11.876.345a6.237 6.237 0 0 1 6.237-10.802",
    style: {
      fill: "#ffdcec",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 4.06500006,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1,
      paintOrder: "normal"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 252.488,
    cy: 165.275,
    r: 5.168,
    style: {
      fill: "#ff83ba",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 3.36817837,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1,
      paintOrder: "normal"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(.4006 0 0 .4006 30.32 -45.09)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M258.725 156.021c0 3.444-2.793 10.112-6.237 10.112s-6.237-6.668-6.237-10.112a6.237 6.237 0 1 1 12.474 0",
    style: {
      fill: "#ffdcec",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 4.06500006,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1,
      paintOrder: "normal"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M263.041 168.904c-3.327.892-10.49-.08-11.382-3.407s4.827-7.75 8.154-8.641a6.237 6.237 0 1 1 3.228 12.048",
    style: {
      fill: "#ffdcec",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 4.06500006,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1,
      paintOrder: "normal"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M251.714 176.408c-1.722-2.983-2.638-10.153.345-11.876s8.735 2.656 10.457 5.64a6.237 6.237 0 1 1-10.802 6.236",
    style: {
      fill: "#ffdcec",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 4.06500006,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1,
      paintOrder: "normal"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M241.534 167.41c2.436-2.436 9.125-5.177 11.56-2.741s-.304 9.124-2.74 11.56a6.237 6.237 0 1 1-8.82-8.82",
    style: {
      fill: "#ffdcec",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 4.06500006,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1,
      paintOrder: "normal"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M247.592 155.247c2.983 1.722 7.361 7.474 5.639 10.457s-8.893 2.067-11.876.345a6.237 6.237 0 0 1 6.237-10.802",
    style: {
      fill: "#ffdcec",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 4.06500006,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1,
      paintOrder: "normal"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M247.592 155.247c2.983 1.722 7.361 7.474 5.639 10.457s-8.893 2.067-11.876.345a6.237 6.237 0 0 1 6.237-10.802",
    style: {
      fill: "#ffdcec",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 4.06500006,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1,
      paintOrder: "normal"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 252.488,
    cy: 165.275,
    r: 5.168,
    style: {
      fill: "#ff83ba",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 3.36817837,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1,
      paintOrder: "normal"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(.4006 0 0 .4006 43.22 -37.135)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M258.725 156.021c0 3.444-2.793 10.112-6.237 10.112s-6.237-6.668-6.237-10.112a6.237 6.237 0 1 1 12.474 0",
    style: {
      fill: "#ffdcec",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 4.06500006,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1,
      paintOrder: "normal"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M263.041 168.904c-3.327.892-10.49-.08-11.382-3.407s4.827-7.75 8.154-8.641a6.237 6.237 0 1 1 3.228 12.048",
    style: {
      fill: "#ffdcec",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 4.06500006,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1,
      paintOrder: "normal"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M251.714 176.408c-1.722-2.983-2.638-10.153.345-11.876s8.735 2.656 10.457 5.64a6.237 6.237 0 1 1-10.802 6.236",
    style: {
      fill: "#ffdcec",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 4.06500006,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1,
      paintOrder: "normal"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M241.534 167.41c2.436-2.436 9.125-5.177 11.56-2.741s-.304 9.124-2.74 11.56a6.237 6.237 0 1 1-8.82-8.82",
    style: {
      fill: "#ffdcec",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 4.06500006,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1,
      paintOrder: "normal"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M247.592 155.247c2.983 1.722 7.361 7.474 5.639 10.457s-8.893 2.067-11.876.345a6.237 6.237 0 0 1 6.237-10.802",
    style: {
      fill: "#ffdcec",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 4.06500006,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1,
      paintOrder: "normal"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M247.592 155.247c2.983 1.722 7.361 7.474 5.639 10.457s-8.893 2.067-11.876.345a6.237 6.237 0 0 1 6.237-10.802",
    style: {
      fill: "#ffdcec",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 4.06500006,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1,
      paintOrder: "normal"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 252.488,
    cy: 165.275,
    r: 5.168,
    style: {
      fill: "#ff83ba",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 3.36817837,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1,
      paintOrder: "normal"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(.4006 0 0 .4006 25.018 -35.635)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M258.725 156.021c0 3.444-2.793 10.112-6.237 10.112s-6.237-6.668-6.237-10.112a6.237 6.237 0 1 1 12.474 0",
    style: {
      fill: "#ffdcec",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 4.06500006,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1,
      paintOrder: "normal"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M263.041 168.904c-3.327.892-10.49-.08-11.382-3.407s4.827-7.75 8.154-8.641a6.237 6.237 0 1 1 3.228 12.048",
    style: {
      fill: "#ffdcec",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 4.06500006,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1,
      paintOrder: "normal"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M251.714 176.408c-1.722-2.983-2.638-10.153.345-11.876s8.735 2.656 10.457 5.64a6.237 6.237 0 1 1-10.802 6.236",
    style: {
      fill: "#ffdcec",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 4.06500006,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1,
      paintOrder: "normal"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M241.534 167.41c2.436-2.436 9.125-5.177 11.56-2.741s-.304 9.124-2.74 11.56a6.237 6.237 0 1 1-8.82-8.82",
    style: {
      fill: "#ffdcec",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 4.06500006,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1,
      paintOrder: "normal"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M247.592 155.247c2.983 1.722 7.361 7.474 5.639 10.457s-8.893 2.067-11.876.345a6.237 6.237 0 0 1 6.237-10.802",
    style: {
      fill: "#ffdcec",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 4.06500006,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1,
      paintOrder: "normal"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M247.592 155.247c2.983 1.722 7.361 7.474 5.639 10.457s-8.893 2.067-11.876.345a6.237 6.237 0 0 1 6.237-10.802",
    style: {
      fill: "#ffdcec",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 4.06500006,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1,
      paintOrder: "normal"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 252.488,
    cy: 165.275,
    r: 5.168,
    style: {
      fill: "#ff83ba",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 3.36817837,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1,
      paintOrder: "normal"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(.4006 0 0 .4006 58.455 -33.795)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M258.725 156.021c0 3.444-2.793 10.112-6.237 10.112s-6.237-6.668-6.237-10.112a6.237 6.237 0 1 1 12.474 0",
    style: {
      fill: "#ffdcec",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 4.06500006,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1,
      paintOrder: "normal"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M263.041 168.904c-3.327.892-10.49-.08-11.382-3.407s4.827-7.75 8.154-8.641a6.237 6.237 0 1 1 3.228 12.048",
    style: {
      fill: "#ffdcec",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 4.06500006,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1,
      paintOrder: "normal"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M251.714 176.408c-1.722-2.983-2.638-10.153.345-11.876s8.735 2.656 10.457 5.64a6.237 6.237 0 1 1-10.802 6.236",
    style: {
      fill: "#ffdcec",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 4.06500006,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1,
      paintOrder: "normal"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M241.534 167.41c2.436-2.436 9.125-5.177 11.56-2.741s-.304 9.124-2.74 11.56a6.237 6.237 0 1 1-8.82-8.82",
    style: {
      fill: "#ffdcec",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 4.06500006,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1,
      paintOrder: "normal"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M247.592 155.247c2.983 1.722 7.361 7.474 5.639 10.457s-8.893 2.067-11.876.345a6.237 6.237 0 0 1 6.237-10.802",
    style: {
      fill: "#ffdcec",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 4.06500006,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1,
      paintOrder: "normal"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M247.592 155.247c2.983 1.722 7.361 7.474 5.639 10.457s-8.893 2.067-11.876.345a6.237 6.237 0 0 1 6.237-10.802",
    style: {
      fill: "#ffdcec",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 4.06500006,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1,
      paintOrder: "normal"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 252.488,
    cy: 165.275,
    r: 5.168,
    style: {
      fill: "#ff83ba",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 3.36817837,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1,
      paintOrder: "normal"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(.4006 0 0 .4006 37.902 -20.006)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M258.725 156.021c0 3.444-2.793 10.112-6.237 10.112s-6.237-6.668-6.237-10.112a6.237 6.237 0 1 1 12.474 0",
    style: {
      fill: "#ffdcec",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 4.06500006,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1,
      paintOrder: "normal"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M263.041 168.904c-3.327.892-10.49-.08-11.382-3.407s4.827-7.75 8.154-8.641a6.237 6.237 0 1 1 3.228 12.048",
    style: {
      fill: "#ffdcec",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 4.06500006,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1,
      paintOrder: "normal"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M251.714 176.408c-1.722-2.983-2.638-10.153.345-11.876s8.735 2.656 10.457 5.64a6.237 6.237 0 1 1-10.802 6.236",
    style: {
      fill: "#ffdcec",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 4.06500006,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1,
      paintOrder: "normal"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M241.534 167.41c2.436-2.436 9.125-5.177 11.56-2.741s-.304 9.124-2.74 11.56a6.237 6.237 0 1 1-8.82-8.82",
    style: {
      fill: "#ffdcec",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 4.06500006,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1,
      paintOrder: "normal"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M247.592 155.247c2.983 1.722 7.361 7.474 5.639 10.457s-8.893 2.067-11.876.345a6.237 6.237 0 0 1 6.237-10.802",
    style: {
      fill: "#ffdcec",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 4.06500006,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1,
      paintOrder: "normal"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M247.592 155.247c2.983 1.722 7.361 7.474 5.639 10.457s-8.893 2.067-11.876.345a6.237 6.237 0 0 1 6.237-10.802",
    style: {
      fill: "#ffdcec",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 4.06500006,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1,
      paintOrder: "normal"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 252.488,
    cy: 165.275,
    r: 5.168,
    style: {
      fill: "#ff83ba",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 3.36817837,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1,
      paintOrder: "normal"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(.4006 0 0 .4006 48.566 -3.059)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M258.725 156.021c0 3.444-2.793 10.112-6.237 10.112s-6.237-6.668-6.237-10.112a6.237 6.237 0 1 1 12.474 0",
    style: {
      fill: "#ffdcec",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 4.06500006,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1,
      paintOrder: "normal"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M263.041 168.904c-3.327.892-10.49-.08-11.382-3.407s4.827-7.75 8.154-8.641a6.237 6.237 0 1 1 3.228 12.048",
    style: {
      fill: "#ffdcec",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 4.06500006,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1,
      paintOrder: "normal"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M251.714 176.408c-1.722-2.983-2.638-10.153.345-11.876s8.735 2.656 10.457 5.64a6.237 6.237 0 1 1-10.802 6.236",
    style: {
      fill: "#ffdcec",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 4.06500006,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1,
      paintOrder: "normal"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M241.534 167.41c2.436-2.436 9.125-5.177 11.56-2.741s-.304 9.124-2.74 11.56a6.237 6.237 0 1 1-8.82-8.82",
    style: {
      fill: "#ffdcec",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 4.06500006,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1,
      paintOrder: "normal"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M247.592 155.247c2.983 1.722 7.361 7.474 5.639 10.457s-8.893 2.067-11.876.345a6.237 6.237 0 0 1 6.237-10.802",
    style: {
      fill: "#ffdcec",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 4.06500006,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1,
      paintOrder: "normal"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M247.592 155.247c2.983 1.722 7.361 7.474 5.639 10.457s-8.893 2.067-11.876.345a6.237 6.237 0 0 1 6.237-10.802",
    style: {
      fill: "#ffdcec",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 4.06500006,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1,
      paintOrder: "normal"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 252.488,
    cy: 165.275,
    r: 5.168,
    style: {
      fill: "#ff83ba",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 3.36817837,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1,
      paintOrder: "normal"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(.4006 0 0 .4006 27.117 15.984)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M258.725 156.021c0 3.444-2.793 10.112-6.237 10.112s-6.237-6.668-6.237-10.112a6.237 6.237 0 1 1 12.474 0",
    style: {
      fill: "#ffdcec",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 4.06500006,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1,
      paintOrder: "normal"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M263.041 168.904c-3.327.892-10.49-.08-11.382-3.407s4.827-7.75 8.154-8.641a6.237 6.237 0 1 1 3.228 12.048",
    style: {
      fill: "#ffdcec",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 4.06500006,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1,
      paintOrder: "normal"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M251.714 176.408c-1.722-2.983-2.638-10.153.345-11.876s8.735 2.656 10.457 5.64a6.237 6.237 0 1 1-10.802 6.236",
    style: {
      fill: "#ffdcec",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 4.06500006,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1,
      paintOrder: "normal"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M241.534 167.41c2.436-2.436 9.125-5.177 11.56-2.741s-.304 9.124-2.74 11.56a6.237 6.237 0 1 1-8.82-8.82",
    style: {
      fill: "#ffdcec",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 4.06500006,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1,
      paintOrder: "normal"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M247.592 155.247c2.983 1.722 7.361 7.474 5.639 10.457s-8.893 2.067-11.876.345a6.237 6.237 0 0 1 6.237-10.802",
    style: {
      fill: "#ffdcec",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 4.06500006,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1,
      paintOrder: "normal"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M247.592 155.247c2.983 1.722 7.361 7.474 5.639 10.457s-8.893 2.067-11.876.345a6.237 6.237 0 0 1 6.237-10.802",
    style: {
      fill: "#ffdcec",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 4.06500006,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1,
      paintOrder: "normal"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 252.488,
    cy: 165.275,
    r: 5.168,
    style: {
      fill: "#ff83ba",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 3.36817837,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1,
      paintOrder: "normal"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(.4006 0 0 .4006 45.359 13.245)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M258.725 156.021c0 3.444-2.793 10.112-6.237 10.112s-6.237-6.668-6.237-10.112a6.237 6.237 0 1 1 12.474 0",
    style: {
      fill: "#ffdcec",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 4.06500006,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1,
      paintOrder: "normal"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M263.041 168.904c-3.327.892-10.49-.08-11.382-3.407s4.827-7.75 8.154-8.641a6.237 6.237 0 1 1 3.228 12.048",
    style: {
      fill: "#ffdcec",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 4.06500006,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1,
      paintOrder: "normal"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M251.714 176.408c-1.722-2.983-2.638-10.153.345-11.876s8.735 2.656 10.457 5.64a6.237 6.237 0 1 1-10.802 6.236",
    style: {
      fill: "#ffdcec",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 4.06500006,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1,
      paintOrder: "normal"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M241.534 167.41c2.436-2.436 9.125-5.177 11.56-2.741s-.304 9.124-2.74 11.56a6.237 6.237 0 1 1-8.82-8.82",
    style: {
      fill: "#ffdcec",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 4.06500006,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1,
      paintOrder: "normal"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M247.592 155.247c2.983 1.722 7.361 7.474 5.639 10.457s-8.893 2.067-11.876.345a6.237 6.237 0 0 1 6.237-10.802",
    style: {
      fill: "#ffdcec",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 4.06500006,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1,
      paintOrder: "normal"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M247.592 155.247c2.983 1.722 7.361 7.474 5.639 10.457s-8.893 2.067-11.876.345a6.237 6.237 0 0 1 6.237-10.802",
    style: {
      fill: "#ffdcec",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 4.06500006,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1,
      paintOrder: "normal"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 252.488,
    cy: 165.275,
    r: 5.168,
    style: {
      fill: "#ff83ba",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 3.36817837,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1,
      paintOrder: "normal"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(.4006 0 0 .4006 57.52 2.287)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M258.725 156.021c0 3.444-2.793 10.112-6.237 10.112s-6.237-6.668-6.237-10.112a6.237 6.237 0 1 1 12.474 0",
    style: {
      fill: "#ffdcec",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 4.06500006,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1,
      paintOrder: "normal"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M263.041 168.904c-3.327.892-10.49-.08-11.382-3.407s4.827-7.75 8.154-8.641a6.237 6.237 0 1 1 3.228 12.048",
    style: {
      fill: "#ffdcec",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 4.06500006,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1,
      paintOrder: "normal"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M251.714 176.408c-1.722-2.983-2.638-10.153.345-11.876s8.735 2.656 10.457 5.64a6.237 6.237 0 1 1-10.802 6.236",
    style: {
      fill: "#ffdcec",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 4.06500006,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1,
      paintOrder: "normal"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M241.534 167.41c2.436-2.436 9.125-5.177 11.56-2.741s-.304 9.124-2.74 11.56a6.237 6.237 0 1 1-8.82-8.82",
    style: {
      fill: "#ffdcec",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 4.06500006,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1,
      paintOrder: "normal"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M247.592 155.247c2.983 1.722 7.361 7.474 5.639 10.457s-8.893 2.067-11.876.345a6.237 6.237 0 0 1 6.237-10.802",
    style: {
      fill: "#ffdcec",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 4.06500006,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1,
      paintOrder: "normal"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M247.592 155.247c2.983 1.722 7.361 7.474 5.639 10.457s-8.893 2.067-11.876.345a6.237 6.237 0 0 1 6.237-10.802",
    style: {
      fill: "#ffdcec",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 4.06500006,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1,
      paintOrder: "normal"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 252.488,
    cy: 165.275,
    r: 5.168,
    style: {
      fill: "#ff83ba",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 3.36817837,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1,
      paintOrder: "normal"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(.4006 0 0 .4006 65.137 -12.413)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M258.725 156.021c0 3.444-2.793 10.112-6.237 10.112s-6.237-6.668-6.237-10.112a6.237 6.237 0 1 1 12.474 0",
    style: {
      fill: "#ffdcec",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 4.06500006,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1,
      paintOrder: "normal"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M263.041 168.904c-3.327.892-10.49-.08-11.382-3.407s4.827-7.75 8.154-8.641a6.237 6.237 0 1 1 3.228 12.048",
    style: {
      fill: "#ffdcec",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 4.06500006,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1,
      paintOrder: "normal"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M251.714 176.408c-1.722-2.983-2.638-10.153.345-11.876s8.735 2.656 10.457 5.64a6.237 6.237 0 1 1-10.802 6.236",
    style: {
      fill: "#ffdcec",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 4.06500006,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1,
      paintOrder: "normal"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M241.534 167.41c2.436-2.436 9.125-5.177 11.56-2.741s-.304 9.124-2.74 11.56a6.237 6.237 0 1 1-8.82-8.82",
    style: {
      fill: "#ffdcec",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 4.06500006,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1,
      paintOrder: "normal"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M247.592 155.247c2.983 1.722 7.361 7.474 5.639 10.457s-8.893 2.067-11.876.345a6.237 6.237 0 0 1 6.237-10.802",
    style: {
      fill: "#ffdcec",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 4.06500006,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1,
      paintOrder: "normal"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M247.592 155.247c2.983 1.722 7.361 7.474 5.639 10.457s-8.893 2.067-11.876.345a6.237 6.237 0 0 1 6.237-10.802",
    style: {
      fill: "#ffdcec",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 4.06500006,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1,
      paintOrder: "normal"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 252.488,
    cy: 165.275,
    r: 5.168,
    style: {
      fill: "#ff83ba",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 3.36817837,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1,
      paintOrder: "normal"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(.4006 0 0 .4006 61.261 -25.51)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M258.725 156.021c0 3.444-2.793 10.112-6.237 10.112s-6.237-6.668-6.237-10.112a6.237 6.237 0 1 1 12.474 0",
    style: {
      fill: "#ffdcec",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 4.06500006,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1,
      paintOrder: "normal"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M263.041 168.904c-3.327.892-10.49-.08-11.382-3.407s4.827-7.75 8.154-8.641a6.237 6.237 0 1 1 3.228 12.048",
    style: {
      fill: "#ffdcec",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 4.06500006,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1,
      paintOrder: "normal"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M251.714 176.408c-1.722-2.983-2.638-10.153.345-11.876s8.735 2.656 10.457 5.64a6.237 6.237 0 1 1-10.802 6.236",
    style: {
      fill: "#ffdcec",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 4.06500006,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1,
      paintOrder: "normal"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M241.534 167.41c2.436-2.436 9.125-5.177 11.56-2.741s-.304 9.124-2.74 11.56a6.237 6.237 0 1 1-8.82-8.82",
    style: {
      fill: "#ffdcec",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 4.06500006,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1,
      paintOrder: "normal"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M247.592 155.247c2.983 1.722 7.361 7.474 5.639 10.457s-8.893 2.067-11.876.345a6.237 6.237 0 0 1 6.237-10.802",
    style: {
      fill: "#ffdcec",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 4.06500006,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1,
      paintOrder: "normal"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M247.592 155.247c2.983 1.722 7.361 7.474 5.639 10.457s-8.893 2.067-11.876.345a6.237 6.237 0 0 1 6.237-10.802",
    style: {
      fill: "#ffdcec",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 4.06500006,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1,
      paintOrder: "normal"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 252.488,
    cy: 165.275,
    r: 5.168,
    style: {
      fill: "#ff83ba",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 3.36817837,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1,
      paintOrder: "normal"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(.4006 0 0 .4006 70.933 -22.946)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M258.725 156.021c0 3.444-2.793 10.112-6.237 10.112s-6.237-6.668-6.237-10.112a6.237 6.237 0 1 1 12.474 0",
    style: {
      fill: "#ffdcec",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 4.06500006,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1,
      paintOrder: "normal"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M263.041 168.904c-3.327.892-10.49-.08-11.382-3.407s4.827-7.75 8.154-8.641a6.237 6.237 0 1 1 3.228 12.048",
    style: {
      fill: "#ffdcec",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 4.06500006,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1,
      paintOrder: "normal"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M251.714 176.408c-1.722-2.983-2.638-10.153.345-11.876s8.735 2.656 10.457 5.64a6.237 6.237 0 1 1-10.802 6.236",
    style: {
      fill: "#ffdcec",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 4.06500006,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1,
      paintOrder: "normal"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M241.534 167.41c2.436-2.436 9.125-5.177 11.56-2.741s-.304 9.124-2.74 11.56a6.237 6.237 0 1 1-8.82-8.82",
    style: {
      fill: "#ffdcec",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 4.06500006,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1,
      paintOrder: "normal"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M247.592 155.247c2.983 1.722 7.361 7.474 5.639 10.457s-8.893 2.067-11.876.345a6.237 6.237 0 0 1 6.237-10.802",
    style: {
      fill: "#ffdcec",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 4.06500006,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1,
      paintOrder: "normal"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M247.592 155.247c2.983 1.722 7.361 7.474 5.639 10.457s-8.893 2.067-11.876.345a6.237 6.237 0 0 1 6.237-10.802",
    style: {
      fill: "#ffdcec",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 4.06500006,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1,
      paintOrder: "normal"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 252.488,
    cy: 165.275,
    r: 5.168,
    style: {
      fill: "#ff83ba",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 3.36817837,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1,
      paintOrder: "normal"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(.4006 0 0 .4006 72.62 -4.261)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M258.725 156.021c0 3.444-2.793 10.112-6.237 10.112s-6.237-6.668-6.237-10.112a6.237 6.237 0 1 1 12.474 0",
    style: {
      fill: "#ffdcec",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 4.06500006,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1,
      paintOrder: "normal"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M263.041 168.904c-3.327.892-10.49-.08-11.382-3.407s4.827-7.75 8.154-8.641a6.237 6.237 0 1 1 3.228 12.048",
    style: {
      fill: "#ffdcec",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 4.06500006,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1,
      paintOrder: "normal"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M251.714 176.408c-1.722-2.983-2.638-10.153.345-11.876s8.735 2.656 10.457 5.64a6.237 6.237 0 1 1-10.802 6.236",
    style: {
      fill: "#ffdcec",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 4.06500006,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1,
      paintOrder: "normal"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M241.534 167.41c2.436-2.436 9.125-5.177 11.56-2.741s-.304 9.124-2.74 11.56a6.237 6.237 0 1 1-8.82-8.82",
    style: {
      fill: "#ffdcec",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 4.06500006,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1,
      paintOrder: "normal"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M247.592 155.247c2.983 1.722 7.361 7.474 5.639 10.457s-8.893 2.067-11.876.345a6.237 6.237 0 0 1 6.237-10.802",
    style: {
      fill: "#ffdcec",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 4.06500006,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1,
      paintOrder: "normal"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M247.592 155.247c2.983 1.722 7.361 7.474 5.639 10.457s-8.893 2.067-11.876.345a6.237 6.237 0 0 1 6.237-10.802",
    style: {
      fill: "#ffdcec",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 4.06500006,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1,
      paintOrder: "normal"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 252.488,
    cy: 165.275,
    r: 5.168,
    style: {
      fill: "#ff83ba",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 3.36817837,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1,
      paintOrder: "normal"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(.4006 0 0 .4006 62.999 9.77)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M258.725 156.021c0 3.444-2.793 10.112-6.237 10.112s-6.237-6.668-6.237-10.112a6.237 6.237 0 1 1 12.474 0",
    style: {
      fill: "#ffdcec",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 4.06500006,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1,
      paintOrder: "normal"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M263.041 168.904c-3.327.892-10.49-.08-11.382-3.407s4.827-7.75 8.154-8.641a6.237 6.237 0 1 1 3.228 12.048",
    style: {
      fill: "#ffdcec",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 4.06500006,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1,
      paintOrder: "normal"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M251.714 176.408c-1.722-2.983-2.638-10.153.345-11.876s8.735 2.656 10.457 5.64a6.237 6.237 0 1 1-10.802 6.236",
    style: {
      fill: "#ffdcec",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 4.06500006,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1,
      paintOrder: "normal"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M241.534 167.41c2.436-2.436 9.125-5.177 11.56-2.741s-.304 9.124-2.74 11.56a6.237 6.237 0 1 1-8.82-8.82",
    style: {
      fill: "#ffdcec",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 4.06500006,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1,
      paintOrder: "normal"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M247.592 155.247c2.983 1.722 7.361 7.474 5.639 10.457s-8.893 2.067-11.876.345a6.237 6.237 0 0 1 6.237-10.802",
    style: {
      fill: "#ffdcec",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 4.06500006,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1,
      paintOrder: "normal"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M247.592 155.247c2.983 1.722 7.361 7.474 5.639 10.457s-8.893 2.067-11.876.345a6.237 6.237 0 0 1 6.237-10.802",
    style: {
      fill: "#ffdcec",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 4.06500006,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1,
      paintOrder: "normal"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 252.488,
    cy: 165.275,
    r: 5.168,
    style: {
      fill: "#ff83ba",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 3.36817837,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1,
      paintOrder: "normal"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(.4006 0 0 .4006 70.215 28.078)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M258.725 156.021c0 3.444-2.793 10.112-6.237 10.112s-6.237-6.668-6.237-10.112a6.237 6.237 0 1 1 12.474 0",
    style: {
      fill: "#ffdcec",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 4.06500006,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1,
      paintOrder: "normal"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M263.041 168.904c-3.327.892-10.49-.08-11.382-3.407s4.827-7.75 8.154-8.641a6.237 6.237 0 1 1 3.228 12.048",
    style: {
      fill: "#ffdcec",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 4.06500006,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1,
      paintOrder: "normal"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M251.714 176.408c-1.722-2.983-2.638-10.153.345-11.876s8.735 2.656 10.457 5.64a6.237 6.237 0 1 1-10.802 6.236",
    style: {
      fill: "#ffdcec",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 4.06500006,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1,
      paintOrder: "normal"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M241.534 167.41c2.436-2.436 9.125-5.177 11.56-2.741s-.304 9.124-2.74 11.56a6.237 6.237 0 1 1-8.82-8.82",
    style: {
      fill: "#ffdcec",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 4.06500006,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1,
      paintOrder: "normal"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M247.592 155.247c2.983 1.722 7.361 7.474 5.639 10.457s-8.893 2.067-11.876.345a6.237 6.237 0 0 1 6.237-10.802",
    style: {
      fill: "#ffdcec",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 4.06500006,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1,
      paintOrder: "normal"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M247.592 155.247c2.983 1.722 7.361 7.474 5.639 10.457s-8.893 2.067-11.876.345a6.237 6.237 0 0 1 6.237-10.802",
    style: {
      fill: "#ffdcec",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 4.06500006,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1,
      paintOrder: "normal"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 252.488,
    cy: 165.275,
    r: 5.168,
    style: {
      fill: "#ff83ba",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 3.36817837,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1,
      paintOrder: "normal"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(.4006 0 0 .4006 60.192 27.41)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M258.725 156.021c0 3.444-2.793 10.112-6.237 10.112s-6.237-6.668-6.237-10.112a6.237 6.237 0 1 1 12.474 0",
    style: {
      fill: "#ffdcec",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 4.06500006,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1,
      paintOrder: "normal"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M263.041 168.904c-3.327.892-10.49-.08-11.382-3.407s4.827-7.75 8.154-8.641a6.237 6.237 0 1 1 3.228 12.048",
    style: {
      fill: "#ffdcec",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 4.06500006,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1,
      paintOrder: "normal"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M251.714 176.408c-1.722-2.983-2.638-10.153.345-11.876s8.735 2.656 10.457 5.64a6.237 6.237 0 1 1-10.802 6.236",
    style: {
      fill: "#ffdcec",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 4.06500006,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1,
      paintOrder: "normal"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M241.534 167.41c2.436-2.436 9.125-5.177 11.56-2.741s-.304 9.124-2.74 11.56a6.237 6.237 0 1 1-8.82-8.82",
    style: {
      fill: "#ffdcec",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 4.06500006,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1,
      paintOrder: "normal"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M247.592 155.247c2.983 1.722 7.361 7.474 5.639 10.457s-8.893 2.067-11.876.345a6.237 6.237 0 0 1 6.237-10.802",
    style: {
      fill: "#ffdcec",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 4.06500006,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1,
      paintOrder: "normal"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M247.592 155.247c2.983 1.722 7.361 7.474 5.639 10.457s-8.893 2.067-11.876.345a6.237 6.237 0 0 1 6.237-10.802",
    style: {
      fill: "#ffdcec",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 4.06500006,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1,
      paintOrder: "normal"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 252.488,
    cy: 165.275,
    r: 5.168,
    style: {
      fill: "#ff83ba",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 3.36817837,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1,
      paintOrder: "normal"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(.4006 0 0 .4006 60.192 27.41)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M258.725 156.021c0 3.444-2.793 10.112-6.237 10.112s-6.237-6.668-6.237-10.112a6.237 6.237 0 1 1 12.474 0",
    style: {
      fill: "#ffdcec",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 4.06500006,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1,
      paintOrder: "normal"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M263.041 168.904c-3.327.892-10.49-.08-11.382-3.407s4.827-7.75 8.154-8.641a6.237 6.237 0 1 1 3.228 12.048",
    style: {
      fill: "#ffdcec",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 4.06500006,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1,
      paintOrder: "normal"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M251.714 176.408c-1.722-2.983-2.638-10.153.345-11.876s8.735 2.656 10.457 5.64a6.237 6.237 0 1 1-10.802 6.236",
    style: {
      fill: "#ffdcec",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 4.06500006,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1,
      paintOrder: "normal"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M241.534 167.41c2.436-2.436 9.125-5.177 11.56-2.741s-.304 9.124-2.74 11.56a6.237 6.237 0 1 1-8.82-8.82",
    style: {
      fill: "#ffdcec",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 4.06500006,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1,
      paintOrder: "normal"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M247.592 155.247c2.983 1.722 7.361 7.474 5.639 10.457s-8.893 2.067-11.876.345a6.237 6.237 0 0 1 6.237-10.802",
    style: {
      fill: "#ffdcec",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 4.06500006,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1,
      paintOrder: "normal"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M247.592 155.247c2.983 1.722 7.361 7.474 5.639 10.457s-8.893 2.067-11.876.345a6.237 6.237 0 0 1 6.237-10.802",
    style: {
      fill: "#ffdcec",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 4.06500006,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1,
      paintOrder: "normal"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 252.488,
    cy: 165.275,
    r: 5.168,
    style: {
      fill: "#ff83ba",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 3.36817837,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1,
      paintOrder: "normal"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M431.896 25.895c-4.535 0-8.32 3.198-9.23 7.462-4.148-1.344-8.812.336-11.08 4.264-2.608 4.517-1.061 10.291 3.455 12.899.504.29 1.098.564 1.74.818-.554.412-1.057.83-1.469 1.242a9.44 9.44 0 0 0 0 13.354c.88.879 1.891 1.542 2.97 2.002a9.4 9.4 0 0 0-2.686 4.818c-4.149-1.345-8.814.335-11.082 4.264-2.608 4.516-1.06 10.29 3.457 12.898.504.291 1.098.564 1.74.818-.555.413-1.057.828-1.469 1.24-3.687 3.688-3.687 9.668 0 13.356a9.44 9.44 0 0 0 13.354 0c.411-.412.828-.914 1.24-1.469.254.643.527 1.234.818 1.739 2.608 4.516 8.382 6.064 12.899 3.457 3.012-1.74 4.695-4.888 4.715-8.131 4.518 8.295 10.26 15.682 16.455 22.504-.668 3.04.17 6.346 2.535 8.71a9.42 9.42 0 0 0 7.582 2.721q.456-.043.908-.13c9.43 9.137 19.067 17.66 27.36 27.056a144 144 0 0 1 12.517 16.434c-3.346 3.707-3.243 9.42.328 12.992a9.43 9.43 0 0 0 8.526 2.58c.838 1.72 1.644 3.455 2.41 5.207.162.37.315.745.474 1.117a9.4 9.4 0 0 0-4.779-1.308 9.43 9.43 0 0 0-9.23 7.464c-4.149-1.344-8.812.336-11.08 4.264-2.608 4.517-1.062 10.291 3.455 12.899a13.4 13.4 0 0 0 1.74.816c-.555.412-1.057.83-1.469 1.242a9.442 9.442 0 0 0 7.582 16.076 9.4 9.4 0 0 0 5.772-2.722q.346-.346.695-.764c.183-.219.365-.46.547-.705.254.642.525 1.236.816 1.74 2.608 4.516 8.384 6.065 12.9 3.457a9.4 9.4 0 0 0 2.276-1.84 71.4 71.4 0 0 0-2.856 16.176 11.7 11.7 0 0 0-1.752.635c.101-.683.16-1.334.16-1.916 0-5.215-4.226-9.443-9.44-9.443-4.537 0-8.323 3.2-9.233 7.464a9.4 9.4 0 0 0-1.694-.38 9.44 9.44 0 0 0-9.918-3.35c-.562.15-1.175.378-1.808.652.044-.301.086-.6.111-.885q.048-.541.049-1.03c0-5.216-4.226-9.444-9.441-9.444-3.445 0-6.45 1.85-8.1 4.605-.885-.584-1.755-1.165-2.645-1.752l-.544-.357c.095-.05.193-.092.287-.147 4.516-2.607 6.064-8.382 3.457-12.898a13 13 0 0 0-1.098-1.578c.686-.08 1.328-.19 1.89-.34 5.038-1.35 8.028-6.527 6.678-11.564-1.35-5.038-6.527-8.028-11.564-6.678-.562.15-1.175.376-1.809.65.045-.3.086-.6.112-.883q.048-.541.049-1.03a9.42 9.42 0 0 0-3.78-7.546c.238-.005.475-.01.711-.033a9.4 9.4 0 0 0 5.772-2.723q.346-.346.695-.763c.183-.219.365-.461.547-.705.254.642.525 1.236.816 1.74 2.608 4.516 8.384 6.064 12.9 3.457 4.517-2.608 6.063-8.384 3.456-12.9a13 13 0 0 0-1.098-1.579 13 13 0 0 0 1.893-.34c5.037-1.35 8.027-6.527 6.677-11.564s-6.527-8.027-11.564-6.678c-.562.151-1.175.379-1.809.653.045-.302.086-.601.112-.885q.048-.541.048-1.031a9.444 9.444 0 0 0-9.443-9.444c-4.536 0-8.32 3.2-9.23 7.465a9.4 9.4 0 0 0-3.56-.437q-.42.031-.833.1a9.4 9.4 0 0 0-.31-2.89c-1.35-5.037-6.528-8.027-11.565-6.677-.562.15-1.175.376-1.809.65.101-.683.16-1.332.16-1.914a9.444 9.444 0 0 0-18.46-2.808 9 9 0 0 0-.213.83c-4.149-1.345-8.812.333-11.08 4.261-2.608 4.517-1.062 10.293 3.455 12.9.504.292 1.098.563 1.74.817-.555.412-1.057.83-1.469 1.242a9.44 9.44 0 0 0 0 13.354 9.4 9.4 0 0 0 2.782 1.916 9.44 9.44 0 0 0-8.561 7.43 9.3 9.3 0 0 0-2.219-.424c-5.93-8.86-12.558-19.623-20.238-32.024a9.43 9.43 0 0 0 1.924-8.548 9.4 9.4 0 0 0-2.479-4.256c.682-.4 1.33-.882 1.914-1.467.412-.412.829-.915 1.24-1.469.255.642.528 1.236.819 1.74 2.607 4.517 8.382 6.063 12.898 3.455 4.517-2.607 6.065-8.382 3.457-12.898a13 13 0 0 0-1.097-1.578c.686-.08 1.33-.19 1.892-.34 5.038-1.35 8.026-6.527 6.676-11.564-1.35-5.038-6.527-8.028-11.564-6.678q-.473.127-.983.314c-.267.098-.547.215-.826.336.1-.683.162-1.332.162-1.914a9.444 9.444 0 0 0-18.46-2.808 9 9 0 0 0-.214.83c-4.148-1.345-8.814.333-11.082 4.261-2.607 4.517-1.06 10.293 3.457 12.9a13.4 13.4 0 0 0 1.74.817c-.555.412-1.056.83-1.468 1.242a9.4 9.4 0 0 0-2.414 4.137 10 10 0 0 0-.623-.516c-.79-1.242-1.554-2.453-2.366-3.72.138.861.288 1.72.438 2.58a9.4 9.4 0 0 0-3.773-.79c-4.537 0-8.322 3.2-9.23 7.466-4.15-1.345-8.815.333-11.083 4.261-2.132 3.693-1.482 8.226 1.293 11.182a10 10 0 0 0-.98-.05c-4.537 0-8.322 3.199-9.23 7.464-4.15-1.345-8.815.333-11.083 4.262-2.608 4.516-1.06 10.293 3.457 12.9.504.291 1.098.562 1.74.817-.554.411-1.057.83-1.468 1.242a9.44 9.44 0 0 0 0 13.353 9.44 9.44 0 0 0 13.353 0c.412-.412.83-.914 1.242-1.469.254.643.525 1.236.817 1.74 2.607 4.517 8.382 6.063 12.898 3.456a9.4 9.4 0 0 0 3.334-3.248 9.4 9.4 0 0 0 4.512 6.252c.504.29 1.098.562 1.74.816-.555.412-1.057.83-1.469 1.242a9.442 9.442 0 0 0 7.582 16.076 9.4 9.4 0 0 0 5.774-2.722q.345-.346.693-.764c.183-.218.366-.46.547-.705.254.642.527 1.236.818 1.74 2.608 4.517 8.382 6.063 12.899 3.455s6.064-8.382 3.457-12.898a13 13 0 0 0-1.098-1.578c.686-.08 1.328-.19 1.89-.34.294-.079.579-.174.858-.277q.323.362.688.693 1.049 1.518 2.129 3.016c-.079.073-.17.147-.243.22-3.687 3.688-3.687 9.668 0 13.356q.031.029.063.056a9.45 9.45 0 0 0-3.822 5.754c-4.149-1.344-8.812.336-11.08 4.264-2.608 4.516-1.06 10.29 3.457 12.898.504.292 1.096.565 1.738.819-.554.411-1.057.828-1.469 1.24a9.44 9.44 0 0 0 0 13.354 9.5 9.5 0 0 0 1.201 1.003 9.4 9.4 0 0 0-1.586 3.547c-4.148-1.344-8.812.336-11.08 4.264-2.607 4.516-1.06 10.29 3.457 12.898.505.292 1.096.565 1.739.819-.555.411-1.057.828-1.47 1.24a9.442 9.442 0 0 0 7.583 16.076 9.4 9.4 0 0 0 5.773-2.722q.346-.346.694-.764c.182-.219.365-.459.547-.703.254.642.527 1.234.818 1.738 2.607 4.516 8.382 6.065 12.898 3.457 4.517-2.607 6.065-8.382 3.457-12.898a13 13 0 0 0-1.097-1.58c.685-.08 1.33-.19 1.892-.34 5.038-1.35 8.026-6.527 6.676-11.565s-6.527-8.027-11.564-6.677a13 13 0 0 0-1.809.652c.044-.3.086-.601.111-.885q.05-.541.05-1.031c0-1.344-.286-2.62-.792-3.777 2.956 2.5 7.27 3.023 10.815.976a9.4 9.4 0 0 0 3.98-4.535 9.43 9.43 0 0 0 4.7 7.52c.504.29 1.095.564 1.738.818-.555.411-1.057.828-1.47 1.24a9.442 9.442 0 0 0 7.583 16.076 9.4 9.4 0 0 0 5.773-2.722q.346-.346.694-.764c.182-.219.365-.459.547-.703.254.642.527 1.234.818 1.738 2.607 4.516 8.382 6.065 12.898 3.457 3.328-1.921 5.037-5.562 4.666-9.152a9.44 9.44 0 0 0 5.528 1.174 9.4 9.4 0 0 0 5.771-2.723q.346-.346.696-.764c.182-.218.365-.46.546-.705.255.642.528 1.236.819 1.74 2.168 3.757 6.526 5.45 10.531 4.416a975 975 0 0 1 16.727 11.961c-.078.252-.141.51-.198.77l-.008.031a9.46 9.46 0 0 0-7.843.936c-.205.125-.4.265-.596.406a9 9 0 0 0-.7-.205 9.4 9.4 0 0 0-4.642.064 13 13 0 0 0-1.808.653c.044-.302.086-.601.111-.885q.048-.541.049-1.031c0-5.215-4.227-9.444-9.442-9.444a9.45 9.45 0 0 0-9.02 6.635 9 9 0 0 0-.212.83c-4.148-1.345-8.812.333-11.08 4.262-2.608 4.516-1.06 10.293 3.457 12.9.504.291 1.096.562 1.738.817-.555.412-1.057.83-1.469 1.242a9.442 9.442 0 0 0 7.582 16.076 9.4 9.4 0 0 0 5.774-2.723q.345-.346.693-.763c.183-.219.366-.461.547-.705.254.642.527 1.235.819 1.74 2.607 4.516 8.382 6.062 12.898 3.455a9.4 9.4 0 0 0 3.914-4.381 9.4 9.4 0 0 0 1.877 2.697 9.42 9.42 0 0 0 7.582 2.723 9.4 9.4 0 0 0 5.771-2.723q.347-.346.696-.763c.183-.219.365-.461.547-.705.254.642.525 1.235.816 1.74 2.608 4.516 8.384 6.062 12.9 3.455 4.517-2.608 6.063-8.382 3.456-12.899a13 13 0 0 0-1.098-1.58 13 13 0 0 0 1.892-.338 9.4 9.4 0 0 0 2.522-1.09 9.4 9.4 0 0 0 1.81 1.33c9.01 7.28 17.79 14.752 26.264 22.438a9.4 9.4 0 0 0-.805 2.266c-4.148-1.345-8.811.335-11.08 4.263-2.607 4.517-1.06 10.291 3.455 12.899.505.291 1.099.564 1.74.818-.554.412-1.056.829-1.468 1.24a9.442 9.442 0 0 0 7.582 16.077 9.4 9.4 0 0 0 5.771-2.723q.347-.346.696-.764c.183-.219.365-.46.547-.705.254.642.525 1.236.816 1.74 2.608 4.517 8.384 6.065 12.9 3.458 4.517-2.608 6.063-8.384 3.456-12.9a13 13 0 0 0-1.098-1.579c.686-.08 1.33-.189 1.892-.34q.019-.005.038-.012c.226.237.456.47.681.707v.002a9.39 9.39 0 0 0 7.065 7.594c23.283 25.67 42.688 53.645 55.96 84.531 20.037 46.628 25.585 99.813 15.606 149.573l48.787 9.781c12.006-59.866 5.43-122.898-18.676-178.996-10.14-23.599-23.893-43.536-39.99-61.09.022-.012.045-.02.067-.033 4.516-2.608 6.064-8.382 3.457-12.899a13 13 0 0 0-1.1-1.58 13.4 13.4 0 0 0 1.895-.338c5.037-1.35 8.025-6.527 6.675-11.564s-6.527-8.028-11.564-6.678q-.474.128-.985.315c-.267.098-.545.215-.824.336.101-.683.162-1.332.162-1.914a9.444 9.444 0 0 0-18.675-1.979 9.45 9.45 0 0 0-9.508 2.246 9.42 9.42 0 0 0-8.051-1.53c-.164.045-.34.11-.512.165q-.58-.45-1.16-.9c.009-.177.026-.361.026-.528a9.444 9.444 0 0 0-9.444-9.443 9.4 9.4 0 0 0-3.166.555 588 588 0 0 0-7.053-5.028c3.059-2.94 3.853-7.679 1.637-11.517a13 13 0 0 0-1.096-1.579c.686-.079 1.329-.189 1.891-.34a9.43 9.43 0 0 0 6.522-6.17 9.403 9.403 0 0 0 8.64-2.553q.346-.346.695-.763c.183-.218.366-.46.547-.705.255.642.528 1.236.819 1.74 2.607 4.517 8.382 6.063 12.898 3.456 4.517-2.608 6.063-8.383 3.455-12.899a13 13 0 0 0-1.097-1.58c.686-.08 1.33-.187 1.892-.338 5.038-1.35 8.028-6.527 6.678-11.564-1.35-5.038-6.527-8.028-11.565-6.678-.562.15-1.175.376-1.808.65.1-.683.16-1.332.16-1.914a9.4 9.4 0 0 0-2.947-6.844c2.813-.162 6.38-.132 10.297-1.695 2.757-1.1 5.07-2.859 6.908-4.945 1.682-1.91 2.918-4.058 3.84-6.256.24-.028.482-.057.72-.103a9.4 9.4 0 0 0 4.875-2.594q.345-.346.694-.764c.182-.219.365-.46.547-.705.254.642.527 1.236.818 1.74 2.607 4.517 8.382 6.063 12.898 3.455 4.517-2.607 6.065-8.382 3.457-12.898a13 13 0 0 0-1.097-1.578c.686-.08 1.328-.19 1.89-.34 5.038-1.35 8.028-6.527 6.678-11.565s-6.527-8.027-11.564-6.677c-.563.15-1.175.376-1.809.65.1-.683.16-1.332.16-1.914 0-5.215-4.226-9.443-9.441-9.443a9.42 9.42 0 0 0-7.457 3.66q-.203-1.43-.436-2.856c-.248-1.515-.53-3.025-.828-4.53 2.744-2.285 4.076-6.026 3.092-9.7-.974-3.636-3.947-6.194-7.418-6.834a141 141 0 0 0-1.904-5.44c-.268-.715-.546-1.426-.825-2.136.132-.007.264-.007.395-.02a9.4 9.4 0 0 0 5.771-2.722q.347-.346.696-.764c.182-.219.365-.46.547-.705.254.642.525 1.234.816 1.738 2.608 4.516 8.384 6.065 12.9 3.457 4.517-2.607 6.063-8.382 3.456-12.898a13 13 0 0 0-1.098-1.58c.686-.08 1.33-.19 1.892-.34 5.038-1.35 8.028-6.527 6.678-11.565s-6.529-8.025-11.566-6.675a11.6 11.6 0 0 0-1.807.65c.101-.683.16-1.334.16-1.916 0-4.372-2.975-8.038-7.008-9.113a9.4 9.4 0 0 0-1.253-4.926 13 13 0 0 0-1.098-1.58 13 13 0 0 0 1.892-.34c5.038-1.35 8.028-6.527 6.678-11.565s-6.529-8.025-11.566-6.675a11.6 11.6 0 0 0-1.807.65c.101-.683.16-1.334.16-1.916 0-5.215-4.228-9.441-9.443-9.441-4.536 0-8.32 3.198-9.23 7.463a9.4 9.4 0 0 0-3.561-.436c-.236.017-.468.05-.701.084a10 10 0 0 0-.649-.512 9.42 9.42 0 0 0-7.927-1.431 11.6 11.6 0 0 0-1.807.65c.1-.683.16-1.334.16-1.916 0-5.215-4.228-9.441-9.443-9.441-4.536 0-8.32 3.198-9.23 7.462-4.149-1.344-8.815.336-11.083 4.264-2.607 4.517-1.06 10.291 3.457 12.899.505.29 1.098.564 1.74.818-.554.412-1.056.828-1.468 1.24-3.688 3.688-3.688 9.668 0 13.356a9.4 9.4 0 0 0 7.043 2.748c-.054.086-.113.165-.164.254-2.608 4.516-1.06 10.29 3.457 12.898.504.291 1.096.564 1.738.818a13 13 0 0 0-1.469 1.24c-3.687 3.688-3.687 9.668 0 13.356a9.42 9.42 0 0 0 7.582 2.723 9.4 9.4 0 0 0 5.774-2.723q.345-.346.693-.764c.183-.218.365-.46.547-.705.254.643.527 1.236.818 1.74 2.608 4.517 8.382 6.063 12.899 3.456a9.4 9.4 0 0 0 2.886-2.586 780 780 0 0 1 2.014 6.527c.216.713.427 1.448.643 2.168a9 9 0 0 0-.721-.185 9.5 9.5 0 0 0-1.902-.194c-4.536 0-8.32 3.2-9.23 7.465-4.15-1.345-8.815.335-11.083 4.264-2.607 4.516-1.06 10.29 3.457 12.898.504.291 1.097.564 1.738.818-.243.182-.484.363-.703.545q-.417.349-.763.696a9.44 9.44 0 0 0 0 13.353 9.44 9.44 0 0 0 13.353 0 13 13 0 0 0 1.24-1.467c.255.642.528 1.234.819 1.739 1.742 3.017 4.9 4.702 8.15 4.715-.968 3.97.733 8.265 4.451 10.412.46.265.996.51 1.57.746l-.001.138-.002.065c-.483.369-.93.741-1.297 1.11-3.285 3.284-3.635 8.384-1.067 12.066-.588 1.465-1.36 2.782-2.285 3.832-.942 1.07-2.083 1.897-3.232 2.355-1.88.75-4.85.748-8.652 1.1q-1.062.097-2.112.25c-.114.016-.227.04-.342.058.03-.157.068-.313.09-.472a9.4 9.4 0 0 0-.234-3.743c-1.35-5.037-6.527-8.027-11.565-6.677-.562.15-1.174.378-1.808.652.1-.683.162-1.334.162-1.916a9.444 9.444 0 0 0-9.443-9.443c-4.536 0-8.32 3.2-9.23 7.465a9.43 9.43 0 0 0-5.862.027c.2-.133.4-.267.588-.414a9.45 9.45 0 0 0 3.318-9.897c-1.35-5.037-6.527-8.027-11.564-6.677-.563.15-1.175.378-1.809.652.044-.3.088-.601.113-.885.004-.039.003-.073.006-.111a9.4 9.4 0 0 0 6.117-2.738c.412-.412.829-.913 1.24-1.467.255.641.528 1.234.819 1.738 2.607 4.516 8.382 6.065 12.898 3.457 4.517-2.607 6.065-8.382 3.457-12.898a13 13 0 0 0-1.097-1.58c.686-.08 1.33-.19 1.892-.34 5.038-1.35 8.026-6.527 6.676-11.565s-6.527-8.027-11.564-6.677c-.563.15-1.175.377-1.809.652.044-.3.088-.601.113-.885q.05-.541.05-1.031c0-4.69-3.424-8.57-7.905-9.307.385-2.195.637-4.417.73-6.654a51 51 0 0 0-1.136-12.979c4.055-1.909 6.294-6.494 5.093-10.976-1.35-5.037-6.527-8.026-11.564-6.676a11.6 11.6 0 0 0-1.809.65c.101-.683.16-1.333.16-1.916a9.44 9.44 0 0 0-9.44-9.44c-4.537 0-8.323 3.198-9.233 7.462-4.149-1.345-8.812.335-11.08 4.264a9.444 9.444 0 0 0 3.455 12.898c.504.291 1.098.564 1.74.818a13 13 0 0 0-1.469 1.24c-3.687 3.688-3.687 9.669 0 13.356a9.42 9.42 0 0 0 7.582 2.72 9.4 9.4 0 0 0 5.772-2.72q.346-.346.695-.764c.183-.218.365-.46.547-.705.254.643.527 1.234.818 1.739 1.705 2.952 4.762 4.625 7.938 4.709-2.065 4.262-4.513 7.644-7.133 11.086a9.4 9.4 0 0 0-3.518 3.48 9.4 9.4 0 0 0-.953 2.348c-5.334 6.382-13.629 12.028-20.992 20.492-.086-.71-.172-1.42-.28-2.125-1.036-6.793-3.083-13.39-5.876-19.785a10 10 0 0 0 1.088-.53c4.516-2.607 6.062-8.382 3.455-12.898a13 13 0 0 0-1.096-1.58c.686-.08 1.328-.187 1.89-.338 5.038-1.35 8.028-6.529 6.678-11.566s-6.527-8.026-11.564-6.676c-.562.15-1.175.376-1.809.65.101-.683.16-1.332.16-1.914 0-5.215-4.226-9.443-9.44-9.443-4.537 0-8.323 3.199-9.233 7.463a9.4 9.4 0 0 0-4.461-.328c-.168.028-.334.072-.5.109-.147-.167-.287-.338-.434-.504-6.072-6.88-15.376-14.33-23.894-21.336a9.5 9.5 0 0 0 1.552-.71 9.4 9.4 0 0 0 3.72-3.952c1.12.311 2.286.417 3.437.307a9.4 9.4 0 0 0 5.771-2.723q.346-.346.695-.764c.183-.219.366-.46.547-.705.254.642.525 1.236.817 1.74 2.607 4.517 8.384 6.065 12.9 3.458s6.063-8.384 3.455-12.9a13 13 0 0 0-1.098-1.579c.687-.08 1.33-.189 1.893-.34 3.886-1.041 6.543-4.363 6.94-8.139.357.283.732.551 1.138.786a13 13 0 0 0 1.738.818c-.554.412-1.054.828-1.466 1.24-3.688 3.688-3.688 9.668 0 13.356a9.44 9.44 0 0 0 13.353 0c.412-.412.829-.915 1.24-1.47.255.643.528 1.235.819 1.74 2.607 4.516 8.382 6.064 12.898 3.456 4.517-2.607 6.065-8.382 3.457-12.898a13 13 0 0 0-1.097-1.58c.685-.08 1.33-.19 1.892-.34 5.038-1.35 8.026-6.527 6.676-11.565s-6.527-8.025-11.565-6.675c-.562.15-1.174.376-1.808.65.1-.683.162-1.334.162-1.916a9.4 9.4 0 0 0-2.28-6.14 9.4 9.4 0 0 0 .514-6.323c-1.35-5.037-6.527-8.027-11.564-6.678-.562.151-1.175.379-1.809.653.045-.301.086-.601.112-.885q.048-.541.048-1.031c0-5.215-4.226-9.444-9.44-9.444a9.45 9.45 0 0 0-9.02 6.635 9 9 0 0 0-.213.83 9.4 9.4 0 0 0-2.114-.416c-1.616-4.62-6.54-7.287-11.345-6q-.474.127-.985.315c-.267.098-.545.215-.824.336.1-.683.162-1.332.162-1.914a9.444 9.444 0 0 0-18.676-1.979c-4.148-1.345-8.812.333-11.08 4.262-.063.11-.111.223-.17.334-1.16-3.9-4.77-6.746-9.046-6.746-4.536 0-8.32 3.2-9.231 7.464-4.148-1.344-8.814.336-11.082 4.264a9.4 9.4 0 0 0-1.17 5.99 9.47 9.47 0 0 0-5.947-3.588 89 89 0 0 1-.115-4.937 9.4 9.4 0 0 0 3.816-1.215c4.516-2.607 6.063-8.382 3.455-12.898a13 13 0 0 0-1.096-1.58c.686-.08 1.329-.188 1.891-.338 5.037-1.35 8.028-6.53 6.678-11.567s-6.527-8.025-11.565-6.675c-.562.15-1.175.376-1.808.65.1-.683.16-1.332.16-1.914a9.444 9.444 0 0 0-9.444-9.443m-1.988 38.57c.254.642.527 1.236.819 1.74a9.4 9.4 0 0 0 4.462 3.95 88 88 0 0 0-.146 6.12c-.303.108-.615.236-.934.373.101-.683.16-1.333.16-1.916a9.44 9.44 0 0 0-5.732-8.681c.042-.04.087-.076.129-.117.412-.412.83-.914 1.242-1.47m17.803 19.394a9.4 9.4 0 0 0 2.787 2.45c.504.29 1.097.564 1.738.818a13 13 0 0 0-1.466 1.24 9.44 9.44 0 0 0 0 13.354 9.4 9.4 0 0 0 5.468 2.68 9.4 9.4 0 0 0-.896 2.945c-.329-.35-.624-.643-.963-1.012-2.438-2.649-5.173-5.804-8.41-9.775a38 38 0 0 1-2.078-3.797 9.44 9.44 0 0 0 3.82-8.903m65.453 6.377c.21.144.419.287.643.416a13.4 13.4 0 0 0 1.74.817c-.555.412-1.057.83-1.469 1.242-.352.352-.66.73-.945 1.121a9.4 9.4 0 0 0 .031-3.596m-18.271 4.701c.224.567.465 1.086.718 1.547-.036.139-.077.276-.107.416l-.006.026a9.4 9.4 0 0 0-1.97-.406c.04-.04.084-.074.124-.114q.345-.346.694-.763c.182-.219.365-.461.547-.706m-8.934 4.176c.026.003.052.01.078.012l-.035.035-.025.026q-.01-.037-.018-.073m132.17 29.121c.428.364.889.698 1.392.989.505.29 1.099.564 1.74.818-.554.412-1.056.828-1.468 1.24a10 10 0 0 0-.545.604 9.5 9.5 0 0 0-.846-1.96 13 13 0 0 0-1.097-1.58c.282-.032.56-.066.824-.11m16.26 14.934c.254.642.525 1.234.816 1.738a9.4 9.4 0 0 0 1.809 2.252c-.11.015-.22.021-.328.04-.122.02-.24.052-.36.077a9.4 9.4 0 0 0-2.25-3.705q.157-.195.313-.402m-5.112 16.268c.043.13.08.262.127.39q-.117-.183-.234-.367zm1.965 3.406a9.4 9.4 0 0 0 2.281 1.845c.505.292 1.099.565 1.74.819a13 13 0 0 0-1.468 1.24c-.076.076-.14.159-.213.236-.25-.457-.494-.918-.748-1.373q-.78-1.392-1.592-2.767m-176.39 10.068c-.017.367-.02.733.005 1.098.011.156.036.311.055.467a14 14 0 0 0-1.004-1.432c.325-.038.644-.08.944-.133m-65.32 2.002q.668 1.604 1.364 3.195c.25.57.51 1.134.766 1.702a9.449 9.449 0 0 0-9.982 6.586 9 9 0 0 0-.213.83 9.44 9.44 0 0 0-10.95 4.06 9.4 9.4 0 0 0-1.064-2.8 13.4 13.4 0 0 0-1.1-1.579c.688-.08 1.332-.189 1.895-.34a9.44 9.44 0 0 0 6.895-7.726 9.43 9.43 0 0 0 8.853-.315 9.4 9.4 0 0 0 3.535-3.613m66.675 3.34a9.4 9.4 0 0 0 3.35 3.277 13.4 13.4 0 0 0 1.74.817c-.555.412-1.057.83-1.469 1.242a9.44 9.44 0 0 0 0 13.353c.32.32.662.603 1.014.868a9.44 9.44 0 0 0-8.824 6.625 9 9 0 0 0-.213.83 9.4 9.4 0 0 0-2.162-.42 9.5 9.5 0 0 0-.297-1.783c-1.35-5.038-6.527-8.026-11.565-6.676-.562.15-1.174.376-1.808.65.1-.683.162-1.334.162-1.916 0-3.821-2.276-7.104-5.541-8.59.075-.005.15-.004.226-.011a9.4 9.4 0 0 0 5.772-2.723q.346-.346.695-.764c.183-.218.366-.46.547-.705.254.642.525 1.236.816 1.74 2.608 4.517 8.384 6.063 12.9 3.455a9.44 9.44 0 0 0 4.657-9.269M31.59 218.076a9.444 9.444 0 0 0-9.451 9.436c-.005 5.215 4.218 9.444 9.433 9.449 2.657.003 6.578-1.094 9.79-2.857a7.82 7.82 0 0 1-3.592-6.579 7.82 7.82 0 0 1 3.595-6.576c-3.207-1.766-7.12-2.87-9.775-2.873m411.533 3.627c.334.259.68.506 1.057.723.504.291 1.098.562 1.74.816-.26.193-.512.386-.742.58l-2.121-1.388q.046-.364.066-.73m-19.66 6.61q.176.196.353.392a199 199 0 0 0 5.506 5.75 9.4 9.4 0 0 0-2.652.315c-.562.15-1.175.378-1.809.652.045-.301.086-.601.112-.885q.048-.541.048-1.031c0-1.92-.574-3.703-1.558-5.193m123.5 9.958a9.4 9.4 0 0 0 2.025 1.58c.505.292 1.096.565 1.739.819a13.4 13.4 0 0 0-1.47 1.24 9.442 9.442 0 0 0 7.585 16.076 9.4 9.4 0 0 0 5.771-2.722q.346-.346.694-.764c.182-.218.365-.46.547-.703.254.641.527 1.234.818 1.738 2.607 4.516 8.382 6.065 12.898 3.457a9.5 9.5 0 0 0 2.211-1.762 9.4 9.4 0 0 0 3.047 2.825c.504.29 1.097.564 1.738.818a13 13 0 0 0-1.466 1.24 9.44 9.44 0 0 0 0 13.354c2.164 2.164 5.115 3.047 7.931 2.672a52 52 0 0 0-3.082 5.584 9.5 9.5 0 0 0-1.93-.198c-4.237 0-7.822 2.791-9.017 6.635a9 9 0 0 0-.213.83 9.4 9.4 0 0 0-2.351-.435c-2.29-2.684-5.99-3.978-9.625-3.004a11.6 11.6 0 0 0-1.81.652c.102-.683.161-1.334.161-1.916a9.444 9.444 0 0 0-17.764-4.467c-.188-.566-.382-1.13-.556-1.699a67 67 0 0 1-2.393-10.957c-1.37-10.52.166-21.517 4.512-30.893m-108.436 4.94a254 254 0 0 0 7.198 6.228 9.4 9.4 0 0 0-2.116 4.213c-4.148-1.344-8.812.336-11.08 4.264-.205.356-.377.72-.531 1.09a9.4 9.4 0 0 0-1.234-4.076 13 13 0 0 0-1.098-1.578c.686-.08 1.33-.19 1.893-.34 4.448-1.192 7.293-5.371 6.968-9.801m143.825.79c-.626.413-1.208.9-1.729 1.464-.054-.081-.097-.158-.154-.24-.164-.233-.35-.473-.54-.711.686-.08 1.331-.19 1.893-.34.182-.049.354-.114.53-.172m-476.034 3.003c-.929-.017-1.863.015-2.775.103a7.82 7.82 0 0 1 .705 7.461 7.82 7.82 0 0 1-5.898 4.625c2.25 2.889 5.41 5.445 7.85 6.495a9.443 9.443 0 0 0 7.464-17.346c-1.83-.788-4.558-1.287-7.346-1.338m166.678 2.992c-5.215-.004-9.446 4.219-9.451 9.434a9.44 9.44 0 0 0 9.434 9.45c2.657.003 6.577-1.095 9.789-2.859a7.82 7.82 0 0 1-3.592-6.576 7.82 7.82 0 0 1 3.595-6.578c-3.207-1.767-7.12-2.868-9.775-2.87m140.594 12.637q.111.278.226.54c.033.076.063.159.096.231-.022-.018-.042-.04-.064-.058-.165-.136-.339-.26-.512-.385.085-.108.17-.214.254-.328m-197.652 15.691a9.42 9.42 0 0 0-6.598 2.951c-1.826 1.93-3.72 5.533-4.643 9.079a7.82 7.82 0 0 1 7.248 1.904 7.82 7.82 0 0 1 2.313 7.13c3.486-1.118 6.976-3.206 8.8-5.134 3.585-3.788 3.42-9.765-.369-13.35a9.41 9.41 0 0 0-6.751-2.58m131.789.598c-.93-.017-1.866.015-2.778.103a7.82 7.82 0 0 1 .705 7.461 7.82 7.82 0 0 1-5.898 4.625c2.25 2.889 5.41 5.447 7.85 6.496 4.79 2.062 10.346-.15 12.408-4.941 2.06-4.79-.153-10.345-4.944-12.406-1.83-.788-4.556-1.287-7.343-1.338m251.593 4.262a9.4 9.4 0 0 0 4.215 5.156 13.4 13.4 0 0 0 1.74.816c-.554.412-1.056.83-1.468 1.242a9.4 9.4 0 0 0-2.075 3.123c-.08.199-.144.402-.21.604-.222-.047-.443-.096-.668-.127a9.4 9.4 0 0 0-3.743.234c-.562.151-1.175.379-1.808.653.1-.684.16-1.334.16-1.916 0-.595-.061-1.175-.166-1.739a43 43 0 0 1 4.023-8.046m-547.412 1.224c-3.035 2.048-5.802 5.027-7.015 7.389-2.383 4.639-.553 10.332 4.086 12.715 4.638 2.383 10.33.553 12.712-4.086 1.214-2.364 2.025-6.353 1.92-10.016a7.82 7.82 0 0 1-7.49.197 7.82 7.82 0 0 1-4.213-6.199m451.399 30.63c-.37.296-.72.593-1.014.888a9.4 9.4 0 0 0-1.686 2.285c-.101.193-.186.392-.273.59a10 10 0 0 0-.375-.737 13 13 0 0 0-1.098-1.578c.686-.079 1.33-.189 1.893-.34a9.4 9.4 0 0 0 2.553-1.109m-209.993 1.288c-3.034 2.048-5.802 5.027-7.015 7.389-2.383 4.639-.553 10.332 4.086 12.715s10.33.553 12.713-4.086c1.214-2.364 2.024-6.351 1.92-10.014a7.82 7.82 0 0 1-7.49.195 7.82 7.82 0 0 1-4.214-6.199M84.768 338.803a9.5 9.5 0 0 0-1.905.162c-2.611.49-6.259 2.296-9.088 4.625a7.82 7.82 0 0 1 4.748 5.797 7.82 7.82 0 0 1-2.312 7.129c3.479 1.14 7.527 1.5 10.137 1.01 5.125-.963 8.501-5.9 7.539-11.026-.843-4.485-4.728-7.626-9.12-7.697m73.968.926c-2.762 2.402-5.144 5.695-6.06 8.187-1.8 4.895.71 10.324 5.605 12.123 4.895 1.8 10.32-.71 12.12-5.605.916-2.494 1.235-6.552.685-10.174a7.82 7.82 0 0 1-7.412 1.107 7.82 7.82 0 0 1-4.938-5.638m72.875 3.019a7.82 7.82 0 0 1-2.394 7.102 7.82 7.82 0 0 1-7.27 1.822c.879 3.554 2.722 7.177 4.522 9.129 3.535 3.834 9.512 4.074 13.345.539s4.075-9.508.54-13.342c-1.802-1.953-5.268-4.087-8.743-5.25m211.315 16.076a9.444 9.444 0 0 0-9.451 9.436c-.004 5.215 4.22 9.444 9.435 9.449 2.657.003 6.576-1.094 9.787-2.857a7.82 7.82 0 0 1-3.592-6.579 7.82 7.82 0 0 1 3.596-6.576c-3.207-1.766-7.12-2.87-9.775-2.873m-116.752 11.897a9.5 9.5 0 0 0-1.904.164c-2.612.49-6.26 2.294-9.088 4.623a7.82 7.82 0 0 1 4.748 5.797 7.82 7.82 0 0 1-2.313 7.13c3.48 1.142 7.53 1.498 10.139 1.008a9.442 9.442 0 0 0-1.582-18.722m-281.381.492a9.5 9.5 0 0 0-1.906.162c-2.612.49-6.26 2.297-9.088 4.625a7.82 7.82 0 0 1 4.75 5.797 7.82 7.82 0 0 1-2.315 7.129c3.48 1.141 7.53 1.5 10.139 1.01 5.125-.963 8.5-5.9 7.537-11.026-.842-4.485-4.726-7.626-9.117-7.697m341.074 15.94a9.42 9.42 0 0 0-6.597 2.95c-1.827 1.93-3.718 5.533-4.641 9.079a7.82 7.82 0 0 1 7.248 1.904 7.82 7.82 0 0 1 2.312 7.13c3.487-1.118 6.975-3.205 8.8-5.134a9.444 9.444 0 0 0-7.122-15.93m131.79.597c-.93-.017-1.866.017-2.778.105a7.82 7.82 0 0 1 .707 7.461 7.82 7.82 0 0 1-5.899 4.625c2.25 2.889 5.411 5.445 7.85 6.495A9.443 9.443 0 1 0 525 389.088c-1.83-.788-4.556-1.287-7.344-1.338m-268.669.75c-3.647.324-7.51 1.59-9.715 3.07-4.33 2.907-5.484 8.774-2.578 13.104s8.774 5.484 13.104 2.578c2.206-1.48 4.846-4.579 6.527-7.834a7.82 7.82 0 0 1-6.652-3.455 7.82 7.82 0 0 1-.686-7.463M64.805 401.807a7.82 7.82 0 0 1-6.108 4.343 7.82 7.82 0 0 1-6.955-2.795c-1.375 3.394-2.008 7.41-1.697 10.047.611 5.18 5.307 8.881 10.486 8.27s8.88-5.305 8.268-10.485c-.312-2.638-1.864-6.4-3.994-9.38m221.394 1.324a9.5 9.5 0 0 0-1.906.162c-2.611.49-6.26 2.297-9.088 4.625a7.82 7.82 0 0 1 4.75 5.797 7.82 7.82 0 0 1-2.314 7.13c3.479 1.142 7.529 1.499 10.138 1.009a9.44 9.44 0 0 0 7.537-11.024c-.842-4.485-4.725-7.628-9.117-7.7",
    style: {
      color: "#000",
      fontStyle: "normal",
      fontVariant: "normal",
      fontWeight: 400,
      fontStretch: "normal",
      fontSize: "medium",
      lineHeight: "normal",
      fontFamily: "sans-serif",
      fontVariantLigatures: "normal",
      fontVariantPosition: "normal",
      fontVariantCaps: "normal",
      fontVariantNumeric: "normal",
      fontVariantAlternates: "normal",
      fontFeatureSettings: "normal",
      textIndent: 0,
      textAlign: "start",
      textDecoration: "none",
      textDecorationLine: "none",
      textDecorationStyle: "solid",
      textDecorationColor: "#000",
      letterSpacing: "normal",
      wordSpacing: "normal",
      textTransform: "none",
      writingMode: "lr-tb",
      direction: "ltr",
      textOrientation: "mixed",
      dominantBaseline: "auto",
      baselineShift: "baseline",
      textAnchor: "start",
      whiteSpace: "normal",
      shapePadding: 0,
      clipRule: "nonzero",
      display: "inline",
      overflow: "visible",
      visibility: "visible",
      opacity: 1,
      isolation: "auto",
      mixBlendMode: "normal",
      colorInterpolation: "sRGB",
      colorInterpolationFilters: "linearRGB",
      solidColor: "#000",
      solidOpacity: 1,
      vectorEffect: "none",
      fill: "#fff",
      fillOpacity: 0.70499998,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 9.69448853,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1,
      colorRendering: "auto",
      imageRendering: "auto",
      shapeRendering: "auto",
      textRendering: "auto"
    },
    transform: "scale(.26458)"
  }));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSpringBreak);
export default __webpack_public_path__ + "static/media/spring-break.97e832b5f1c00d54700bdbc8252d42c8.svg";
export { ForwardRef as ReactComponent };